import React, {useCallback, useEffect, useRef, useState} from 'react';
import {Tab, Table, Tabs} from "react-bootstrap";
import {BsSquareFill} from "react-icons/bs";
import * as XLSX from "xlsx";
import axios from '../../services/axiosInstance';
import excel from "exceljs";
import MsgSelectModal from "../../components/web/modal/MsgSelectModal";
import maCateImg from "../../assets/img/m-a-cate.png";
import excelLogo from "../../assets/img/HeaderLogo.png";

function AdminCurrencyRatePg() {

    /** region DataTable */

    const [emsData, setEmsData] = useState([]);
    const [emsPreData, setEmsPreData] = useState([]);
    const [fedexData, setFedexData] = useState([]);
    const [fedexEcoData, setFedexEcoData] = useState([]);
    const [shipData, setShipData] = useState([]);
    const [domeData, setDomeData] = useState([]);
    const [dhlData, setDhlData] = useState([]);
    const [upsData, setUpsData] = useState([]);
    const [upsEcoData, setUpsEcoData] = useState([]);
    const [kpackData, setKpackData] = useState([]);
    const [airSData, setAirSData] = useState([]);

    /** endregion */

    /** region Function */

    const LCAT = localStorage.getItem('adminToken');
    const [excelData, setExcelData] = useState(null);
    const [excelDataep, setExcelDataep] = useState(null);
    const [excelDataf, setExcelDataf] = useState(null);
    const [excelDatafe, setExcelDatafe] = useState(null);
    const [excelDatas, setExcelDatas] = useState(null);
    const [excelDataDhl, setExcelDataDhl] = useState(null);
    const [excelDataUps, setExcelDataUps] = useState(null);
    const [excelDataUpse, setExcelDataUpse] = useState(null);
    const [excelDataKp, setExcelDataKp] = useState(null);
    const [excelDataAs, setExcelDataAs] = useState(null);
    const [selectedSheet, setSelectedSheet] = useState(null);
    const [selectedSheetp, setSelectedSheetp] = useState(null);
    const [selectedSheetf, setSelectedSheetf] = useState(null);
    const [selectedSheetfe, setSelectedSheetfe] = useState(null);
    const [selectedSheets, setSelectedSheets] = useState(null);
    const [selectedSheetDhl, setSelectedSheetDhl] = useState(null);
    const [selectedSheetUps, setSelectedSheetUps] = useState(null);
    const [selectedSheetUpse, setSelectedSheetUpse] = useState(null);
    const [selectedSheetKp, setSelectedSheetKp] = useState(null);
    const [selectedSheetAs, setSelectedSheetAs] = useState(null);

    /// region Alert

    const [alertShow, setAlertShow] = useState(false); /*FedEx*/
    const [alertShow2, setAlertShow2] = useState(false); /*FedEx-E*/
    const [alertShow3, setAlertShow3] = useState(false); /*EMS*/
    const [alertShow4, setAlertShow4] = useState(false); /*EMSP*/
    const [alertShow5, setAlertShow5] = useState(false); /*UPS*/
    const [alertShow6, setAlertShow6] = useState(false); /*UPSE*/
    const [alertShow7, setAlertShow7] = useState(false); /*KP*/
    const [alertShow8, setAlertShow8] = useState(false); /*AS*/
    const [alertShow9, setAlertShow9] = useState(false); /*SHIP*/
    const msgConfirmData1 = "기존 데이터에서 덮어 씌우시겠습니까?";
    const msgConfirmData2 = "저장 완료시 기존 요금정보는 복구 불가능합니다.";
    const alert = (() => {
        setAlertShow(true)
    })
    const alert2 = (() => {
        setAlertShow2(true)
    })
    const alert3 = (() => {
        setAlertShow3(true)
    })
    const alert4 = (() => {
        setAlertShow4(true)
    })
    const alert5 = (() => {
        setAlertShow5(true)
    })
    const alert6 = (() => {
        setAlertShow6(true)
    })
    const alert7 = (() => {
        setAlertShow7(true)
    })
    const alert8 = (() => {
        setAlertShow8(true)
    })
    const alert9 = (() => {
        setAlertShow9(true)
    })

    const modalCancel = useCallback(() => {
        setAlertShow(false);
    })
    const modalCancel2 = useCallback(() => {
        setAlertShow2(false);
    })
    const modalCancel3 = useCallback(() => {
        setAlertShow3(false);
    })
    const modalCancel4 = useCallback(() => {
        setAlertShow4(false);
    })
    const modalCancel5 = useCallback(() => {
        setAlertShow5(false);
    })
    const modalCancel6 = useCallback(() => {
        setAlertShow6(false);
    })
    const modalCancel7 = useCallback(() => {
        setAlertShow7(false);
    })
    const modalCancel8 = useCallback(() => {
        setAlertShow8(false);
    })
    const modalCancel9 = useCallback(() => {
        setAlertShow9(false);
    })

    // endregion Alert

    const excelUploadEMS = (event) => {
        event.preventDefault();
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.onload = (event) => {
            const data = new Uint8Array(event.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const sheetName = workbook.SheetNames;
            setSelectedSheet(sheetName[0]);
            setExcelData(workbook);
        };
        reader.readAsArrayBuffer(file);
    };

    const excelUploadEMSP = (event) => {
        event.preventDefault();
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.onload = (event) => {
            const data = new Uint8Array(event.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const sheetNamep = workbook.SheetNames;
            setSelectedSheetp(sheetNamep[0]);
            setExcelDataep(workbook);
        };
        reader.readAsArrayBuffer(file);
    };

    const excelUploadFEDEX = (event) => {
        event.preventDefault();
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.onload = (event) => {
            const data = new Uint8Array(event.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const sheetNamesf = workbook.SheetNames;
            setSelectedSheetf(sheetNamesf[0]);
            setExcelDataf(workbook);
        };
        reader.readAsArrayBuffer(file);
    };

    const excelUploadFEDEXE = (event) => {
        event.preventDefault();
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.onload = (event) => {
            const data = new Uint8Array(event.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const sheetNamesfe = workbook.SheetNames;
            setSelectedSheetfe(sheetNamesfe[0]);
            setExcelDatafe(workbook);
        };
        reader.readAsArrayBuffer(file);
    };

    const excelUploadSHIP = (event) => {
        event.preventDefault();
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.onload = (event) => {
            const data = new Uint8Array(event.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const sheetNames = workbook.SheetNames;
            setSelectedSheets(sheetNames[0]);
            setExcelDatas(workbook);
        };
        reader.readAsArrayBuffer(file);
    };

    const excelUploadDHL = (event) => {
        event.preventDefault();
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.onload = (event) => {
            const data = new Uint8Array(event.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const sheetNamesDhl = workbook.SheetNames;
            setSelectedSheetDhl(sheetNamesDhl[0]);
            setExcelDataDhl(workbook);
        };
        reader.readAsArrayBuffer(file);
    };

    const excelUploadUPS = (event) => {
        event.preventDefault();
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.onload = (event) => {
            const data = new Uint8Array(event.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const sheetNamesUps = workbook.SheetNames;
            setSelectedSheetUps(sheetNamesUps[0]);
            setExcelDataUps(workbook);
        };
        reader.readAsArrayBuffer(file);
    };

    const excelUploadUPSE = (event) => {
        event.preventDefault();
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.onload = (event) => {
            const data = new Uint8Array(event.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const sheetNamesUpse = workbook.SheetNames;
            setSelectedSheetUpse(sheetNamesUpse[0]);
            setExcelDataUpse(workbook);
        };
        reader.readAsArrayBuffer(file);
    };

    const excelUploadKP = (event) => {
        event.preventDefault();
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.onload = (event) => {
            const data = new Uint8Array(event.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const sheetNamesKp = workbook.SheetNames;
            setSelectedSheetKp(sheetNamesKp[0]);
            setExcelDataKp(workbook);
        };
        reader.readAsArrayBuffer(file);
    };

    const excelUploadAS = (event) => {
        event.preventDefault();
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.onload = (event) => {
            const data = new Uint8Array(event.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const sheetNamesAs = workbook.SheetNames;
            setSelectedSheetAs(sheetNamesAs[0]);
            setExcelDataAs(workbook);
        };
        reader.readAsArrayBuffer(file);
    };

    const sheetSelectFEDEX = (event) => {
        const sheetNamef = event.target.value;
        setSelectedSheetf(sheetNamef);
    };

    const sheetSelectFEDEXE = (event) => {
        const sheetNamefe = event.target.value;
        setSelectedSheetfe(sheetNamefe);
    };

    const sheetSelectEMS = (event) => {
        const sheetName = event.target.value;
        setSelectedSheet(sheetName);
    };

    const sheetSelectEMSP = (event) => {
        const sheetNameep = event.target.value;
        setSelectedSheetp(sheetNameep);
    };

    const sheetSelectSHIP = (event) => {
        const sheetNames = event.target.value;
        setSelectedSheets(sheetNames);
    };

    const sheetSelectDHL = (event) => {
        const sheetNameDhl = event.target.value;
        setSelectedSheetDhl(sheetNameDhl);
    };

    const sheetSelectUPS = (event) => {
        const sheetNameUps = event.target.value;
        setSelectedSheetUps(sheetNameUps);
    };

    const sheetSelectUPSE = (event) => {
        const sheetNameUpse = event.target.value;
        setSelectedSheetUpse(sheetNameUpse);
    };

    const sheetSelectKP = (event) => {
        const sheetNameKp = event.target.value;
        setSelectedSheetKp(sheetNameKp);
    };

    const sheetSelectAS = (event) => {
        const sheetNameAs = event.target.value;
        setSelectedSheetAs(sheetNameAs);
    };

    const getSheetDataf = () => {
        if (!selectedSheetf || !excelDataf) {
            return [];
        }
        const worksheet = excelDataf.Sheets[selectedSheetf];
        const allData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

        return allData.slice(5).map(row => row.slice(1));
    };

    const getSheetDatafe = () => {
        if (!selectedSheetfe || !excelDatafe) {
            return [];
        }
        const worksheet = excelDatafe.Sheets[selectedSheetfe];
        const allData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

        return allData.slice(5).map(row => row.slice(1));
    };

    const getSheetData = () => {
        if (!selectedSheet || !excelData) {
            return [];
        }
        const worksheet = excelData.Sheets[selectedSheet];
        const allData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

        return allData.slice(5).map(row => row.slice(1));
    };

    const getSheetDataep = () => {
        if (!selectedSheetp || !excelDataep) {
            return [];
        }
        const worksheet = excelDataep.Sheets[selectedSheetp];
        const allData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

        return allData.slice(5).map(row => row.slice(1));
    };

    const getSheetDatas = () => {
        if (!selectedSheets || !excelDatas) {
            return [];
        }

        const worksheet = excelDatas.Sheets[selectedSheets];

        // 전체 데이터 읽어오기
        const allData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

        // 첫 번째 열과 앞의 4행 제외하기
        return allData.slice(5).map(row => row.slice(1));
    };

    const getSheetDataDhl = () => {
        if (!selectedSheetDhl || !excelDataDhl) {
            return [];
        }
        const worksheet = excelDataDhl.Sheets[selectedSheetDhl];
        return XLSX.utils.sheet_to_json(worksheet, { header: 1 });
    };

    const getSheetDataUps = () => {
        if (!selectedSheetUps || !excelDataUps) {
            return [];
        }
        const worksheet = excelDataUps.Sheets[selectedSheetUps];
        const allData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

        return allData.slice(5).map(row => row.slice(1));
    };

    const getSheetDataUpse = () => {
        if (!selectedSheetUpse || !excelDataUpse) {
            return [];
        }
        const worksheet = excelDataUpse.Sheets[selectedSheetUpse];
        const allData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

        return allData.slice(5).map(row => row.slice(1));
    };

    const getSheetDataKp = () => {
        if (!selectedSheetKp || !excelDataKp) {
            return [];
        }
        const worksheet = excelDataKp.Sheets[selectedSheetKp];
        const allData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

        return allData.slice(5).map(row => row.slice(1));
    };

    const getSheetDataAs = () => {
        if (!selectedSheetAs || !excelDataAs) {
            return [];
        }
        const worksheet = excelDataAs.Sheets[selectedSheetAs];
        const allData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

        return allData.slice(5).map(row => row.slice(1));
    };

    const sheetData = getSheetData();
    const sheetDatap = getSheetDataep();
    const sheetDataf = getSheetDataf();
    const sheetDatafe = getSheetDatafe();
    const sheetDatas = getSheetDatas();
    const sheetDataDhl = getSheetDataDhl();
    const sheetDataUps = getSheetDataUps();
    const sheetDataUpse = getSheetDataUpse();
    const sheetDataKp = getSheetDataKp();
    const sheetDataAs = getSheetDataAs();

    const fileSelect = useRef(null);
    const fileSelectep = useRef(null);
    const fileSelectf = useRef(null);
    const fileSelectfe = useRef(null);
    const fileSelects = useRef(null);
    const fileSelectDhl = useRef(null);
    const fileSelectUps = useRef(null);
    const fileSelectUpse = useRef(null);
    const fileSelectKp = useRef(null);
    const fileSelectAs = useRef(null);

    const [editMode, setEditMode] = useState(null);
    const [editedWeights, setEditedWeights] = useState({});

    const handleEditClick = (cData) => {
        setEditMode(cData.seqNum);
        setEditedWeights({
            w3000: cData.w3000,
            w5000: cData.w5000,
            w10000: cData.w10000,
            w20000: cData.w20000,
            w25000: cData.w25000
        });
    };

    const handleFeeChange = (e, weightType) => {
        setEditedWeights(prevWeights => ({
            ...prevWeights,
            [weightType]: e.target.value
        }));
    };

    /** endregion */

    /** region Event */

    useEffect(() => {
        selectFEDEX();
        selectFEDEXE();
        selectUPS();
        selectUPSE();
        selectEMS();
        selectEMSP();
        selectSHIP();
        selectKP();
        selectAS();
        selectDOME();
    }, [])

    // region dataSelect

    const selectFEDEX = () => {
        axios({
            method: 'get',
            url: '/shipinfo/fedexexrdata',
            headers: {
                Authorization: LCAT
            },
        })
            .then((response) => {
                setFedexData(response.data)
            })
            .catch(() => {});
    };

    const selectFEDEXE = () => {
        axios({
            method: 'get',
            url: '/shipinfo/fedexEcoexrdata',
            headers: {
                Authorization: LCAT
            },
        })
            .then((response) => {
                setFedexEcoData(response.data)
            })
            .catch(() => {});
    };

    const selectUPS= () => {
        axios({
            method: 'get',
            url: '/shipinfo/upsexrdata',
            headers: {
                Authorization: LCAT
            },
        })
            .then((response) => {
                setUpsData(response.data)
            })
            .catch(() => {});
    };

    const selectUPSE= () => {
        axios({
            method: 'get',
            url: '/shipinfo/upsEcoexrdata',
            headers: {
                Authorization: LCAT
            },
        })
            .then((response) => {
                setUpsEcoData(response.data)
            })
            .catch(() => {});
    };

    const selectEMS = () => {
        axios({
            method: 'get',
            url: '/shipinfo/emsexrdata',
            headers: {
                Authorization: LCAT
            },
        })
            .then((response) => {
                setEmsData(response.data)
            })
            .catch(() => {});
    };

    const selectEMSP = () => {
        axios({
            method: 'get',
            url: '/shipinfo/emsPreexrdata',
            headers: {
                Authorization: LCAT
            },
        })
            .then((response) => {
                setEmsPreData(response.data)
            })
            .catch(() => {});
    };

    const selectSHIP= () => {
        axios({
            method: 'get',
            url: '/shipinfo/shipexrdata',
            headers: {
                Authorization: LCAT
            },
        })
            .then((response) => {
                setShipData(response.data)
            })
            .catch(() => {});
    };

    const selectKP= () => {
        axios({
            method: 'get',
            url: '/shipinfo/kpexrdata',
            headers: {
                Authorization: LCAT
            },
        })
            .then((response) => {
                setKpackData(response.data)
            })
            .catch(() => {});
    };

    const selectAS= () => {
        axios({
            method: 'get',
            url: '/shipinfo/airsexrdata',
            headers: {
                Authorization: LCAT
            },
        })
            .then((response) => {
                setAirSData(response.data)
            })
            .catch(() => {});
    };

    const selectDOME= () => {
        axios({
            method: 'get',
            url: '/shipinfo/domeexrdata',
            headers: {
                Authorization: LCAT
            },
        })
            .then((response) => {
                setDomeData(response.data)
            })
            .catch(() => {});
    };

    // endregion dataSelect

    // region excelSave

    /**
     * [요금표 업로드 안전장치] 서버 전송 전 누락구간 검증
     * ──────────────────────────────────────────────────────────────────────────
     *  요금표 컬럼(unitXXXXX)은 DB에서 NOT NULL 이라 값이 하나라도 비면 저장이 500 으로 실패한다.
     *  실패 원인을 서버 로그로만 알 수 있었기 때문에, 전송 전에 미리 잡아 정확히 안내한다.
     *
     *  @param carrier      배송사명 (안내문구용)
     *  @param excelDataList 서버로 보낼 목록
     *  @param groupKey     그룹 식별 필드명 (appGroup / appUpsCode / appEmsPreCode ...)
     *  @return true = 정상 / false = 누락 있음(전송 중단)
     */
    const validateRateRows = (carrier, excelDataList, groupKey) => {
        if (!Array.isArray(excelDataList) || excelDataList.length === 0) {
            window.alert(`[${carrier}] 업로드할 요금 데이터가 없습니다.\n시트 선택과 엑셀 내용을 확인해주세요.`);
            return false;
        }

        const problems = [];
        excelDataList.forEach((row) => {
            const group = row[groupKey];
            if (group === undefined || group === null || String(group).trim() === '') {
                problems.push('구분값(' + groupKey + ')이 비어있는 열이 있습니다');
                return;
            }
            const emptyBands = Object.keys(row)
                .filter((k) => /^w\d+$/.test(k))
                .filter((k) => {
                    const v = row[k];
                    if (v === undefined || v === null) return true;
                    return String(v).trim() === '';
                })
                .map((k) => k.replace('w', '') + 'g');

            if (emptyBands.length > 0) {
                const preview = emptyBands.slice(0, 6).join(', ');
                problems.push(`${group} : ${emptyBands.length}개 구간 누락 (${preview}${emptyBands.length > 6 ? ' 외' : ''})`);
            }
        });

        if (problems.length > 0) {
            console.error(`[${carrier}] 요금표 누락구간`, problems);
            window.alert(
                `[${carrier}] 요금표에 값이 비어있는 구간이 있어 저장할 수 없습니다.\n\n` +
                problems.slice(0, 10).join('\n') +
                (problems.length > 10 ? `\n... 외 ${problems.length - 10}건` : '') +
                `\n\n[EXCEL 양식] 을 다시 받아 값만 채운 뒤 업로드해주세요.`
            );
            return false;
        }
        return true;
    };

    const transposeData = (data) => {
        if (data.length === 0) return [];

        const headers = data[0];
        return headers.slice(1).map((_, colIndex) => {
            return data.map(row => row[colIndex + 1]);
        });
    };

    const getCountryKpCode = (countryName) => {
        const countryCodes = {
            'Australia': 'AU',
            'Brazil': 'BR',
            'Canada': 'CA',
            'China': 'CN',
            'France': 'FR',
            'Germany': 'DE',
            'Hong Kong': 'HK',
            'Indonesia': 'ID',
            'Japan': 'JP',
            'Malaysia': 'MY',
            'New Zealand': 'NZ',
            'Philippines': 'PH',
            'Singapore': 'SG',
            'Spain': 'ES',
            'Taiwan': 'TW',
            'Thailand': 'TH',
            'United Kingdom': 'GB',
            'United States': 'US',
            'Vietnam': 'VN',
        };

        return countryCodes[countryName] || 'ZZ';
    };

    const saveExcelFileFEDEX = () => {
        const sheetDataf = getSheetDataf();
        const transposedData = transposeData(sheetDataf);
        const excelDataList = transposedData.map(rowData => {
            return {
                appGroup: rowData[0],
                w500: rowData[1], w1000: rowData[2], w1500: rowData[3], w2000: rowData[4], w2500: rowData[5],
                w3000: rowData[6], w3500: rowData[7], w4000: rowData[8], w4500: rowData[9], w5000: rowData[10],
                w5500: rowData[11], w6000: rowData[12], w6500: rowData[13], w7000: rowData[14], w7500: rowData[15],
                w8000: rowData[16], w8500: rowData[17], w9000: rowData[18], w9500: rowData[19], w10000: rowData[20],
                w10500: rowData[21], w11000: rowData[22], w11500: rowData[23], w12000: rowData[24], w12500: rowData[25],
                w13000: rowData[26], w13500: rowData[27], w14000: rowData[28], w14500: rowData[29], w15000: rowData[30],
                w15500: rowData[31], w16000: rowData[32], w16500: rowData[33], w17000: rowData[34], w17500: rowData[35],
                w18000: rowData[36], w18500: rowData[37], w19000: rowData[38], w19500: rowData[39], w20000: rowData[40],
                w20500: rowData[41], w21000: rowData[42], w22000: rowData[43], w23000: rowData[44], w24000: rowData[45],
                w25000: rowData[46], w26000: rowData[47], w27000: rowData[48], w28000: rowData[49], w29000: rowData[50], w30000: rowData[51]
            };
        });
        // [요금표 업로드 안전장치] 누락구간이 있으면 전송하지 않는다
        if (!validateRateRows('FedEx', excelDataList, 'appGroup')) return;

        axios.post('/shipinfo/foamdatasavefedex', excelDataList, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': LCAT
            },
        })
            .then(() => {
                setAlertShow(false);
                setSelectedSheetf([]);
                selectFEDEX()
            })
            .catch((error) => {console.error('Error:', error);});
    };

    const saveExcelFileFEDEXE = () => {
        const sheetDatafe = getSheetDatafe();
        const transposedData = transposeData(sheetDatafe);
        const excelDataList = transposedData.map(rowData => {
            return {
                appGroup: rowData[0],
                w500: rowData[1], w1000: rowData[2], w1500: rowData[3], w2000: rowData[4], w2500: rowData[5],
                w3000: rowData[6], w3500: rowData[7], w4000: rowData[8], w4500: rowData[9], w5000: rowData[10],
                w5500: rowData[11], w6000: rowData[12], w6500: rowData[13], w7000: rowData[14], w7500: rowData[15],
                w8000: rowData[16], w8500: rowData[17], w9000: rowData[18], w9500: rowData[19], w10000: rowData[20],
                w10500: rowData[21], w11000: rowData[22], w11500: rowData[23], w12000: rowData[24], w12500: rowData[25],
                w13000: rowData[26], w13500: rowData[27], w14000: rowData[28], w14500: rowData[29], w15000: rowData[30],
                w15500: rowData[31], w16000: rowData[32], w16500: rowData[33], w17000: rowData[34], w17500: rowData[35],
                w18000: rowData[36], w18500: rowData[37], w19000: rowData[38], w19500: rowData[39], w20000: rowData[40],
                w20500: rowData[41], w21000: rowData[42], w22000: rowData[43], w23000: rowData[44], w24000: rowData[45],
                w25000: rowData[46], w26000: rowData[47], w27000: rowData[48], w28000: rowData[49], w29000: rowData[50], w30000: rowData[51]
            };
        });
        // [요금표 업로드 안전장치] 누락구간이 있으면 전송하지 않는다
        if (!validateRateRows('FedEx-E', excelDataList, 'appGroup')) return;

        axios.post('/shipinfo/foamdatasavefedexEco', excelDataList, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': LCAT
            },
        })
            .then(() => {
                setAlertShow2(false);
                setSelectedSheetfe([]);
                selectFEDEXE()
            })
            .catch((error) => {console.error('Error:', error);});
    };

    const saveExcelFileUPS = () => {
        const sheetDataUps = getSheetDataUps();
        const transposedData = transposeData(sheetDataUps);
        const excelDataList = transposedData.map(rowData => {
            return {
                appUpsCode: rowData[0],
                w500: rowData[1], w1000: rowData[2], w1500: rowData[3], w2000: rowData[4], w2500: rowData[5], w3000: rowData[6], w3500: rowData[7], w4000: rowData[8],
                w4500: rowData[9], w5000: rowData[10], w5500: rowData[11], w6000: rowData[12], w6500: rowData[13], w7000: rowData[14], w7500: rowData[15], w8000: rowData[16],
                w8500: rowData[17], w9000: rowData[18], w9500: rowData[19], w10000: rowData[20], w10500: rowData[21], w11000: rowData[22], w11500: rowData[23], w12000: rowData[24],
                w12500: rowData[25], w13000: rowData[26], w13500: rowData[27], w14000: rowData[28], w14500: rowData[29], w15000: rowData[30], w15500: rowData[31], w16000: rowData[32],
                w16500: rowData[33], w17000: rowData[34], w17500: rowData[35], w18000: rowData[36], w18500: rowData[37], w19000: rowData[38], w19500: rowData[39], w20000: rowData[40],
                w20500: rowData[41], w21000: rowData[42], w22000: rowData[43], w23000: rowData[44], w24000: rowData[45], w25000: rowData[46], w26000: rowData[47], w27000: rowData[48],
                // DB(ExrInfoUPSVO / ExrInfoUPSECOVO)에 존재하는 마지막 구간은 w30000 이다.
                // w31000 이상은 EMS-Premium 전용 컬럼이라 UPS 로 보내도 저장되지 않으므로 매핑하지 않는다.
                w28000: rowData[49], w29000: rowData[50], w30000: rowData[51],
            };
        });
        // [요금표 업로드 안전장치] 누락구간이 있으면 전송하지 않는다
        if (!validateRateRows('UPS', excelDataList, 'appUpsCode')) return;

        axios.post('/shipinfo/foamdatasaveups', excelDataList, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': LCAT
            },
        })
            .then(() => {
                setAlertShow5(false);
                setSelectedSheetUps([]);
                selectUPS();
            })
            .catch((error) => {console.error('Error:', error);});
    };

    const saveExcelFileUPSE = () => {
        const sheetDataUpse = getSheetDataUpse();
        const transposedData = transposeData(sheetDataUpse);
        const excelDataList = transposedData.map(rowData => {
            return {
                appUpsEcoCode: rowData[0],
                w500: rowData[1], w1000: rowData[2], w1500: rowData[3], w2000: rowData[4], w2500: rowData[5], w3000: rowData[6], w3500: rowData[7], w4000: rowData[8],
                w4500: rowData[9], w5000: rowData[10], w5500: rowData[11], w6000: rowData[12], w6500: rowData[13], w7000: rowData[14], w7500: rowData[15], w8000: rowData[16],
                w8500: rowData[17], w9000: rowData[18], w9500: rowData[19], w10000: rowData[20], w10500: rowData[21], w11000: rowData[22], w11500: rowData[23], w12000: rowData[24],
                w12500: rowData[25], w13000: rowData[26], w13500: rowData[27], w14000: rowData[28], w14500: rowData[29], w15000: rowData[30], w15500: rowData[31], w16000: rowData[32],
                w16500: rowData[33], w17000: rowData[34], w17500: rowData[35], w18000: rowData[36], w18500: rowData[37], w19000: rowData[38], w19500: rowData[39], w20000: rowData[40],
                w20500: rowData[41], w21000: rowData[42], w22000: rowData[43], w23000: rowData[44], w24000: rowData[45], w25000: rowData[46], w26000: rowData[47], w27000: rowData[48],
                // DB(ExrInfoUPSVO / ExrInfoUPSECOVO)에 존재하는 마지막 구간은 w30000 이다.
                // w31000 이상은 EMS-Premium 전용 컬럼이라 UPS 로 보내도 저장되지 않으므로 매핑하지 않는다.
                w28000: rowData[49], w29000: rowData[50], w30000: rowData[51],
            };
        });
        // [요금표 업로드 안전장치] 누락구간이 있으면 전송하지 않는다
        if (!validateRateRows('UPS-E', excelDataList, 'appUpsEcoCode')) return;

        axios.post('/shipinfo/foamdatasaveupsEco', excelDataList, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': LCAT
            },
        })
            .then(() => {
                setAlertShow6(false);
                setSelectedSheetUpse([]);
                selectUPS();
            })
            .catch((error) => {console.error('Error:', error);});
    };

    const saveExcelFileEMS = () => {
        const tableData = sheetData.slice(1).map((row) => {
            const rowData = {};
            sheetData[0].forEach((header, index) => {
                rowData[header] = row[index];
            });
            return rowData;
        });

        const excelDataList = tableData.map((rowData) => {
            let countryCode;
            if (rowData['Country'] === 'Zone 1') {
                countryCode = 'LA';
            } else if (rowData['Country'] === 'Zone 2') {
                countryCode = 'BD';
            } else if (rowData['Country'] === 'Zone 3') {
                countryCode = 'IL';
            } else if (rowData['Country'] === 'Zone 4') {
                countryCode = 'MX';
            } else if (rowData['Country'] === 'New Zealand') {
                countryCode = 'NZ';
            } else if (rowData['Country'] === 'Taiwan') {
                countryCode = 'TW';
            } else if (rowData['Country'] === 'Germany') {
                countryCode = 'DE';
            } else if (rowData['Country'] === 'Russia') {
                countryCode = 'RU';
            } else if (rowData['Country'] === 'Malaysia') {
                countryCode = 'MY';
            } else if (rowData['Country'] === 'United States') {
                countryCode = 'US';
            } else if (rowData['Country'] === 'Vietnam') {
                countryCode = 'VN';
            } else if (rowData['Country'] === 'Brazil') {
                countryCode = 'BR';
            } else if (rowData['Country'] === 'Spain') {
                countryCode = 'ES';
            } else if (rowData['Country'] === 'Singapore') {
                countryCode = 'SG';
            } else if (rowData['Country'] === 'United Kingdom') {
                countryCode = 'GB';
            } else if (rowData['Country'] === 'Indonesia') {
                countryCode = 'ID';
            } else if (rowData['Country'] === 'Japan') {
                countryCode = 'JP';
            } else if (rowData['Country'] === 'China') {
                countryCode = 'CN';
            } else if (rowData['Country'] === 'Canada') {
                countryCode = 'CA';
            } else if (rowData['Country'] === 'Thailand') {
                countryCode = 'TH';
            } else if (rowData['Country'] === 'France') {
                countryCode = 'FR';
            } else if (rowData['Country'] === 'Philippines') {
                countryCode = 'PH';
            } else if (rowData['Country'] === 'Australia') {
                countryCode = 'AU';
            } else if (rowData['Country'] === 'Hong Kong') {
                countryCode = 'HK';
            } else {
                countryCode = 'ZZ';
            }
            return {
                countryCode,
                w500: rowData['500g'], w750: rowData['750g'], w1000: rowData['1000g'], w1250: rowData['1250g'], w1500: rowData['1500g'], w1750: rowData['1750g'], w2000: rowData['2000g'],
                w2500: rowData['2500g'], w3000: rowData['3000g'], w3500: rowData['3500g'], w4000: rowData['4000g'], w4500: rowData['4500g'], w5000: rowData['5000g'], w5500: rowData['5500g'],
                w6000: rowData['6000g'], w6500: rowData['6500g'], w7000: rowData['7000g'], w7500: rowData['7500g'], w8000: rowData['8000g'], w8500: rowData['8500g'], w9000: rowData['9000g'],
                w9500: rowData['9500g'], w10000: rowData['10000g'], w10500: rowData['10500g'], w11000: rowData['11000g'], w11500: rowData['11500g'], w12000: rowData['12000g'],
                w12500: rowData['12500g'], w13000: rowData['13000g'], w13500: rowData['13500g'], w14000: rowData['14000g'], w14500: rowData['14500g'], w15000: rowData['15000g'],
                w15500: rowData['15500g'], w16000: rowData['16000g'], w16500: rowData['16500g'], w17000: rowData['17000g'], w17500: rowData['17500g'], w18000: rowData['18000g'],
                w18500: rowData['18500g'], w19000: rowData['19000g'], w19500: rowData['19500g'], w20000: rowData['20000g'], w20500: rowData['20500g'], w21000: rowData['21000g'],
                w21500: rowData['21500g'], w22000: rowData['22000g'], w22500: rowData['22500g'], w23000: rowData['23000g'], w23500: rowData['23500g'], w24000: rowData['24000g'],
                w24500: rowData['24500g'], w25000: rowData['25000g'], w25500: rowData['25500g'], w26000: rowData['26000g'], w26500: rowData['26500g'], w27000: rowData['27000g'],
                w27500: rowData['27500g'], w28000: rowData['28000g'], w28500: rowData['28500g'], w29000: rowData['29000g'], w29500: rowData['29500g'], w30000: rowData['30000g']
            };
        });

        axios.post('/shipinfo/foamdatasave', excelDataList, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': LCAT
            },
        })
            .then(() => {
                setAlertShow3(false);
                setSelectedSheet([]);
                selectEMS()
            })
            .catch((error) => {setAlertShow2(false); console.error('Error:', error);});
    };

    const saveExcelFileEMSP = () => {
        const sheetDataEmsp = getSheetDataep();
        const transposedData = transposeData(sheetDataEmsp);

        /**
         * 엑셀 셀값 -> 정수 변환
         *  엑셀에서 읽은 셀은 문자열("12,000")일 수도 숫자(12000)일 수도 있어
         *  문자열로 통일한 뒤 처리한다. (기존에는 숫자일 때 .replace 에서 TypeError 발생)
         */
        const parseBigInt = (value) => {
            if (value === null || value === undefined || value === '') return null;
            const text = String(value).replace(/,/g, '').trim();
            if (text === '') return null;
            const num = parseInt(text, 10);
            return Number.isNaN(num) ? null : num;
        };

        const excelDataList = transposedData.map(rowData => {
            return {
                appEmsPreCode: rowData[0],
                w500: parseBigInt(rowData[1]),
                w1000: parseBigInt(rowData[2]),
                w1500: parseBigInt(rowData[3]),
                w2000: parseBigInt(rowData[4]),
                w2500: parseBigInt(rowData[5]),
                w3000: parseBigInt(rowData[6]),
                w3500: parseBigInt(rowData[7]),
                w4000: parseBigInt(rowData[8]),
                w4500: parseBigInt(rowData[9]),
                w5000: parseBigInt(rowData[10]),
                w5500: parseBigInt(rowData[11]),
                w6000: parseBigInt(rowData[12]),
                w6500: parseBigInt(rowData[13]),
                w7000: parseBigInt(rowData[14]),
                w7500: parseBigInt(rowData[15]),
                w8000: parseBigInt(rowData[16]),
                w8500: parseBigInt(rowData[17]),
                w9000: parseBigInt(rowData[18]),
                w9500: parseBigInt(rowData[19]),
                w10000: parseBigInt(rowData[20]),
                w10500: parseBigInt(rowData[21]),
                w11000: parseBigInt(rowData[22]),
                w11500: parseBigInt(rowData[23]),
                w12000: parseBigInt(rowData[24]),
                w12500: parseBigInt(rowData[25]),
                w13000: parseBigInt(rowData[26]),
                w13500: parseBigInt(rowData[27]),
                w14000: parseBigInt(rowData[28]),
                w14500: parseBigInt(rowData[29]),
                w15000: parseBigInt(rowData[30]),
                w15500: parseBigInt(rowData[31]),
                w16000: parseBigInt(rowData[32]),
                w16500: parseBigInt(rowData[33]),
                w17000: parseBigInt(rowData[34]),
                w17500: parseBigInt(rowData[35]),
                w18000: parseBigInt(rowData[36]),
                w18500: parseBigInt(rowData[37]),
                w19000: parseBigInt(rowData[38]),
                w19500: parseBigInt(rowData[39]),
                w20000: parseBigInt(rowData[40]),
                w21000: parseBigInt(rowData[41]),
                w22000: parseBigInt(rowData[42]),
                w23000: parseBigInt(rowData[43]),
                w24000: parseBigInt(rowData[44]),
                w25000: parseBigInt(rowData[45]),
                w26000: parseBigInt(rowData[46]),
                w27000: parseBigInt(rowData[47]),
                w28000: parseBigInt(rowData[48]),
                w29000: parseBigInt(rowData[49]),
                w30000: parseBigInt(rowData[50]),
                w31000: parseBigInt(rowData[51]),
                w32000: parseBigInt(rowData[52]),
                w33000: parseBigInt(rowData[53]),
                w34000: parseBigInt(rowData[54]),
                w35000: parseBigInt(rowData[55]),
                w36000: parseBigInt(rowData[56]),
                w37000: parseBigInt(rowData[57]),
                w38000: parseBigInt(rowData[58]),
                w39000: parseBigInt(rowData[59]),
                w40000: parseBigInt(rowData[60]),
                w41000: parseBigInt(rowData[61]),
                w42000: parseBigInt(rowData[62]),
                w43000: parseBigInt(rowData[63]),
                w44000: parseBigInt(rowData[64]),
                w45000: parseBigInt(rowData[65]),
                w46000: parseBigInt(rowData[66]),
                w47000: parseBigInt(rowData[67]),
                w48000: parseBigInt(rowData[68]),
                w49000: parseBigInt(rowData[69]),
                w50000: parseBigInt(rowData[70]),
                w51000: parseBigInt(rowData[71]),
                w52000: parseBigInt(rowData[72]),
                w53000: parseBigInt(rowData[73]),
                w54000: parseBigInt(rowData[74]),
                w55000: parseBigInt(rowData[75]),
                w56000: parseBigInt(rowData[76]),
                w57000: parseBigInt(rowData[77]),
                w58000: parseBigInt(rowData[78]),
                w59000: parseBigInt(rowData[79]),
                w60000: parseBigInt(rowData[80]),
                w61000: parseBigInt(rowData[81]),
                w62000: parseBigInt(rowData[82]),
                w63000: parseBigInt(rowData[83]),
                w64000: parseBigInt(rowData[84]),
                w65000: parseBigInt(rowData[85]),
                w66000: parseBigInt(rowData[86]),
                w67000: parseBigInt(rowData[87]),
                w68000: parseBigInt(rowData[88]),
                w69000: parseBigInt(rowData[89]),
                w70000: parseBigInt(rowData[90]),
            };
        });

        // [요금표 업로드 안전장치] 누락구간이 있으면 전송하지 않는다
        if (!validateRateRows('EMS-Premium', excelDataList, 'appEmsPreCode')) return;

        axios.post('/shipinfo/foamdatasaveemsp', excelDataList, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': LCAT
            },
        })
            .then(() => {
                setAlertShow4(false);
                setSelectedSheetp([]);
                selectEMSP();
            })
            .catch((error) => {console.error('Error:', error);});
    };

    const saveExcelFileSHIP = () => {
        const tableData = sheetDatas.slice(1).map((row) => {
            const rowData = {};
            sheetDatas[0].forEach((header, index) => {
                rowData[header] = row[index];
            });
            return rowData;
        });

        const excelDataList = tableData.map((rowData) => {
            let appShipCode;
            if (rowData['Zone'] === 'Zone 1') {
                appShipCode = 'Z1';
            } else if (rowData['Zone'] === 'Zone 2') {
                appShipCode = 'Z2';
            } else if (rowData['Zone'] === 'Zone 3') {
                appShipCode = 'Z3';
            } else {
                appShipCode = 'Z4';
            }
            return {
                appShipCode,
                w1000: rowData['1000g'], w2000: rowData['2000g'], w4000: rowData['4000g'], w6000: rowData['6000g'], w8000: rowData['8000g'], w10000: rowData['10000g'],
                w12000: rowData['12000g'], w14000: rowData['14000g'], w16000: rowData['16000g'], w18000: rowData['18000g'], w20000: rowData['20000g']
            };
        });
        axios.post('/shipinfo/foamdatasaveship', excelDataList, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': LCAT
            },
        })
            .then(() => {
                setAlertShow9(false);
                setSelectedSheets([]);
                selectSHIP()
            })
            .catch((error) => {console.error('Error:', error);});
    };

    const saveExcelFileKP = () => {
        const sheetDataKp = getSheetDataKp();
        const transposedData = transposeData(sheetDataKp);

        const parseValue = (value) => {
            if (typeof value === 'string') {
                return parseInt(value.replace(/,/g, ''), 10) || 0;
            } else if (typeof value === 'number') {
                return value;
            }
            return 0;
        };

        const excelDataList = transposedData.map(rowData => ({
            countryCode: getCountryKpCode(rowData[0]),
            w100: parseValue(rowData[1]),
            w200: parseValue(rowData[2]),
            w300: parseValue(rowData[3]),
            w400: parseValue(rowData[4]),
            w500: parseValue(rowData[5]),
            w600: parseValue(rowData[6]),
            w700: parseValue(rowData[7]),
            w800: parseValue(rowData[8]),
            w900: parseValue(rowData[9]),
            w1000: parseValue(rowData[10]),
            w1100: parseValue(rowData[11]),
            w1200: parseValue(rowData[12]),
            w1300: parseValue(rowData[13]),
            w1400: parseValue(rowData[14]),
            w1500: parseValue(rowData[15]),
            w1600: parseValue(rowData[16]),
            w1700: parseValue(rowData[17]),
            w1800: parseValue(rowData[18]),
            w1900: parseValue(rowData[19]),
            w2000: parseValue(rowData[20])
        }));

        // const excelDataList = transposedData.map(rowData => {
        //     return {
        //         countryCode: getCountryKpCode(rowData[0]),
        //         w100: parseInt(rowData[1].replace(/,/g, ''), 10) || 0,
        //         w200: parseInt(rowData[2].replace(/,/g, ''), 10) || 0,
        //         w300: parseInt(rowData[3].replace(/,/g, ''), 10) || 0,
        //         w400: parseInt(rowData[4].replace(/,/g, ''), 10) || 0,
        //         w500: parseInt(rowData[5].replace(/,/g, ''), 10) || 0,
        //         w600: parseInt(rowData[6].replace(/,/g, ''), 10) || 0,
        //         w700: parseInt(rowData[7].replace(/,/g, ''), 10) || 0,
        //         w800: parseInt(rowData[8].replace(/,/g, ''), 10) || 0,
        //         w900: parseInt(rowData[9].replace(/,/g, ''), 10) || 0,
        //         w1000: parseInt(rowData[10].replace(/,/g, ''), 10) || 0,
        //         w1100: parseInt(rowData[11].replace(/,/g, ''), 10) || 0,
        //         w1200: parseInt(rowData[12].replace(/,/g, ''), 10) || 0,
        //         w1300: parseInt(rowData[13].replace(/,/g, ''), 10) || 0,
        //         w1400: parseInt(rowData[14].replace(/,/g, ''), 10) || 0,
        //         w1500: parseInt(rowData[15].replace(/,/g, ''), 10) || 0,
        //         w1600: parseInt(rowData[16].replace(/,/g, ''), 10) || 0,
        //         w1700: parseInt(rowData[17].replace(/,/g, ''), 10) || 0,
        //         w1800: parseInt(rowData[18].replace(/,/g, ''), 10) || 0,
        //         w1900: parseInt(rowData[19].replace(/,/g, ''), 10) || 0,
        //         w2000: parseInt(rowData[20].replace(/,/g, ''), 10) || 0
        //     };
        // });

        axios.post('/shipinfo/foamdatasavekpack', excelDataList, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': LCAT
            },
        })
            .then(() => {
                setAlertShow7(false);
                setSelectedSheetKp([]);
                selectKP()
            })
            .catch((error) => {console.error('Error:', error);});
    };

    const saveExcelFileAS = () => {
        const tableData = sheetDataAs.slice(1).map((row) => {
            const rowData = {};
            sheetDataAs[0].forEach((header, index) => {
                rowData[header] = row[index];
            });
            return rowData;
        });

        const excelDataList = tableData.map((rowData) => {
            let appAsCode;
            if (rowData['Zone'] === 'Zone 1') {
                appAsCode = 'Z1';
            } else if (rowData['Zone'] === 'Zone 2') {
                appAsCode = 'Z2';
            } else if (rowData['Zone'] === 'Zone 3') {
                appAsCode = 'Z3';
            } else if (rowData['Zone'] === 'Zone 4') {
                appAsCode = 'Z4';
            } else {
                appAsCode = 'Z5';
            }
            return {
                appAsCode: appAsCode,
                w100: rowData['100g'],w200: rowData['200g'],w300: rowData['300g'],w400: rowData['400g'],
                w500: rowData['500g'],w600: rowData['600g'],w700: rowData['700g'],w800: rowData['800g'],
                w900: rowData['900g'],w1000: rowData['1000g'],w1100: rowData['1100g'],w1200: rowData['1200g'],
                w1300: rowData['1300g'],w1400: rowData['1400g'],w1500: rowData['1500g'],w1600: rowData['1600g'],
                w1700: rowData['1700g'],w1800: rowData['1800g'],w1900: rowData['1900g'],w2000: rowData['2000g']
            };
        });
        axios.post('/shipinfo/foamdatasaveairs', excelDataList, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': LCAT
            },
        })
            .then(() => {
                setAlertShow8(false);
                setSelectedSheetAs([]);
                selectAS()
            })
            .catch((error) => {console.error('Error:', error);});
    };

    // endregion excelSave

    //region ExcelDown

    const excelDownFEDEX = async () => {
        const workbook = new excel.Workbook();
        const sheetOne = workbook.addWorksheet('FedEx');

        sheetOne.columns = [
            { header: '', width: 0.5 }, // A
            { header: '', width: 12, style: { alignment: { horizontal: 'center' } } }, // B
            ...Array(21).fill({ width: 10, style: { alignment: { horizontal: 'center' } } }) // C ~ V (A~Y)
        ];

        const zones = ['A', 'D', 'F', 'G', 'H', 'I', 'J', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y'];
        const headerRow = sheetOne.getRow(6);
        zones.forEach((zone, index) => {
            headerRow.getCell(index + 3).value = zone;
        });
        sheetOne.getRow(1).height = 3;
        sheetOne.getRow(5).height = 3;
        headerRow.values = ['', 'weight(kg)', 'A', 'D', 'F', 'G', 'H', 'I', 'J', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y'];
        headerRow.font = { name: '맑은 고딕', bold: true, size: 11 };
        headerRow.alignment = { horizontal: 'center', vertical: 'middle' };
        headerRow.height = 20;
        headerRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
            if (colNumber > 1) {
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'ebf8fc' }
                };
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' }
                };
            }
        });

        // [요금표 업로드 수정] 업로드 파서가 기대하는 무게구간과 정확히 일치시켜야 한다.
        //  0.5kg ~ 20.5kg : 0.5kg 단위 41개  /  21kg ~ 30kg : 1kg 단위 10개
        //  (20.5kg 행이 빠지면 이후 값이 한 칸씩 밀려 마지막 구간이 비고 저장 시 500 오류가 발생한다)
        const weights = [...Array(41)].map((_, i) => (i + 1) * 0.5)
            .concat([...Array(10)].map((_, i) => i + 21));

        weights.forEach((w, i) => {
            const rowIdx = i + 7;
            sheetOne.getRow(rowIdx).getCell(2).value = w;
            sheetOne.getRow(rowIdx).getCell(2).alignment = { horizontal: 'center' };
        });

        const weightKeys = weights.map(w => `w${w * 1000}`.replace('.0', ''));
        const zoneMap = {
            'A': fedexData.find(d => d.appGroup === 'A'),
            'D': fedexData.find(d => d.appGroup === 'D'),
            'F': fedexData.find(d => d.appGroup === 'F'),
            'G': fedexData.find(d => d.appGroup === 'G'),
            'H': fedexData.find(d => d.appGroup === 'H'),
            'I': fedexData.find(d => d.appGroup === 'I'),
            'J': fedexData.find(d => d.appGroup === 'J'),
            'M': fedexData.find(d => d.appGroup === 'M'),
            'N': fedexData.find(d => d.appGroup === 'N'),
            'O': fedexData.find(d => d.appGroup === 'O'),
            'P': fedexData.find(d => d.appGroup === 'P'),
            'Q': fedexData.find(d => d.appGroup === 'Q'),
            'R': fedexData.find(d => d.appGroup === 'R'),
            'S': fedexData.find(d => d.appGroup === 'S'),
            'T': fedexData.find(d => d.appGroup === 'T'),
            'U': fedexData.find(d => d.appGroup === 'U'),
            'V': fedexData.find(d => d.appGroup === 'V'),
            'W': fedexData.find(d => d.appGroup === 'W'),
            'X': fedexData.find(d => d.appGroup === 'X'),
            'Y': fedexData.find(d => d.appGroup === 'Y')
        };

        const addBorders = (range) => {
            const [startCell, endCell] = range.split(':');
            const [startCol, startRow] = startCell.match(/[A-Z]+|[0-9]+/g);
            const [endCol, endRow] = endCell.match(/[A-Z]+|[0-9]+/g);

            for (let row = parseInt(startRow); row <= parseInt(endRow); row++) {
                for (let col = startCol.charCodeAt(0); col <= endCol.charCodeAt(0); col++) {
                    const cell = sheetOne.getCell(String.fromCharCode(col) + row);
                    cell.border = {
                        top: { style: 'thin', color: { argb: '000000' } },
                        left: { style: 'thin', color: { argb: '000000' } },
                        bottom: { style: 'thin', color: { argb: '000000' } },
                        right: { style: 'thin', color: { argb: '000000' } }
                    };
                }
            }
        };

        addBorders('B3:C4');
        addBorders('D3:V4');

        weightKeys.forEach((key, i) => {
            const rowIdx = 7 + i;
            zones.forEach((zone, j) => {
                const cell = sheetOne.getCell(rowIdx, j + 3);
                cell.value = zoneMap[zone]?.[key] ?? '';
                cell.alignment = { horizontal: 'center' };
            });
        });

        const titleRow = sheetOne.getRow(2);
        titleRow.getCell(2).value = '운임표는 각 배송사 측의 유류할증료 및 기타서비스 수수료가 제외된 금액입니다. (Shipping rates exclude fuel surcharges and other service fees from each carrier)';
        titleRow.font = { name: '맑은 고딕', size: 10 };
        titleRow.alignment = { horizontal: 'left', vertical: 'middle' };
        titleRow.height = 18;

        sheetOne.mergeCells('B3:C4');
        sheetOne.mergeCells('D3:V4');
        sheetOne.getCell('D3').value = 'FedEx Shipping Rate List';
        sheetOne.getCell('D3').font = { name: '맑은 고딕', size: 16, bold: true };
        sheetOne.getCell('D3').alignment = { horizontal: 'center', vertical: 'middle' };
        sheetOne.getCell('D3').fill = {
            type: 'pattern', pattern: 'solid', fgColor: { argb: 'f8f8f8' }
        };

        // region Sheet2

        const memoSheet = workbook.addWorksheet('Group Reference');

        const headers = ['Group A', 'Group D', 'Group F', 'Group G', 'Group H', 'Group I', 'Group J', 'Group M', 'Group N', 'Group O', 'Group P', 'Group Q', 'Group R', 'Group S', 'Group T', 'Group U', 'Group V', 'Group W', 'Group X', 'Group Y'];
        headers.forEach((header, index) => {
            const columnIndex = index + 1;
            memoSheet.getCell(1, columnIndex).value = header;
            memoSheet.getCell(1, columnIndex).alignment = { horizontal: 'center', vertical: 'middle' };
            memoSheet.getCell(1, columnIndex).font = { name: '맑은 고딕', size: 11, bold: true };
        });

        const rowData = [
            /*A*/ ['Macau[MO]'],
            /*D*/ ['Cambodia[KH]', 'Laos[LA]', 'Mongolia[MN]', 'Brunei[BN]', 'Guam[GU]', 'Rota[RO]', 'Tinian[TI]'],
            /*F*/ ['Canada[CA]', 'United States[US]', 'Mexico[MX]', 'Austria[AT]', 'Puerto Rico[PR]'],
            /*G*/ [
                'Austria[AT]', 'Czech Republic[CZ]', 'Denmark[DK]', 'Finland[FI]', 'Greece[GR]',
                'Hungary[HU]', 'Ireland[IE]', 'Norway[NO]', 'Poland[PL]', 'Portugal[PT]',
                'Sweden[SE]', 'Switzerland[CH]', 'Czechia[CZ]', 'Faroe Islands[FO]',
                'Greenland[GL]', 'Liechtenstein[LI]', 'Luxembourg[LU]', 'Monaco[MC]',
                'Slovakia[SK]'
            ],
            /*H*/ [
                'Israel[IL]', 'Turkey[TR]', 'Russia[RU]', 'Ukraine[UA]', 'Uzbekistan[UZ]',
                'Albania[AL]', 'Andorra[AD]', 'Armenia[AM]', 'Azerbaijan[AZ]', 'Belarus[BY]',
                'Bosnia and Herzegovina[BA]', 'Bulgaria[BG]', 'Croatia[HR]', 'Cyprus[CY]',
                'Estonia[EE]', 'Gibraltar[GI]', 'Georgia[GE]', 'Iceland[IS]',
                'Kyrgyzstan[KG]', 'Kazakhstan[KZ]', 'Latvia[LV]', 'Lithuania[LT]',
                'North Macedonia[MK]', 'Malta[MT]', 'Moldova[MD]', 'Montenegro[ME]',
                'Romania[RO]', 'Serbia[RS]', 'Slovenia[SI]'
            ],
            /*I*/ [
                'Argentina[AR]', 'Brazil[BR]', 'Chile[CL]', 'Peru[PE]', 'American Samoa[AS]',
                'Anguilla[AI]', 'Antigua and Barbuda[AG]', 'Aruba[AW]', 'Bahamas[BS]',
                'Barbados[BB]', 'Barbuda[BB]', 'Belize[BZ]', 'Bermuda[BM]', 'Bolivia[BO]',
                'Bonaire[BQ]', 'British Virgin Islands[VG]', 'Cayman Islands[KY]',
                'Colombia[CO]', 'Cook Islands[CK]', 'Costa Rica[CR]', 'Curaçao[CW]',
                'Dominica[DM]', 'Saint Barthélemy[BL]', 'Saint Kitts and Nevis[KN]',
                'Suriname[SR]', 'Tahiti[PF]', 'Tonga[TO]', 'Tortola[VG]',
                'Trinidad and Tobago[TT]', 'Union Island[VC]', 'Vanuatu[VU]', 'Venezuela[VE]',
                'Marshall Islands[MH]', 'Martinique[MQ]', 'Micronesia[FM]', 'Montserrat[MS]',
                'Nevis[KN]', 'New Caledonia[NC]', 'Nicaragua[NI]', 'Norman Islands[VG]',
                'Northern Mariana Islands[MP]', 'Palau[PW]', 'Papua New Guinea[PG]',
                'Paraguay[PY]', 'Saba[BQ]', 'Saipan[MP]', 'Samoa[WS]', 'Dominican Republic[DO]',
                'Timor-Leste[TL]', 'Ecuador[EC]', 'El Salvador[SV]', 'Fiji[FJ]', 'Grenada[GD]',
                'Guadeloupe[GP]', 'Guyana[GY]', 'Haiti[HT]', 'Honduras[HN]', 'Jamaica[JM]'
            ],
            /*J*/ [
                'Bangladesh[BD]', 'Morocco[MA]', 'Qatar[QA]', 'United Arab Emirates[AE]',
                'Jordan[JO]', 'Saudi Arabia[SA]', 'Afghanistan[AF]', 'Algeria[DZ]',
                'Angola[AO]', 'Bahrain[BH]', 'Benin[BJ]', 'Bhutan[BT]', 'Burkina Faso[BF]',
                'Burundi[BI]', 'Cabo Verde[CV]', 'Cameroon[CM]', 'Botswana[BW]', 'Chad[TD]',
                'Congo[CG]', 'Democratic Republic of the Congo[CD]', 'Djibouti[DJ]',
                'Zimbabwe[ZW]', 'Zambia[ZM]', 'Yemen[YE]', 'Tanzania[TZ]', 'Tunisia[TN]',
                'Uganda[UG]', 'Eswatini[SZ]', 'Sri Lanka[LK]', 'South Africa[ZA]', 'Syria[SY]',
                'Togo[TG]', 'Senegal[SN]', 'Seychelles[SC]', 'Rwanda[RW]', 'Réunion[RE]',
                'Qatar[QA]', 'Palestine[PS]', 'Pakistan[PK]', 'Oman[OM]', 'Nigeria[NG]',
                'Niger[NE]', 'Nepal[NP]', 'Mozambique[MZ]', 'Namibia[NA]', 'Mauritius[MU]',
                'Mauritania[MR]', 'Mali[ML]', 'Maldives[MV]', 'Malawi[MW]', 'Madagascar[MG]',
                'Egypt[EG]', 'Eritrea[ER]', 'Ethiopia[ET]', 'Gabon[GA]', 'Gambia[GM]',
                'Ghana[GH]', 'Guinea[GN]', 'Iraq[IQ]', 'Côte d\'Ivoire[CI]', 'Kenya[KE]',
                'Kuwait[KW]', 'Lebanon[LB]', 'Lesotho[LS]', 'Liberia[LR]', 'Libya[LY]'
            ],
            /*M*/ ['Belgium[BE]', 'Germany[DE]', 'Italy[IT]', 'Netherlands[NL]', 'Spain[ES]', 'United Kingdom[GB]', 'France[FR]', 'Canary Islands[IC]', 'Channel Islands[JE]', 'Vatican City[VA]', 'San Marino[SM]'],
            /*N*/ ['Vietnam[VN]'],
            /*O*/ ['India[IN]'],
            /*P*/ ['Japan[JP]'],
            /*Q*/ ['Malaysia[MY]'],
            /*R*/ ['Thailand[TH]'],
            /*S*/ ['Philippines[PH]'],
            /*T*/ ['Indonesia[ID]'],
            /*U*/ ['Australia[AU]', 'New Zealand[NZ]', 'Norfolk Island[NF]'],
            /*V*/ ['Hong Kong[HK]'],
            /*W*/ ['China[CN]'],
            /*X*/ ['Taiwan[TW]'],
            /*Y*/ ['Singapore[SG]']
        ];

        rowData.forEach((columnData, columnIndex) => {
            columnData.forEach((value, rowIndex) => {
                memoSheet.getCell(rowIndex + 2, columnIndex + 1).value = value;  // 데이터 입력
                memoSheet.getCell(rowIndex + 2, columnIndex + 1).alignment = { horizontal: 'center', vertical: 'middle' };
                memoSheet.getCell(rowIndex + 2, columnIndex + 1).font = { name: '맑은 고딕', size: 11 };
            });
        });

        const equalColumnWidth = 28;
        for (let i = 1; i <= headers.length; i++) {
            memoSheet.getColumn(i).width = equalColumnWidth;
        }

        // endregion Sheet2

        const response = await fetch(excelLogo);
        const imageBuffer = await response.arrayBuffer();
        const imageId = workbook.addImage({ buffer: imageBuffer, extension: 'png' });
        sheetOne.addImage(imageId, { tl: { col: 1, row: 2 }, ext: { width: 168, height: 40 }, editAs: 'oneCell' });

        workbook.xlsx.writeBuffer().then((data) => {
            const blob = new Blob([data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            const url = window.URL.createObjectURL(blob);
            const anchor = document.createElement('a');
            anchor.href = url;
            anchor.download = `Btorage 요금표[FedEx].xlsx`;
            anchor.click();
            window.URL.revokeObjectURL(url);
        });
    }

    const excelDownFEDEXE = async () => {
        const workbook = new excel.Workbook();
        const sheetOne = workbook.addWorksheet('FedEx');

        sheetOne.columns = [
            { header: '', width: 0.5 }, // A
            { header: '', width: 12, style: { alignment: { horizontal: 'center' } } }, // B
            ...Array(21).fill({ width: 10, style: { alignment: { horizontal: 'center' } } }) // C ~ V (A~Y)
        ];

        const zones = ['A', 'D', 'F', 'G', 'H', 'I', 'J', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y'];
        const headerRow = sheetOne.getRow(6);
        zones.forEach((zone, index) => {
            headerRow.getCell(index + 3).value = zone;
        });
        sheetOne.getRow(1).height = 3;
        sheetOne.getRow(5).height = 3;
        headerRow.values = ['', 'weight(kg)', 'A', 'D', 'F', 'G', 'H', 'I', 'J', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y'];
        headerRow.font = { name: '맑은 고딕', bold: true, size: 11 };
        headerRow.alignment = { horizontal: 'center', vertical: 'middle' };
        headerRow.height = 20;
        headerRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
            if (colNumber > 1) {
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'ebf8fc' }
                };
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' }
                };
            }
        });

        // [요금표 업로드 수정] 업로드 파서가 기대하는 무게구간과 정확히 일치시켜야 한다.
        //  0.5kg ~ 20.5kg : 0.5kg 단위 41개  /  21kg ~ 30kg : 1kg 단위 10개
        //  (20.5kg 행이 빠지면 이후 값이 한 칸씩 밀려 마지막 구간이 비고 저장 시 500 오류가 발생한다)
        const weights = [...Array(41)].map((_, i) => (i + 1) * 0.5)
            .concat([...Array(10)].map((_, i) => i + 21));

        weights.forEach((w, i) => {
            const rowIdx = i + 7;
            sheetOne.getRow(rowIdx).getCell(2).value = w;
            sheetOne.getRow(rowIdx).getCell(2).alignment = { horizontal: 'center' };
        });

        const weightKeys = weights.map(w => `w${w * 1000}`.replace('.0', ''));
        const zoneMap = {
            'A': fedexEcoData.find(d => d.appGroup === 'A'),
            'D': fedexEcoData.find(d => d.appGroup === 'D'),
            'F': fedexEcoData.find(d => d.appGroup === 'F'),
            'G': fedexEcoData.find(d => d.appGroup === 'G'),
            'H': fedexEcoData.find(d => d.appGroup === 'H'),
            'I': fedexEcoData.find(d => d.appGroup === 'I'),
            'J': fedexEcoData.find(d => d.appGroup === 'J'),
            'M': fedexEcoData.find(d => d.appGroup === 'M'),
            'N': fedexEcoData.find(d => d.appGroup === 'N'),
            'O': fedexEcoData.find(d => d.appGroup === 'O'),
            'P': fedexEcoData.find(d => d.appGroup === 'P'),
            'Q': fedexEcoData.find(d => d.appGroup === 'Q'),
            'R': fedexEcoData.find(d => d.appGroup === 'R'),
            'S': fedexEcoData.find(d => d.appGroup === 'S'),
            'T': fedexEcoData.find(d => d.appGroup === 'T'),
            'U': fedexEcoData.find(d => d.appGroup === 'U'),
            'V': fedexEcoData.find(d => d.appGroup === 'V'),
            'W': fedexEcoData.find(d => d.appGroup === 'W'),
            'X': fedexEcoData.find(d => d.appGroup === 'X'),
            'Y': fedexEcoData.find(d => d.appGroup === 'Y')
        };

        const addBorders = (range) => {
            const [startCell, endCell] = range.split(':');
            const [startCol, startRow] = startCell.match(/[A-Z]+|[0-9]+/g);
            const [endCol, endRow] = endCell.match(/[A-Z]+|[0-9]+/g);

            for (let row = parseInt(startRow); row <= parseInt(endRow); row++) {
                for (let col = startCol.charCodeAt(0); col <= endCol.charCodeAt(0); col++) {
                    const cell = sheetOne.getCell(String.fromCharCode(col) + row);
                    cell.border = {
                        top: { style: 'thin', color: { argb: '000000' } },
                        left: { style: 'thin', color: { argb: '000000' } },
                        bottom: { style: 'thin', color: { argb: '000000' } },
                        right: { style: 'thin', color: { argb: '000000' } }
                    };
                }
            }
        };

        addBorders('B3:C4');
        addBorders('D3:V4');

        weightKeys.forEach((key, i) => {
            const rowIdx = 7 + i;
            zones.forEach((zone, j) => {
                const cell = sheetOne.getCell(rowIdx, j + 3);
                cell.value = zoneMap[zone]?.[key] ?? '';
                cell.alignment = { horizontal: 'center' };
            });
        });

        const titleRow = sheetOne.getRow(2);
        titleRow.getCell(2).value = '운임표는 각 배송사 측의 유류할증료 및 기타서비스 수수료가 제외된 금액입니다. (Shipping rates exclude fuel surcharges and other service fees from each carrier)';
        titleRow.font = { name: '맑은 고딕', size: 10 };
        titleRow.alignment = { horizontal: 'left', vertical: 'middle' };
        titleRow.height = 18;

        sheetOne.mergeCells('B3:C4');
        sheetOne.mergeCells('D3:V4');
        sheetOne.getCell('D3').value = 'FedEx-E Shipping Rate List';
        sheetOne.getCell('D3').font = { name: '맑은 고딕', size: 16, bold: true };
        sheetOne.getCell('D3').alignment = { horizontal: 'center', vertical: 'middle' };
        sheetOne.getCell('D3').fill = {
            type: 'pattern', pattern: 'solid', fgColor: { argb: 'f8f8f8' }
        };

        // region Sheet2

        const memoSheet = workbook.addWorksheet('Group Reference');

        const headers = ['Group A', 'Group D', 'Group F', 'Group G', 'Group H', 'Group I', 'Group J', 'Group M', 'Group N', 'Group O', 'Group P', 'Group Q', 'Group R', 'Group S', 'Group T', 'Group U', 'Group V', 'Group W', 'Group X', 'Group Y'];
        headers.forEach((header, index) => {
            const columnIndex = index + 1;
            memoSheet.getCell(1, columnIndex).value = header;
            memoSheet.getCell(1, columnIndex).alignment = { horizontal: 'center', vertical: 'middle' };
            memoSheet.getCell(1, columnIndex).font = { name: '맑은 고딕', size: 11, bold: true };
        });

        const rowData = [
            /*A*/ ['Macau[MO]'],
            /*D*/ ['Cambodia[KH]', 'Laos[LA]', 'Mongolia[MN]', 'Brunei[BN]', 'Guam[GU]', 'Rota[RO]', 'Tinian[TI]'],
            /*F*/ ['Canada[CA]', 'United States[US]', 'Mexico[MX]', 'Austria[AT]', 'Puerto Rico[PR]'],
            /*G*/ [
                'Austria[AT]', 'Czech Republic[CZ]', 'Denmark[DK]', 'Finland[FI]', 'Greece[GR]',
                'Hungary[HU]', 'Ireland[IE]', 'Norway[NO]', 'Poland[PL]', 'Portugal[PT]',
                'Sweden[SE]', 'Switzerland[CH]', 'Czechia[CZ]', 'Faroe Islands[FO]',
                'Greenland[GL]', 'Liechtenstein[LI]', 'Luxembourg[LU]', 'Monaco[MC]',
                'Slovakia[SK]'
            ],
            /*H*/ [
                'Israel[IL]', 'Turkey[TR]', 'Russia[RU]', 'Ukraine[UA]', 'Uzbekistan[UZ]',
                'Albania[AL]', 'Andorra[AD]', 'Armenia[AM]', 'Azerbaijan[AZ]', 'Belarus[BY]',
                'Bosnia and Herzegovina[BA]', 'Bulgaria[BG]', 'Croatia[HR]', 'Cyprus[CY]',
                'Estonia[EE]', 'Gibraltar[GI]', 'Georgia[GE]', 'Iceland[IS]',
                'Kyrgyzstan[KG]', 'Kazakhstan[KZ]', 'Latvia[LV]', 'Lithuania[LT]',
                'North Macedonia[MK]', 'Malta[MT]', 'Moldova[MD]', 'Montenegro[ME]',
                'Romania[RO]', 'Serbia[RS]', 'Slovenia[SI]'
            ],
            /*I*/ [
                'Argentina[AR]', 'Brazil[BR]', 'Chile[CL]', 'Peru[PE]', 'American Samoa[AS]',
                'Anguilla[AI]', 'Antigua and Barbuda[AG]', 'Aruba[AW]', 'Bahamas[BS]',
                'Barbados[BB]', 'Barbuda[BB]', 'Belize[BZ]', 'Bermuda[BM]', 'Bolivia[BO]',
                'Bonaire[BQ]', 'British Virgin Islands[VG]', 'Cayman Islands[KY]',
                'Colombia[CO]', 'Cook Islands[CK]', 'Costa Rica[CR]', 'Curaçao[CW]',
                'Dominica[DM]', 'Saint Barthélemy[BL]', 'Saint Kitts and Nevis[KN]',
                'Suriname[SR]', 'Tahiti[PF]', 'Tonga[TO]', 'Tortola[VG]',
                'Trinidad and Tobago[TT]', 'Union Island[VC]', 'Vanuatu[VU]', 'Venezuela[VE]',
                'Marshall Islands[MH]', 'Martinique[MQ]', 'Micronesia[FM]', 'Montserrat[MS]',
                'Nevis[KN]', 'New Caledonia[NC]', 'Nicaragua[NI]', 'Norman Islands[VG]',
                'Northern Mariana Islands[MP]', 'Palau[PW]', 'Papua New Guinea[PG]',
                'Paraguay[PY]', 'Saba[BQ]', 'Saipan[MP]', 'Samoa[WS]', 'Dominican Republic[DO]',
                'Timor-Leste[TL]', 'Ecuador[EC]', 'El Salvador[SV]', 'Fiji[FJ]', 'Grenada[GD]',
                'Guadeloupe[GP]', 'Guyana[GY]', 'Haiti[HT]', 'Honduras[HN]', 'Jamaica[JM]'
            ],
            /*J*/ [
                'Bangladesh[BD]', 'Morocco[MA]', 'Qatar[QA]', 'United Arab Emirates[AE]',
                'Jordan[JO]', 'Saudi Arabia[SA]', 'Afghanistan[AF]', 'Algeria[DZ]',
                'Angola[AO]', 'Bahrain[BH]', 'Benin[BJ]', 'Bhutan[BT]', 'Burkina Faso[BF]',
                'Burundi[BI]', 'Cabo Verde[CV]', 'Cameroon[CM]', 'Botswana[BW]', 'Chad[TD]',
                'Congo[CG]', 'Democratic Republic of the Congo[CD]', 'Djibouti[DJ]',
                'Zimbabwe[ZW]', 'Zambia[ZM]', 'Yemen[YE]', 'Tanzania[TZ]', 'Tunisia[TN]',
                'Uganda[UG]', 'Eswatini[SZ]', 'Sri Lanka[LK]', 'South Africa[ZA]', 'Syria[SY]',
                'Togo[TG]', 'Senegal[SN]', 'Seychelles[SC]', 'Rwanda[RW]', 'Réunion[RE]',
                'Qatar[QA]', 'Palestine[PS]', 'Pakistan[PK]', 'Oman[OM]', 'Nigeria[NG]',
                'Niger[NE]', 'Nepal[NP]', 'Mozambique[MZ]', 'Namibia[NA]', 'Mauritius[MU]',
                'Mauritania[MR]', 'Mali[ML]', 'Maldives[MV]', 'Malawi[MW]', 'Madagascar[MG]',
                'Egypt[EG]', 'Eritrea[ER]', 'Ethiopia[ET]', 'Gabon[GA]', 'Gambia[GM]',
                'Ghana[GH]', 'Guinea[GN]', 'Iraq[IQ]', 'Côte d\'Ivoire[CI]', 'Kenya[KE]',
                'Kuwait[KW]', 'Lebanon[LB]', 'Lesotho[LS]', 'Liberia[LR]', 'Libya[LY]'
            ],
            /*M*/ ['Belgium[BE]', 'Germany[DE]', 'Italy[IT]', 'Netherlands[NL]', 'Spain[ES]', 'United Kingdom[GB]', 'France[FR]', 'Canary Islands[IC]', 'Channel Islands[JE]', 'Vatican City[VA]', 'San Marino[SM]'],
            /*N*/ ['Vietnam[VN]'],
            /*O*/ ['India[IN]'],
            /*P*/ ['Japan[JP]'],
            /*Q*/ ['Malaysia[MY]'],
            /*R*/ ['Thailand[TH]'],
            /*S*/ ['Philippines[PH]'],
            /*T*/ ['Indonesia[ID]'],
            /*U*/ ['Australia[AU]', 'New Zealand[NZ]', 'Norfolk Island[NF]'],
            /*V*/ ['Hong Kong[HK]'],
            /*W*/ ['China[CN]'],
            /*X*/ ['Taiwan[TW]'],
            /*Y*/ ['Singapore[SG]']
        ];

        rowData.forEach((columnData, columnIndex) => {
            columnData.forEach((value, rowIndex) => {
                memoSheet.getCell(rowIndex + 2, columnIndex + 1).value = value;  // 데이터 입력
                memoSheet.getCell(rowIndex + 2, columnIndex + 1).alignment = { horizontal: 'center', vertical: 'middle' };
                memoSheet.getCell(rowIndex + 2, columnIndex + 1).font = { name: '맑은 고딕', size: 11 };
            });
        });

        const equalColumnWidth = 28;
        for (let i = 1; i <= headers.length; i++) {
            memoSheet.getColumn(i).width = equalColumnWidth;
        }

        // endregion Sheet2

        const response = await fetch(excelLogo);
        const imageBuffer = await response.arrayBuffer();
        const imageId = workbook.addImage({ buffer: imageBuffer, extension: 'png' });
        sheetOne.addImage(imageId, { tl: { col: 1, row: 2 }, ext: { width: 168, height: 40 }, editAs: 'oneCell' });

        workbook.xlsx.writeBuffer().then((data) => {
            const blob = new Blob([data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            const url = window.URL.createObjectURL(blob);
            const anchor = document.createElement('a');
            anchor.href = url;
            anchor.download = `Btorage 요금표[FedEx-E].xlsx`;
            anchor.click();
            window.URL.revokeObjectURL(url);
        });
    }

    const excelDownUPS = async () => {
        const workbook = new excel.Workbook();
        const sheetOne = workbook.addWorksheet('UPS');

        sheetOne.columns = [
            { header: '', width: 0.5 }, // A
            { header: '', width: 12, style: { alignment: { horizontal: 'center' } } }, // B
            ...Array(11).fill({ width: 10, style: { alignment: { horizontal: 'center' } } }) // C ~ L (Z1~Z0)
        ];

        const zones = ['Z1', 'Z2', 'Z3', 'Z4', 'Z5', 'Z6', 'Z7', 'Z8', 'Z9', 'Z0'];
        const headerRow = sheetOne.getRow(6);
        zones.forEach((zone, index) => {
            headerRow.getCell(index + 3).value = zone;
        });
        sheetOne.getRow(1).height = 3;
        sheetOne.getRow(5).height = 3;
        headerRow.values = ['', 'weight(kg)', 'Z1', 'Z2', 'Z3', 'Z4', 'Z5', 'Z6', 'Z7', 'Z8', 'Z9', 'Z0'];
        headerRow.font = { name: '맑은 고딕', bold: true, size: 11 };
        headerRow.alignment = { horizontal: 'center', vertical: 'middle' };
        headerRow.height = 20;
        headerRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
            if (colNumber > 1) {
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'ebf8fc' }
                };
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' }
                };
            }
        });

        // [요금표 업로드 수정] 업로드 파서가 기대하는 무게구간과 정확히 일치시켜야 한다.
        //  0.5kg ~ 20.5kg : 0.5kg 단위 41개  /  21kg ~ 30kg : 1kg 단위 10개  (총 51행 = 엑셀 7~57행)
        //  DB(ExrInfoUPSVO / ExrInfoUPSECOVO)에 w500 ~ w30000 51개 컬럼만 존재하므로 FedEx 와 동일하게 맞춘다.
        //  (20.5kg 행이 빠지면 이후 값이 한 칸씩 밀려 마지막 구간이 비고 저장 시 500 오류가 발생한다)
        const weights = [...Array(41)].map((_, i) => (i + 1) * 0.5)
            .concat([...Array(10)].map((_, i) => i + 21));

        weights.forEach((w, i) => {
            const rowIdx = i + 7;
            sheetOne.getRow(rowIdx).getCell(2).value = w;
            sheetOne.getRow(rowIdx).getCell(2).alignment = { horizontal: 'center' };
        });

        const weightKeys = weights.map(w => `w${w * 1000}`.replace('.0', ''));
        const zoneMap = {
            'Z1': upsData.find(d => d.appUpsCode === 'Z1'),
            'Z2': upsData.find(d => d.appUpsCode === 'Z2'),
            'Z3': upsData.find(d => d.appUpsCode === 'Z3'),
            'Z4': upsData.find(d => d.appUpsCode === 'Z4'),
            'Z5': upsData.find(d => d.appUpsCode === 'Z5'),
            'Z6': upsData.find(d => d.appUpsCode === 'Z6'),
            'Z7': upsData.find(d => d.appUpsCode === 'Z7'),
            'Z8': upsData.find(d => d.appUpsCode === 'Z8'),
            'Z9': upsData.find(d => d.appUpsCode === 'Z9'),
            'Z0': upsData.find(d => d.appUpsCode === 'Z0')
        };

        const addBorders = (range) => {
            const [startCell, endCell] = range.split(':');
            const [startCol, startRow] = startCell.match(/[A-Z]+|[0-9]+/g);
            const [endCol, endRow] = endCell.match(/[A-Z]+|[0-9]+/g);

            for (let row = parseInt(startRow); row <= parseInt(endRow); row++) {
                for (let col = startCol.charCodeAt(0); col <= endCol.charCodeAt(0); col++) {
                    const cell = sheetOne.getCell(String.fromCharCode(col) + row);
                    cell.border = {
                        top: { style: 'thin', color: { argb: '000000' } },
                        left: { style: 'thin', color: { argb: '000000' } },
                        bottom: { style: 'thin', color: { argb: '000000' } },
                        right: { style: 'thin', color: { argb: '000000' } }
                    };
                }
            }
        };

        addBorders('B3:C4');
        addBorders('D3:L4');

        weightKeys.forEach((key, i) => {
            const rowIdx = 7 + i;
            zones.forEach((zone, j) => {
                const cell = sheetOne.getCell(rowIdx, j + 3);
                cell.value = zoneMap[zone]?.[key] ?? '';
                cell.alignment = { horizontal: 'center' };
            });
        });

        const titleRow = sheetOne.getRow(2);
        titleRow.getCell(2).value = '운임표는 각 배송사 측의 유류할증료 및 기타서비스 수수료가 제외된 금액입니다. (Shipping rates exclude fuel surcharges and other service fees from each carrier)';
        titleRow.font = { name: '맑은 고딕', size: 10 };
        titleRow.alignment = { horizontal: 'left', vertical: 'middle' };
        titleRow.height = 18;

        sheetOne.mergeCells('B3:C4');
        sheetOne.mergeCells('D3:L4');
        sheetOne.getCell('D3').value = 'UPS Shipping Rate List';
        sheetOne.getCell('D3').font = { name: '맑은 고딕', size: 16, bold: true };
        sheetOne.getCell('D3').alignment = { horizontal: 'center', vertical: 'middle' };
        sheetOne.getCell('D3').fill = {
            type: 'pattern', pattern: 'solid', fgColor: { argb: 'f8f8f8' }
        };

        // region Sheet2

        const memoSheet = workbook.addWorksheet('Zone Reference');

        const headers = ['Z1[Zone1]', 'Z2[Zone2]', 'Z3[Zone3]', 'Z4[Zone4]', 'Z5[Zone5]', 'Z6[Zone6]', 'Z7[Zone7]', 'Z8[Zone8]', 'Z9[Zone9]', 'Z0[Zone10]'];
        headers.forEach((header, index) => {
            const columnIndex = index + 1;
            memoSheet.getCell(1, columnIndex).value = header;
            memoSheet.getCell(1, columnIndex).alignment = { horizontal: 'center', vertical: 'middle' };
            memoSheet.getCell(1, columnIndex).font = { name: '맑은 고딕', size: 11, bold: true };
        });

        const rowData = [
            ['Singapore[SG]', 'Taiwan, China[TW]', 'Macau SAR, China[MO]'],
            ['Japan[JP]', 'Vietnam[VN]'],
            ['Indonesia[ID]', 'Thailand[TH]', 'Malaysia[MY]', 'Philippines[PH]'],
            ['New Zealand[NZ]', 'Australia[AU]', 'Norfolk Island[NF]', 'India[IN]'],
            ['United States[US]', 'Canada[CA]', 'Mexico[MX]'],
            ['United Kingdom[GB]', 'France[FR]', 'Germany[DE]', 'Spain[ES]', 'Netherlands[NL]', 'Poland[PL]', 'Luxembourg[LU]', 'Liechtenstein[LI]', 'Monaco[MC]', 'Vatican City[VA]', 'Belgium[BE]', 'San Marino[SM]', 'Sweden[SE]', 'Switzerland[CH]', 'Slovakia[SK]', 'Andorra[AD]', 'Italy[IT]', 'Czech Republic[CZ]'],
            ['Austria[AT]', 'Ireland[IE]', 'Greece[GR]', 'Norway[NO]', 'Denmark[DK]', 'Portugal[PT]', 'Finland[FI]'],
            ['Turkey[TR]', 'Russia[RU]', 'Laos[LA]', 'Chile[CL]', 'United Arab Emirates[AE]', 'Cambodia[KH]', 'Bangladesh[BD]', 'Saudi Arabia[SA]', 'Peru[PE]', 'Guadeloupe[GP]', 'Guatemala[GT]', 'Guam[GU]', 'Grenada[GD]', 'French Guiana[GF]', 'South Africa[ZA]', 'New Caledonia[NC]', 'Nicaragua[NI]', 'Dominican Republic[DO]', 'Dominica[DM]', 'Timor-Leste[TL]', 'Latvia[LV]', 'Romania[RO]', 'Lithuania[LT]', 'Martinique[MQ]', 'Marshall Islands[MH]', 'Montserrat[MS]', 'Maldives[MV]', 'Malta[MT]', 'Myanmar[MM]', 'Micronesia[FM]', 'Vanuatu[VU]', 'Bahrain[BH]', 'Barbados[BB]', 'Bahamas[BS]', 'St. Croix (Virgin Islands)[VI]', 'Virgin Gorda[VG]', 'Venezuela[VE]', 'Belize[BZ]', 'Botswana[BW]', 'Bolivia[BO]', 'Bhutan[BT]', 'Bulgaria[BG]', 'Brazil[BR]', 'Samoa[WS]', 'American Samoa[AS]', 'Cyprus[CY]', 'St. Lucia[LC]', 'St. Vincent & the Grenadines[VC]', 'St. Kitts and Nevis[KN]', 'Solomon Islands[SB]', 'Suriname[SR]', 'Sri Lanka[LK]', 'Slovenia[SI]', 'Aruba[AW]', 'Argentina[AR]', 'Iceland[IS]', 'El Salvador[SV]', 'Azerbaijan[AZ]', 'Antigua and Barbuda[AG]', 'Anguilla[AI]', 'Eritrea[ER]', 'Ecuador[EC]', 'Oman[OM]', 'Honduras[HN]', 'Wallis & Futuna Islands[WF]', 'Uruguay[UY]', 'Ukraine[UA]', 'Egypt[EG]', 'Jamaica[JM]', 'Gibraltar[GI]', 'Qatar[QA]', 'Costa Rica[CR]', 'Colombia[CO]', 'Kuwait[KW]', 'Croatia[HR]', 'Tonga[TO]', 'Panama[PA]', 'Paraguay[PY]', 'Pakistan[PK]', 'Papua New Guinea[PG]', 'Palau[PW]', 'Fiji[FJ]', 'Hungary[HU]'],
            ['Israel[IL]', 'Mongolia[MN]', 'Ghana[GH]', 'Gabon[GA]', 'Guyana[GY]', 'Gambia[GM]', 'Greenland[GL]', 'Guinea[GN]', 'Guinea-Bissau[GW]', 'Namibia[NA]', 'Nigeria[NG]', 'Nepal[NP]', 'Niger[NE]', 'Liberia[LR]', 'Lesotho[LS]', 'Reunion Island[RE]', 'Rwanda[RW]', 'Madagascar[MG]', 'Mayotte[YT]', 'Malawi[MW]', 'Mali[ML]', 'Morocco[MA]', 'Mauritius[MU]', 'Mauritania[MR]', 'Mozambique[MZ]', 'Montenegro[ME]', 'Moldova[MD]', 'Bermuda[BM]', 'Benin[BJ]', 'Belarus[BY]', 'Bosnia and Herzegovina[BA]', 'Burundi[BI]', 'Burkina Faso[BF]', 'Macedonia (FYROM)[MK]', 'Botswana[BW]', 'Northern Mariana Islands[MP]', 'Senegal[SN]', 'Serbia[RS]', 'Seychelles[SC]', 'Sierra Leone[SL]', 'Armenia[AM]', 'Afghanistan[AF]', 'Albania[AL]', 'Algeria[DZ]', 'Angola[AO]', 'Swaziland[SZ]', 'Estonia[EE]', 'Ethiopia[ET]', 'Jordan[JO]', 'Uganda[UG]', 'Uzbekistan[UZ]', 'Iraq[IQ]', 'Zambia[ZM]', 'Central African Republic[CF]', 'Djibouti[DJ]', 'Zimbabwe[ZW]', 'Chad[TD]', 'Cameroon[CM]', 'Cape Verde[CV]', 'Kazakhstan[KZ]', 'Kenya[KE]', 'Cote d\'Ivoire (Ivory Coast)[CI]', 'Congo (Brazzaville)[CG]', 'Tanzania[TZ]', 'Togo[TG]', 'Tunisia[TN]'],
            ['Southern China Mainland[CN]', 'Hong Kong[HK]', 'Southern China Mainland[CN]']
        ];

        rowData.forEach((columnData, columnIndex) => {
            columnData.forEach((value, rowIndex) => {
                memoSheet.getCell(rowIndex + 2, columnIndex + 1).value = value;  // 데이터 입력
                memoSheet.getCell(rowIndex + 2, columnIndex + 1).alignment = { horizontal: 'center', vertical: 'middle' };
                memoSheet.getCell(rowIndex + 2, columnIndex + 1).font = { name: '맑은 고딕', size: 11 };
            });
        });

        const equalColumnWidth = 28;
        for (let i = 1; i <= headers.length; i++) {
            memoSheet.getColumn(i).width = equalColumnWidth;
        }

        // endregion Sheet2

        const response = await fetch(excelLogo);
        const imageBuffer = await response.arrayBuffer();
        const imageId = workbook.addImage({ buffer: imageBuffer, extension: 'png' });
        sheetOne.addImage(imageId, { tl: { col: 1, row: 2 }, ext: { width: 168, height: 40 }, editAs: 'oneCell' });

        workbook.xlsx.writeBuffer().then((data) => {
            const blob = new Blob([data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            const url = window.URL.createObjectURL(blob);
            const anchor = document.createElement('a');
            anchor.href = url;
            anchor.download = `Btorage 요금표[UPS].xlsx`;
            anchor.click();
            window.URL.revokeObjectURL(url);
        });
    };

    const excelDownUPSE = async () => {
        const workbook = new excel.Workbook();
        const sheetOne = workbook.addWorksheet('UPS');

        sheetOne.columns = [
            { header: '', width: 0.5 }, // A
            { header: '', width: 12, style: { alignment: { horizontal: 'center' } } }, // B
            ...Array(11).fill({ width: 10, style: { alignment: { horizontal: 'center' } } }) // C ~ L (Z1~Z0)
        ];

        const zones = ['Z1', 'Z2', 'Z3', 'Z4', 'Z5', 'Z6', 'Z7', 'Z8', 'Z9', 'Z0'];
        const headerRow = sheetOne.getRow(6);
        zones.forEach((zone, index) => {
            headerRow.getCell(index + 3).value = zone;
        });
        sheetOne.getRow(1).height = 3;
        sheetOne.getRow(5).height = 3;
        headerRow.values = ['', 'weight(kg)', 'Z1', 'Z2', 'Z3', 'Z4', 'Z5', 'Z6', 'Z7', 'Z8', 'Z9', 'Z0'];
        headerRow.font = { name: '맑은 고딕', bold: true, size: 11 };
        headerRow.alignment = { horizontal: 'center', vertical: 'middle' };
        headerRow.height = 20;
        headerRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
            if (colNumber > 1) {
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'ebf8fc' }
                };
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' }
                };
            }
        });

        // [요금표 업로드 수정] 업로드 파서가 기대하는 무게구간과 정확히 일치시켜야 한다.
        //  0.5kg ~ 20.5kg : 0.5kg 단위 41개  /  21kg ~ 30kg : 1kg 단위 10개  (총 51행 = 엑셀 7~57행)
        //  DB(ExrInfoUPSVO / ExrInfoUPSECOVO)에 w500 ~ w30000 51개 컬럼만 존재하므로 FedEx 와 동일하게 맞춘다.
        //  (20.5kg 행이 빠지면 이후 값이 한 칸씩 밀려 마지막 구간이 비고 저장 시 500 오류가 발생한다)
        const weights = [...Array(41)].map((_, i) => (i + 1) * 0.5)
            .concat([...Array(10)].map((_, i) => i + 21));

        weights.forEach((w, i) => {
            const rowIdx = i + 7;
            sheetOne.getRow(rowIdx).getCell(2).value = w;
            sheetOne.getRow(rowIdx).getCell(2).alignment = { horizontal: 'center' };
        });

        const weightKeys = weights.map(w => `w${w * 1000}`.replace('.0', ''));
        const zoneMap = {
            'Z1': upsEcoData.find(d => d.appUpsEcoCode === 'Z1'),
            'Z2': upsEcoData.find(d => d.appUpsEcoCode === 'Z2'),
            'Z3': upsEcoData.find(d => d.appUpsEcoCode === 'Z3'),
            'Z4': upsEcoData.find(d => d.appUpsEcoCode === 'Z4'),
            'Z5': upsEcoData.find(d => d.appUpsEcoCode === 'Z5'),
            'Z6': upsEcoData.find(d => d.appUpsEcoCode === 'Z6'),
            'Z7': upsEcoData.find(d => d.appUpsEcoCode === 'Z7'),
            'Z8': upsEcoData.find(d => d.appUpsEcoCode === 'Z8'),
            'Z9': upsEcoData.find(d => d.appUpsEcoCode === 'Z9'),
            'Z0': upsEcoData.find(d => d.appUpsEcoCode === 'Z0')
        };

        const addBorders = (range) => {
            const [startCell, endCell] = range.split(':');
            const [startCol, startRow] = startCell.match(/[A-Z]+|[0-9]+/g);
            const [endCol, endRow] = endCell.match(/[A-Z]+|[0-9]+/g);

            for (let row = parseInt(startRow); row <= parseInt(endRow); row++) {
                for (let col = startCol.charCodeAt(0); col <= endCol.charCodeAt(0); col++) {
                    const cell = sheetOne.getCell(String.fromCharCode(col) + row);
                    cell.border = {
                        top: { style: 'thin', color: { argb: '000000' } },
                        left: { style: 'thin', color: { argb: '000000' } },
                        bottom: { style: 'thin', color: { argb: '000000' } },
                        right: { style: 'thin', color: { argb: '000000' } }
                    };
                }
            }
        };

        addBorders('B3:C4');
        addBorders('D3:L4');

        weightKeys.forEach((key, i) => {
            const rowIdx = 7 + i;
            zones.forEach((zone, j) => {
                const cell = sheetOne.getCell(rowIdx, j + 3);
                cell.value = zoneMap[zone]?.[key] ?? '';
                cell.alignment = { horizontal: 'center' };
            });
        });

        const titleRow = sheetOne.getRow(2);
        titleRow.getCell(2).value = '운임표는 각 배송사 측의 유류할증료 및 기타서비스 수수료가 제외된 금액입니다. (Shipping rates exclude fuel surcharges and other service fees from each carrier)';
        titleRow.font = { name: '맑은 고딕', size: 10 };
        titleRow.alignment = { horizontal: 'left', vertical: 'middle' };
        titleRow.height = 18;

        sheetOne.mergeCells('B3:C4');
        sheetOne.mergeCells('D3:L4');
        sheetOne.getCell('D3').value = 'UPS-E Shipping Rate List';
        sheetOne.getCell('D3').font = { name: '맑은 고딕', size: 16, bold: true };
        sheetOne.getCell('D3').alignment = { horizontal: 'center', vertical: 'middle' };
        sheetOne.getCell('D3').fill = {
            type: 'pattern', pattern: 'solid', fgColor: { argb: 'f8f8f8' }
        };

        // region Sheet2

        const memoSheet = workbook.addWorksheet('Zone Reference');

        const headers = ['Z1[Zone1]', 'Z2[Zone2]', 'Z3[Zone3]', 'Z4[Zone4]', 'Z5[Zone5]', 'Z6[Zone6]', 'Z7[Zone7]', 'Z8[Zone8]', 'Z9[Zone9]', 'Z0[Zone10]'];
        headers.forEach((header, index) => {
            const columnIndex = index + 1;
            memoSheet.getCell(1, columnIndex).value = header;
            memoSheet.getCell(1, columnIndex).alignment = { horizontal: 'center', vertical: 'middle' };
            memoSheet.getCell(1, columnIndex).font = { name: '맑은 고딕', size: 11, bold: true };
        });

        const rowData = [
            ['Singapore[SG]', 'Taiwan, China[TW]', 'Macau SAR, China[MO]'],
            ['Japan[JP]', 'Vietnam[VN]'],
            ['Indonesia[ID]', 'Thailand[TH]', 'Malaysia[MY]', 'Philippines[PH]'],
            ['New Zealand[NZ]', 'Australia[AU]', 'Norfolk Island[NF]', 'India[IN]'],
            ['United States[US]', 'Canada[CA]', 'Mexico[MX]'],
            ['United Kingdom[GB]', 'France[FR]', 'Germany[DE]', 'Spain[ES]', 'Netherlands[NL]', 'Poland[PL]', 'Luxembourg[LU]', 'Liechtenstein[LI]', 'Monaco[MC]', 'Vatican City[VA]', 'Belgium[BE]', 'San Marino[SM]', 'Sweden[SE]', 'Switzerland[CH]', 'Slovakia[SK]', 'Andorra[AD]', 'Italy[IT]', 'Czech Republic[CZ]'],
            ['Austria[AT]', 'Ireland[IE]', 'Greece[GR]', 'Norway[NO]', 'Denmark[DK]', 'Portugal[PT]', 'Finland[FI]'],
            ['Turkey[TR]', 'Russia[RU]', 'Laos[LA]', 'Chile[CL]', 'United Arab Emirates[AE]', 'Cambodia[KH]', 'Bangladesh[BD]', 'Saudi Arabia[SA]', 'Peru[PE]', 'Guadeloupe[GP]', 'Guatemala[GT]', 'Guam[GU]', 'Grenada[GD]', 'French Guiana[GF]', 'South Africa[ZA]', 'New Caledonia[NC]', 'Nicaragua[NI]', 'Dominican Republic[DO]', 'Dominica[DM]', 'Timor-Leste[TL]', 'Latvia[LV]', 'Romania[RO]', 'Lithuania[LT]', 'Martinique[MQ]', 'Marshall Islands[MH]', 'Montserrat[MS]', 'Maldives[MV]', 'Malta[MT]', 'Myanmar[MM]', 'Micronesia[FM]', 'Vanuatu[VU]', 'Bahrain[BH]', 'Barbados[BB]', 'Bahamas[BS]', 'St. Croix (Virgin Islands)[VI]', 'Virgin Gorda[VG]', 'Venezuela[VE]', 'Belize[BZ]', 'Botswana[BW]', 'Bolivia[BO]', 'Bhutan[BT]', 'Bulgaria[BG]', 'Brazil[BR]', 'Samoa[WS]', 'American Samoa[AS]', 'Cyprus[CY]', 'St. Lucia[LC]', 'St. Vincent & the Grenadines[VC]', 'St. Kitts and Nevis[KN]', 'Solomon Islands[SB]', 'Suriname[SR]', 'Sri Lanka[LK]', 'Slovenia[SI]', 'Aruba[AW]', 'Argentina[AR]', 'Iceland[IS]', 'El Salvador[SV]', 'Azerbaijan[AZ]', 'Antigua and Barbuda[AG]', 'Anguilla[AI]', 'Eritrea[ER]', 'Ecuador[EC]', 'Oman[OM]', 'Honduras[HN]', 'Wallis & Futuna Islands[WF]', 'Uruguay[UY]', 'Ukraine[UA]', 'Egypt[EG]', 'Jamaica[JM]', 'Gibraltar[GI]', 'Qatar[QA]', 'Costa Rica[CR]', 'Colombia[CO]', 'Kuwait[KW]', 'Croatia[HR]', 'Tonga[TO]', 'Panama[PA]', 'Paraguay[PY]', 'Pakistan[PK]', 'Papua New Guinea[PG]', 'Palau[PW]', 'Fiji[FJ]', 'Hungary[HU]'],
            ['Israel[IL]', 'Mongolia[MN]', 'Ghana[GH]', 'Gabon[GA]', 'Guyana[GY]', 'Gambia[GM]', 'Greenland[GL]', 'Guinea[GN]', 'Guinea-Bissau[GW]', 'Namibia[NA]', 'Nigeria[NG]', 'Nepal[NP]', 'Niger[NE]', 'Liberia[LR]', 'Lesotho[LS]', 'Reunion Island[RE]', 'Rwanda[RW]', 'Madagascar[MG]', 'Mayotte[YT]', 'Malawi[MW]', 'Mali[ML]', 'Morocco[MA]', 'Mauritius[MU]', 'Mauritania[MR]', 'Mozambique[MZ]', 'Montenegro[ME]', 'Moldova[MD]', 'Bermuda[BM]', 'Benin[BJ]', 'Belarus[BY]', 'Bosnia and Herzegovina[BA]', 'Burundi[BI]', 'Burkina Faso[BF]', 'Macedonia (FYROM)[MK]', 'Botswana[BW]', 'Northern Mariana Islands[MP]', 'Senegal[SN]', 'Serbia[RS]', 'Seychelles[SC]', 'Sierra Leone[SL]', 'Armenia[AM]', 'Afghanistan[AF]', 'Albania[AL]', 'Algeria[DZ]', 'Angola[AO]', 'Swaziland[SZ]', 'Estonia[EE]', 'Ethiopia[ET]', 'Jordan[JO]', 'Uganda[UG]', 'Uzbekistan[UZ]', 'Iraq[IQ]', 'Zambia[ZM]', 'Central African Republic[CF]', 'Djibouti[DJ]', 'Zimbabwe[ZW]', 'Chad[TD]', 'Cameroon[CM]', 'Cape Verde[CV]', 'Kazakhstan[KZ]', 'Kenya[KE]', 'Cote d\'Ivoire (Ivory Coast)[CI]', 'Congo (Brazzaville)[CG]', 'Tanzania[TZ]', 'Togo[TG]', 'Tunisia[TN]'],
            ['Southern China Mainland[CN]', 'Hong Kong[HK]', 'Southern China Mainland[CN]']
        ];

        rowData.forEach((columnData, columnIndex) => {
            columnData.forEach((value, rowIndex) => {
                memoSheet.getCell(rowIndex + 2, columnIndex + 1).value = value;  // 데이터 입력
                memoSheet.getCell(rowIndex + 2, columnIndex + 1).alignment = { horizontal: 'center', vertical: 'middle' };
                memoSheet.getCell(rowIndex + 2, columnIndex + 1).font = { name: '맑은 고딕', size: 11 };
            });
        });

        const equalColumnWidth = 28;
        for (let i = 1; i <= headers.length; i++) {
            memoSheet.getColumn(i).width = equalColumnWidth;
        }

        // endregion Sheet2

        const response = await fetch(excelLogo);
        const imageBuffer = await response.arrayBuffer();
        const imageId = workbook.addImage({ buffer: imageBuffer, extension: 'png' });
        sheetOne.addImage(imageId, { tl: { col: 1, row: 2 }, ext: { width: 168, height: 40 }, editAs: 'oneCell' });

        workbook.xlsx.writeBuffer().then((data) => {
            const blob = new Blob([data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            const url = window.URL.createObjectURL(blob);
            const anchor = document.createElement('a');
            anchor.href = url;
            anchor.download = `Btorage 요금표[UPS-E].xlsx`;
            anchor.click();
            window.URL.revokeObjectURL(url);
        });
    }

    const excelDownEMS = async () => {
        const workbook = new excel.Workbook();
        const sheet = workbook.addWorksheet("EMS");

        sheet.columns = [
            { header: "", width: 0.5 },
            { header: "", width: 18, style: { alignment: { horizontal: "center" } } },
            ...Array(64).fill({ width: 10, style: { alignment: { horizontal: "center" } } })
        ];

        const weightKeys = [...Array(7)].map((_, i) => 500 + i * 250)
            .concat([...Array(56)].map((_, i) => 2500 + i * 500));

        const headerRow = sheet.getRow(6);
        headerRow.values = ["", "Country", ...weightKeys.map(w => `${w}g`)];
        headerRow.font = { name: "맑은 고딕", bold: true, size: 11 };
        headerRow.alignment = { horizontal: "center", vertical: "middle" };
        headerRow.height = 20;
        headerRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
            if (colNumber > 1) {
                cell.fill = {
                    type: "pattern",
                    pattern: "solid",
                    fgColor: { argb: "ebf8fc" }
                };
                cell.border = {
                    top: { style: "thin", color: { argb: "000000" } },
                    left: { style: "thin", color: { argb: "000000" } },
                    bottom: { style: "thin", color: { argb: "000000" } },
                    right: { style: "thin", color: { argb: "000000" } }
                };
            }
        });

        const countryCodeMap = {
            'New Zealand': 'NZ',
            'Taiwan': 'TW',
            'Germany': 'DE',
            'Russia': 'RU',
            'Malaysia': 'MY',
            'United States': 'US',
            'Vietnam': 'VN',
            'Brazil': 'BR',
            'Spain': 'ES',
            'Singapore': 'SG',
            'United Kingdom': 'GB',
            'Indonesia': 'ID',
            'Japan': 'JP',
            'China': 'CN',
            'Canada': 'CA',
            'Thailand': 'TH',
            'France': 'FR',
            'Philippines': 'PH',
            'Australia': 'AU',
            'Hong Kong': 'HK',
            'Zone 1': 'LA',
            'Zone 2': 'BD',
            'Zone 3': 'IL',
            'Zone 4': 'MX'
        };

        const countryOrder = [
            'New Zealand', 'Taiwan', 'Germany', 'Russia', 'Malaysia', 'United States',
            'Vietnam', 'Brazil', 'Spain', 'Singapore', 'United Kingdom', 'Indonesia',
            'Japan', 'China', 'Canada', 'Thailand', 'France', 'Philippines',
            'Australia', 'Hong Kong', 'Zone 1', 'Zone 2', 'Zone 3', 'Zone 4'
        ];

        countryOrder.forEach((name, idx) => {
            const row = sheet.getRow(7 + idx);
            row.getCell(2).value = name;
            row.getCell(2).alignment = { horizontal: "center" };

            const countryCode = countryCodeMap[name];
            const matched = emsData.find(d => d.countryDTO?.countryCode === countryCode);

            weightKeys.forEach((key, i) => {
                const cell = row.getCell(i + 3);
                cell.value = matched?.[`w${key}`] ?? '';
                cell.alignment = { horizontal: "center" };
            });
        });

        const titleRow = sheet.getRow(2);
        titleRow.getCell(2).value = "운임표는 각 배송사 측의 유류할증료 및 기타서비스 수수료가 제외된 금액입니다. (Shipping rates exclude fuel surcharges and other service fees from each carrier)";
        titleRow.font = { name: "맑은 고딕", size: 10 };
        titleRow.alignment = { horizontal: "left", vertical: "middle" };
        titleRow.height = 18;

        sheet.getRow(1).height = 3;
        sheet.getRow(3).values = [];
        sheet.getRow(4).values = [];
        sheet.getRow(5).height = 3;

        sheet.mergeCells("B3:C4");
        sheet.mergeCells("D3:V4");
        const cell = sheet.getCell("D3");
        cell.value = "EMS Shipping Rate List";
        cell.font = { name: "맑은 고딕", size: 16, bold: true };
        cell.alignment = { horizontal: "center", vertical: "middle" };
        cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "f8f8f8" } };

        const response = await fetch(excelLogo);
        const buffer = await response.arrayBuffer();
        const imageId = workbook.addImage({ buffer, extension: "png" });
        sheet.addImage(imageId, {
            tl: { col: 1, row: 2 },
            ext: { width: 168, height: 40 },
            editAs: "oneCell"
        });

        // region Sheet2

        const memoSheet = workbook.addWorksheet('Zone Reference');

        const headers = ['Z1[Zone1]', 'Z2[Zone2]', 'Z3[Zone3]', 'Z4[Zone4]'];
        headers.forEach((header, index) => {
            const columnIndex = index + 1;
            memoSheet.getCell(1, columnIndex).value = header;
            memoSheet.getCell(1, columnIndex).alignment = { horizontal: 'center', vertical: 'middle' };
            memoSheet.getCell(1, columnIndex).font = { name: '맑은 고딕', size: 11, bold: true };
        });

        const rowData = [
            ["Laos[LA]", "Macau[MO]", "Cambodia[KH]", "Myanmar[MM]", "Mongolia[MN]"],
            ["Bangladesh[BD]", "Brunei[BN]", "India[IN]", "Nepal[NP]", "Sri Lanka[LK]", "Maldives[MV]", "Bhutan[BT]"],
            [
                "Belgium[BE]", "Denmark[DK]", "Finland[FI]", "Norway[NO]", "Portugal[PT]", "Switzerland[CH]", "Sweden[SE]",
                "Austria[AT]", "Romania[RO]", "Poland[PL]", "Hungary[HU]", "Czech Republic[CZ]", "Bahrain[BH]", "Iran[IR]",
                "Iraq[IQ]", "Israel[IL]", "Jordan[JO]", "Türkiye[TR]", "Kuwait[KW]", "Saudi Arabia[SA]", "Qatar[QA]", "Syria[SY]",
                "Papua New Guinea[PG]", "Guam[GU]", "Afghanistan[AF]", "United Arab Emirates[AE]"
            ],
            [
                "Egypt[EG]", "Kenya[KE]", "Libya[LY]", "Mexico[MX]", "Panama[PA]", "Argentina[AR]", "Uruguay[UY]",
                "Peru[PE]", "Cuba[CU]", "Haiti[HT]", "Dominican Republic[DO]"
            ]
        ];

        rowData.forEach((columnData, columnIndex) => {
            columnData.forEach((value, rowIndex) => {
                memoSheet.getCell(rowIndex + 2, columnIndex + 1).value = value;  // 데이터 입력
                memoSheet.getCell(rowIndex + 2, columnIndex + 1).alignment = { horizontal: 'center', vertical: 'middle' };
                memoSheet.getCell(rowIndex + 2, columnIndex + 1).font = { name: '맑은 고딕', size: 11 };
            });
        });

        const equalColumnWidth = 28;
        for (let i = 1; i <= headers.length; i++) {
            memoSheet.getColumn(i).width = equalColumnWidth;
        }

        // endregion Sheet2

        const xlsx = await workbook.xlsx.writeBuffer();
        const blob = new Blob([xlsx], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "Btorage 요금표[EMS].xlsx";
        a.click();
        window.URL.revokeObjectURL(url);
    };

    const excelDownEMSP = async () => {
        const workbook = new excel.Workbook();
        const sheetOne = workbook.addWorksheet('EMSP');

        sheetOne.columns = [
            { header: '', width: 0.5 }, // A
            { header: '', width: 12, style: { alignment: { horizontal: 'center' } } }, // B
            ...Array(6).fill({ width: 10, style: { alignment: { horizontal: 'center' } } }) // C ~ H (Z1~Z5)
        ];

        const zones = ['Z1', 'Z2', 'Z3', 'Z4', 'ZR', 'Z5'];
        const headerRow = sheetOne.getRow(6);
        zones.forEach((zone, index) => {
            headerRow.getCell(index + 3).value = zone;
        });
        sheetOne.getRow(1).height = 3;
        sheetOne.getRow(5).height = 3;
        headerRow.values = ['', 'weight(kg)', 'Z1', 'Z2', 'Z3', 'Z4', 'ZR', 'Z5'];
        headerRow.font = { name: '맑은 고딕', bold: true, size: 11 };
        headerRow.alignment = { horizontal: 'center', vertical: 'middle' };
        headerRow.height = 20;
        headerRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
            if (colNumber > 1) {
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'ebf8fc' }
                };
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' }
                };
            }
        });

        const weights = [...Array(40)].map((_, i) => (i + 1) * 0.5)
            .concat([...Array(50)].map((_, i) => i + 21));

        weights.forEach((w, i) => {
            const rowIdx = i + 7;
            sheetOne.getRow(rowIdx).getCell(2).value = w;
            sheetOne.getRow(rowIdx).getCell(2).alignment = { horizontal: 'center' };
        });

        const weightKeys = weights.map(w => `w${w * 1000}`.replace('.0', ''));
        const zoneMap = {
            'Z1': emsPreData.find(d => d.appEmsPreCode === 'Z1'),
            'Z2': emsPreData.find(d => d.appEmsPreCode === 'Z2'),
            'Z3': emsPreData.find(d => d.appEmsPreCode === 'Z3'),
            'Z4': emsPreData.find(d => d.appEmsPreCode === 'Z4'),
            'ZR': emsPreData.find(d => d.appEmsPreCode === 'ZR'),
            'Z5': emsPreData.find(d => d.appEmsPreCode === 'Z5')
        };

        const addBorders = (range) => {
            const [startCell, endCell] = range.split(':');
            const [startCol, startRow] = startCell.match(/[A-Z]+|[0-9]+/g);
            const [endCol, endRow] = endCell.match(/[A-Z]+|[0-9]+/g);

            for (let row = parseInt(startRow); row <= parseInt(endRow); row++) {
                for (let col = startCol.charCodeAt(0); col <= endCol.charCodeAt(0); col++) {
                    const cell = sheetOne.getCell(String.fromCharCode(col) + row);
                    cell.border = {
                        top: { style: 'thin', color: { argb: '000000' } },
                        left: { style: 'thin', color: { argb: '000000' } },
                        bottom: { style: 'thin', color: { argb: '000000' } },
                        right: { style: 'thin', color: { argb: '000000' } }
                    };
                }
            }
        };

        addBorders('B3:C4');
        addBorders('D3:H4');

        weightKeys.forEach((key, i) => {
            const rowIdx = 7 + i;
            zones.forEach((zone, j) => {
                const cell = sheetOne.getCell(rowIdx, j + 3);
                cell.value = zoneMap[zone]?.[key] ?? '';
                cell.alignment = { horizontal: 'center' };
            });
        });

        const titleRow = sheetOne.getRow(2);
        titleRow.getCell(2).value = '운임표는 각 배송사 측의 유류할증료 및 기타서비스 수수료가 제외된 금액입니다. (Shipping rates exclude fuel surcharges and other service fees from each carrier)';
        titleRow.font = { name: '맑은 고딕', size: 10 };
        titleRow.alignment = { horizontal: 'left', vertical: 'middle' };
        titleRow.height = 18;

        sheetOne.mergeCells('B3:C4');
        sheetOne.mergeCells('D3:H4');
        sheetOne.getCell('D3').value = 'EMSP Shipping Rate List';
        sheetOne.getCell('D3').font = { name: '맑은 고딕', size: 16, bold: true };
        sheetOne.getCell('D3').alignment = { horizontal: 'center', vertical: 'middle' };
        sheetOne.getCell('D3').fill = {
            type: 'pattern', pattern: 'solid', fgColor: { argb: 'f8f8f8' }
        };

        const response = await fetch(excelLogo);
        const imageBuffer = await response.arrayBuffer();
        const imageId = workbook.addImage({ buffer: imageBuffer, extension: 'png' });
        sheetOne.addImage(imageId, { tl: { col: 1, row: 2 }, ext: { width: 168, height: 40 }, editAs: 'oneCell' });

        // region Sheet2

        const memoSheet = workbook.addWorksheet('Zone Reference');

        const headers = ['Z1[Zone1]', 'Z2[Zone2]', 'Z3[Zone3]', 'Z4[Zone4]', 'ZR[RU]', 'Z5[Zone5]'];
        headers.forEach((header, index) => {
            const columnIndex = index + 1;
            memoSheet.getCell(1, columnIndex).value = header;
            memoSheet.getCell(1, columnIndex).alignment = { horizontal: 'center', vertical: 'middle' };
            memoSheet.getCell(1, columnIndex).font = { name: '맑은 고딕', size: 11, bold: true };
        });

        const rowData = [
            // Z1
            ["China[CN]", "Hong Kong[HK]", "Macau[MO]", "Taiwan[TW]"],
            // Z2
            ["Brunei[BN]", "Cambodia[KH]", "Japan[JP]", "Laos[LA]", "Malaysia[MY]", "Singapore[SG]", "Thailand[TH]", "Vietnam[VN]"],
            // Z3
            ["Albania[AL]", "Armenia[AM]", "Australia[AU]", "Austria[AT]", "Azerbaijan[AZ]", "Bahrain[BH]", "Belgium[BE]", "Bulgaria[BG]",
                "Bosnia and Herzegovina[BA]", "Canada[CA]", "Croatia[HR]", "Czech Republic[CZ]", "Denmark[DK]", "Greece[GR]", "Hungary[HU]",
                "Iceland[IS]", "India[IN]", "Indonesia[ID]", "Ireland[IE]", "Italy[IT]", "Latvia[LV]", "Luxembourg[LU]", "Maldives[MV]",
                "Moldova[MD]", "Mongolia[MN]", "Netherlands[NL]", "New Zealand[NZ]", "North Macedonia[MK]", "Norway[NO]", "Papua New Guinea[PG]",
                "Philippines[PH]", "Poland[PL]", "Portugal[PT]", "Romania[RO]", "Slovakia[SK]", "Slovenia[SI]", "Spain[ES]", "Sweden[SE]",
                "Switzerland[CH]", "Türkiye[TR]", "United States[US]", "United Arab Emirates[AE]", "United Kingdom[GB]", "Belarus[BY]", "Bhutan[BT]"],
            // Z4
            ["Algeria[DZ]", "Angola[AO]", "Bahamas[BS]", "Barbados[BB]", "Benin[BJ]", "Bermuda[BM]", "Bolivia[BO]", "Botswana[BW]",
                "Burkina Faso[BF]", "Cameroon[CM]", "Cape Verde[CV]", "Chad[TD]", "Chile[CL]", "Colombia[CO]", "Costa Rica[CR]", "Ivory Coast[CI]",
                "Djibouti[DJ]", "Egypt[EG]", "Eritrea[ER]", "Ethiopia[ET]", "Fiji[FJ]", "Guatemala[GT]", "Guyana[GY]", "Haiti[HT]", "Honduras[HN]",
                "El Salvador[SV]", "Israel[IL]", "Jamaica[JM]", "Jordan[JO]", "Kuwait[KW]", "Lesotho[LS]", "Liberia[LR]", "Mali[ML]", "Mexico[MX]",
                "Mozambique[MZ]", "Nicaragua[NI]", "Niger[NE]", "Nigeria[NG]", "Oman[OM]", "Pakistan[PK]", "Panama[PA]", "Paraguay[PY]", "Qatar[QA]",
                "Rwanda[RW]", "Tanzania[TZ]", "Togo[TG]", "Zambia[ZM]"],
            // ZR
            ["Russia[RU]"],
            // Z5
            ["Afghanistan[AF]", "Andorra[AD]", "Antigua and Barbuda[AG]", "Argentina[AR]", "Aruba[AW]", "Bangladesh[BD]", "Belize[BZ]", "Brazil[BR]",
                "Burundi[BI]", "Central African Republic[CF]", "Republic of the Congo[CG]", "Dominica[DM]", "Dominican Republic[DO]", "Timor-Leste[TL]",
                "Gabon[GA]", "Gambia[GM]", "Ghana[GH]", "Gibraltar[GI]", "Greenland[GL]", "Grenada[GD]", "Guadeloupe[GP]", "Guam[GU]", "French Guiana[GF]",
                "Guinea[GN]", "Guinea-Bissau[GW]", "Iraq[IQ]", "Kazakhstan[KZ]", "Kenya[KE]", "Eswatini[SZ]", "Kyrgyzstan[KG]", "Lebanon[LB]",
                "Liechtenstein[LI]", "Lithuania[LT]", "Madagascar[MG]", "Malawi[MW]", "Malta[MT]", "Northern Mariana Islands[MP]", "Martinique[MQ]",
                "Mauritania[MR]", "Mauritius[MU]", "Mayotte[YT]", "Micronesia[FM]", "Monaco[MC]", "Montserrat[MS]", "Morocco[MA]", "Namibia[NA]",
                "Nepal[NP]", "New Caledonia[NC]", "Norfolk Island[NF]", "Palau[PW]", "Peru[PE]", "South Africa[ZA]", "Réunion[RE]", "Montenegro[ME]",
                "Saint Kitts and Nevis[KN]", "Saint Lucia[LC]", "Saint Vincent and the Grenadines[VC]", "American Samoa[AS]", "San Marino[SM]",
                "Saudi Arabia[SA]", "Senegal[SN]", "Seychelles[SC]", "Sierra Leone[SL]", "Sri Lanka[LK]", "Suriname[SR]", "Serbia[RS]", "Tonga[TO]",
                "Tunisia[TN]", "Uganda[UG]", "Ukraine[UA]", "Uruguay[UY]", "Uzbekistan[UZ]", "Vanuatu[VU]", "Venezuela[VE]", "U.S. Virgin Islands[VI]",
                "British Virgin Islands[VG]", "Wallis and Futuna[WF]", "Samoa[WS]", "Zimbabwe[ZW]"]
        ];

        rowData.forEach((columnData, columnIndex) => {
            columnData.forEach((value, rowIndex) => {
                memoSheet.getCell(rowIndex + 2, columnIndex + 1).value = value;  // 데이터 입력
                memoSheet.getCell(rowIndex + 2, columnIndex + 1).alignment = { horizontal: 'center', vertical: 'middle' };
                memoSheet.getCell(rowIndex + 2, columnIndex + 1).font = { name: '맑은 고딕', size: 11 };
            });
        });

        const equalColumnWidth = 28;
        for (let i = 1; i <= headers.length; i++) {
            memoSheet.getColumn(i).width = equalColumnWidth;
        }

        // endregion Sheet2

        workbook.xlsx.writeBuffer().then((data) => {
            const blob = new Blob([data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            const url = window.URL.createObjectURL(blob);
            const anchor = document.createElement('a');
            anchor.href = url;
            anchor.download = `Btorage 요금표[EMSP].xlsx`;
            anchor.click();
            window.URL.revokeObjectURL(url);
        });
    };

    const excelDownSHIP = async () => {
        const workbook = new excel.Workbook();
        const sheetOne = workbook.addWorksheet('SEA');

        // 열 너비 설정
        sheetOne.columns = [
            { header: '', width: 0.5 }, // A
            { header: '', width: 13, style: { alignment: { horizontal: 'center' } } }, // B
            ...Array(11).fill({ header: '', width: 10, style: { alignment: { horizontal: 'center' } } }) // C~M
        ];

        // 안내 문구 (Row 2)
        const headerRowTitle = sheetOne.getRow(2);
        headerRowTitle.values = [
            '운임표는 각 배송사 측의 유류할증료 및 기타서비스 수수료가 제외된 금액입니다. (Shipping rates exclude fuel surcharges and other service fees from each carrier)'
        ];
        headerRowTitle.font = { name: '맑은 고딕', size: 10 };
        headerRowTitle.alignment = { horizontal: 'left', vertical: 'middle' };
        headerRowTitle.height = 18;

        // 헤더 (Row 6)
        const headerRow = sheetOne.getRow(6);
        headerRow.values = [
            '',
            'Zone',
            '1000g', '2000g', '4000g', '6000g', '8000g',
            '10000g', '12000g', '14000g', '16000g', '18000g', '20000g'
        ];
        headerRow.font = { name: '맑은 고딕', bold: true, size: 11 };
        headerRow.alignment = { horizontal: 'center', vertical: 'middle' };
        headerRow.height = 20;

        // 공백 정리
        sheetOne.getRow(1).height = 3;
        sheetOne.getRow(3).values = [];
        sheetOne.getRow(4).values = [];
        sheetOne.getRow(5).height = 3;

        // 이미지 삽입
        const response = await fetch(excelLogo);
        const imageBuffer = await response.arrayBuffer();
        const imageId = workbook.addImage({ buffer: imageBuffer, extension: 'png' });
        sheetOne.addImage(imageId, {
            tl: { col: 1, row: 2 },
            ext: { width: 168, height: 40 },
            editAs: 'oneCell'
        });

        // 병합 셀
        const mergeCells = [
            { range: 'B3:C4' },
            { range: 'D3:M4', fillColor: 'f8f8f8', fontSize: 16, fontBold: true }
        ];
        mergeCells.forEach(({ range, fillColor, fontColor, fontSize, fontBold }) => {
            sheetOne.mergeCells(range);
            const firstCell = sheetOne.getCell(range.split(':')[0]);
            firstCell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: fillColor }
            };
            firstCell.font = {
                name: '맑은 고딕',
                color: { argb: fontColor ?? '000000' },
                size: fontSize ?? 11,
                bold: fontBold ?? false
            };
            firstCell.alignment = { horizontal: 'center', vertical: 'middle' };
            if (range === 'D3:M4') firstCell.value = 'SEA Shipping Rate List';
        });

        // 헤더 스타일 테두리
        sheetOne.getRow(6).eachCell({ includeEmpty: true }, (cell, colNumber) => {
            if (colNumber !== 1) {
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'ebf8fc' }
                };
                cell.border = {
                    top: { style: 'thin', color: { argb: '000000' } },
                    left: { style: 'thin', color: { argb: '000000' } },
                    bottom: { style: 'thin', color: { argb: '000000' } },
                    right: { style: 'thin', color: { argb: '000000' } }
                };
            }
        });

        // 테두리 유틸
        const addBorders = (range) => {
            const [startCell, endCell] = range.split(':');
            const [startCol, startRow] = startCell.match(/[A-Z]+|[0-9]+/g);
            const [endCol, endRow] = endCell.match(/[A-Z]+|[0-9]+/g);

            for (let row = parseInt(startRow); row <= parseInt(endRow); row++) {
                for (let col = startCol.charCodeAt(0); col <= endCol.charCodeAt(0); col++) {
                    const cell = sheetOne.getCell(String.fromCharCode(col) + row);
                    cell.border = {
                        top: { style: 'thin', color: { argb: '000000' } },
                        left: { style: 'thin', color: { argb: '000000' } },
                        bottom: { style: 'thin', color: { argb: '000000' } },
                        right: { style: 'thin', color: { argb: '000000' } }
                    };
                }
            }
        };

        addBorders('B3:C4');
        addBorders('D3:M4');

        // Zone → Row 매핑
        const zoneRowMap = { Z1: 7, Z2: 8, Z3: 9, Z4: 10 };
        const weightKeys = [
            'w1000', 'w2000', 'w4000', 'w6000', 'w8000',
            'w10000', 'w12000', 'w14000', 'w16000', 'w18000', 'w20000'
        ];

        // 데이터 삽입
        shipData.forEach(data => {
            const rowIdx = zoneRowMap[data.appShipCode];
            if (!rowIdx) return;

            // B열 = Zone명
            sheetOne.getCell(`B${rowIdx}`).value = data.appShipCode;
            sheetOne.getCell(`B${rowIdx}`).alignment = { horizontal: 'center' };

            // C~M 요금 데이터
            weightKeys.forEach((key, i) => {
                const cell = sheetOne.getCell(rowIdx, 3 + i);
                cell.value = data[key] ?? '';
                cell.alignment = { horizontal: 'center' };
            });
        });

        // Sheet2 (Zone Reference)
        const memoSheet = workbook.addWorksheet('Zone Reference');
        const headers = ['Zone 1', 'Zone 2', 'Zone 3', 'Zone 4'];
        headers.forEach((header, index) => {
            memoSheet.getCell(1, index + 1).value = header;
            memoSheet.getCell(1, index + 1).alignment = { horizontal: 'center', vertical: 'middle' };
            memoSheet.getCell(1, index + 1).font = { name: '맑은 고딕', size: 11, bold: true };
        });

        const rowData = [
            ['China[CN]', 'Hong Kong[HK]', 'Japan[JP]', 'Taiwan[TW]'],
            ['Bangladesh[BD]', 'Indonesia[ID]', 'Malaysia[MY]', 'Philippines[PH]', 'Singapore[SG]', 'Thailand[TH]', 'Vietnam[VN]'],
            ['Australia[AU]', 'Canada[CA]', 'Finland[FI]', 'France[FR]', 'Germany[DE]', 'India[IN]', 'Ireland[IE]', 'Netherlands[NL]', 'Norway[NO]', 'Poland[PL]', 'Russian Federation[RU]', 'Spain[ES]', 'Sweden[SE]', 'United States[US]', 'United Kingdom[GB]'],
            // ['Peru[PE]', 'Chile[CL]', 'Brazil[BZ]', 'South Africa[ZA]', 'Mexico[MX]']
            ['Brazil[BZ]', 'South Africa[ZA]']
        ];
        rowData.forEach((colData, colIdx) => {
            colData.forEach((val, rowIdx) => {
                const cell = memoSheet.getCell(rowIdx + 2, colIdx + 1);
                cell.value = val;
                cell.alignment = { horizontal: 'center', vertical: 'middle' };
                cell.font = { name: '맑은 고딕', size: 11 };
            });
        });
        for (let i = 1; i <= headers.length; i++) {
            memoSheet.getColumn(i).width = 28;
        }

        // 다운로드
        workbook.xlsx.writeBuffer().then((data) => {
            const blob = new Blob([data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });
            const url = window.URL.createObjectURL(blob);
            const anchor = document.createElement('a');
            anchor.href = url;
            anchor.download = `Btorage 요금표[SEA].xlsx`;
            anchor.click();
            window.URL.revokeObjectURL(url);
        });
    };

    const excelDownKP = async () => {
        const workbook = new excel.Workbook();
        const sheetOne = workbook.addWorksheet('K-Packet');

        const countries = [
            'Australia', 'Brazil', 'Canada', 'China', 'France', 'Germany', 'Hong Kong', 'Indonesia',
            'Japan', 'Malaysia', 'New Zealand', 'Philippines', 'Singapore', 'Spain', 'Taiwan',
            'Thailand', 'United Kingdom', 'United States', 'Vietnam'
        ];

        const weightKeys = [
            'w100', 'w200', 'w300', 'w400', 'w500', 'w600', 'w700', 'w800', 'w900', 'w1000',
            'w1100', 'w1200', 'w1300', 'w1400', 'w1500', 'w1600', 'w1700', 'w1800', 'w1900', 'w2000'
        ];

        sheetOne.columns = [
            { header: '', width: 0.5 }, // A
            { header: '', width: 11, style: { alignment: { horizontal: 'center' } } }, // B
            ...Array(countries.length).fill({ width: 15, style: { alignment: { horizontal: 'center' } } }) // C~
        ];

        const headerRowTitle = sheetOne.getRow(2);
        headerRowTitle.values = [
            '운임표는 각 배송사 측의 유류할증료 및 기타서비스 수수료가 제외된 금액입니다. (Shipping rates exclude fuel surcharges and other service fees from each carrier)'
        ];
        headerRowTitle.font = { name: '맑은 고딕', size: 10 };
        headerRowTitle.alignment = { horizontal: 'left', vertical: 'middle' };
        headerRowTitle.height = 18;

        const headerRow = sheetOne.getRow(6);
        headerRow.values = ['', 'Weight(g)', ...countries];
        headerRow.font = { name: '맑은 고딕', bold: true, size: 11 };
        headerRow.alignment = { horizontal: 'center', vertical: 'middle' };
        headerRow.height = 20;

        sheetOne.getRow(1).height = 3;
        sheetOne.getRow(3).values = [];
        sheetOne.getRow(4).values = [];
        sheetOne.getRow(5).height = 3;

        const response = await fetch(excelLogo);
        const imageBuffer = await response.arrayBuffer();
        const imageId = workbook.addImage({
            buffer: imageBuffer,
            extension: 'png',
        });
        sheetOne.addImage(imageId, {
            tl: { col: 1, row: 2 },
            ext: { width: 168, height: 40 },
            editAs: 'oneCell'
        });

        const mergeCells = [
            { range: 'B3:C4' },
            { range: `D3:${String.fromCharCode(67 + countries.length - 1)}4`, fillColor: 'f8f8f8', fontSize: 16, fontBold: true }
        ];
        mergeCells.forEach(({ range, fillColor, fontColor, fontSize, fontBold }) => {
            sheetOne.mergeCells(range);
            const firstCell = sheetOne.getCell(range.split(':')[0]);
            firstCell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: fillColor }
            };
            firstCell.font = {
                name: '맑은 고딕',
                color: { argb: fontColor ?? '000000' },
                size: fontSize ?? 11,
                bold: fontBold ?? false
            };
            firstCell.alignment = { horizontal: 'center', vertical: 'middle' };
            if (firstCell.address.startsWith('D3')) {
                firstCell.value = 'K-Packet Shipping Rate List';
            }
        });

        sheetOne.getRow(6).eachCell({ includeEmpty: true }, (cell, colNumber) => {
            if (colNumber !== 1) {
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'ebf8fc' }
                };
                cell.border = {
                    top: { style: 'thin', color: { argb: '000000' } },
                    left: { style: 'thin', color: { argb: '000000' } },
                    bottom: { style: 'thin', color: { argb: '000000' } },
                    right: { style: 'thin', color: { argb: '000000' } }
                };
            }
        });

        const addBorders = (range) => {
            const [startCell, endCell] = range.split(':');
            const [startCol, startRow] = startCell.match(/[A-Z]+|[0-9]+/g);
            const [endCol, endRow] = endCell.match(/[A-Z]+|[0-9]+/g);
            for (let row = parseInt(startRow); row <= parseInt(endRow); row++) {
                for (let col = startCol.charCodeAt(0); col <= endCol.charCodeAt(0); col++) {
                    const cell = sheetOne.getCell(String.fromCharCode(col) + row);
                    cell.border = {
                        top: { style: 'thin', color: { argb: '000000' } },
                        left: { style: 'thin', color: { argb: '000000' } },
                        bottom: { style: 'thin', color: { argb: '000000' } },
                        right: { style: 'thin', color: { argb: '000000' } }
                    };
                }
            }
        };

        addBorders('B3:C4');
        addBorders(`D3:${String.fromCharCode(67 + countries.length - 1)}4`);

        const countryAliasMap = {
            'Canada': 'Canada',
            'Philippines': 'Pilipinas',
            'United Kingdom': 'UK',
            'United States': 'United States of America',
            'Hong Kong': 'HongKong',
            'New Zealand': 'NewZealand',
            'Taiwan': 'Taiwan',
        };

        const orderedKpackData = countries.map(country => {
            const matchTarget = countryAliasMap[country] ?? country;
            return kpackData.find(d =>
                d.countryDTO.countryEngNm?.toLowerCase().replace(/\s/g, '') === matchTarget.toLowerCase().replace(/\s/g, '')
            ) ?? {};
        });

        weightKeys.forEach((key, i) => {
            const rowIdx = 7 + i;
            const row = sheetOne.getRow(rowIdx);

            row.getCell(2).value = key.replace('w', '');
            row.getCell(2).alignment = { horizontal: 'center' };

            orderedKpackData.forEach((data, j) => {
                const cell = sheetOne.getCell(rowIdx, 3 + j);
                cell.value = typeof data[key] !== 'undefined' ? data[key] : '';
                cell.alignment = { horizontal: 'center' };
            });
        });

        workbook.xlsx.writeBuffer().then((data) => {
            const blob = new Blob([data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });
            const url = window.URL.createObjectURL(blob);
            const anchor = document.createElement('a');
            anchor.href = url;
            anchor.download = `Btorage 요금표[K-Packet].xlsx`;
            anchor.click();
            window.URL.revokeObjectURL(url);
        });
    };

    const excelDownAS = async () => {
        const workbook = new excel.Workbook();
        const sheetOne = workbook.addWorksheet('SmallAir');

        sheetOne.columns = [
            { header: '', width: 0.5 },
            { header: '', width: 13, style: { alignment: { horizontal: 'center' } } },
            ...Array(20).fill({ width: 10, style: { alignment: { horizontal: 'center' } } })
        ];

        const zones = ['Zone 1', 'Zone 2', 'Zone 3', 'Zone 4', 'Zone 5'];
        zones.forEach((zone, i) => {
            const row = 7 + i;
            sheetOne.getCell(`B${row}`).value = zone;
            sheetOne.getCell(`B${row}`).alignment = { horizontal: 'center' };
        });

        const headerRowTitle = sheetOne.getRow(2);
        headerRowTitle.values = ['운임표는 각 배송사 측의 유류할증료 및 기타서비스 수수료가 제외된 금액입니다. (Shipping rates exclude fuel surcharges and other service fees from each carrier)'];
        headerRowTitle.font = { name: '맑은 고딕', size: 10 };
        headerRowTitle.alignment = { horizontal: 'left', vertical: 'middle' };
        headerRowTitle.height = 18;

        const headerRow = sheetOne.getRow(6);
        headerRow.values = [
            '',
            'Zone',
            '100g', '200g', '300g', '400g', '500g',
            '600g', '700g', '800g', '900g', '1000g',
            '1100g', '1200g', '1300g', '1400g', '1500g',
            '1600g', '1700g', '1800g', '1900g', '2000g'
        ];
        headerRow.font = { name: '맑은 고딕', bold: true, size: 11 };
        headerRow.alignment = { horizontal: 'center', vertical: 'middle' };
        headerRow.height = 20;

        sheetOne.getRow(1).height = 3;
        sheetOne.getRow(3).values = [];
        sheetOne.getRow(4).values = [];
        sheetOne.getRow(5).height = 3;

        const response = await fetch(excelLogo);
        const imageBuffer = await response.arrayBuffer();
        const imageId = workbook.addImage({
            buffer: imageBuffer,
            extension: 'png',
        });
        sheetOne.addImage(imageId, {
            tl: { col: 1, row: 2 },
            ext: { width: 168, height: 40 },
            editAs: 'oneCell'
        });

        const mergeCells = [
            { range: 'B3:C4' },
            { range: 'D3:V4', fillColor: 'f8f8f8', fontSize: 16, fontBold: true }
        ];
        mergeCells.forEach(({ range, fillColor, fontColor, fontSize, fontBold }) => {
            sheetOne.mergeCells(range);
            const firstCell = sheetOne.getCell(range.split(':')[0]);
            firstCell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: fillColor }
            };
            firstCell.font = {
                name: '맑은 고딕',
                color: { argb: fontColor ?? '000000' },
                size: fontSize ?? 11,
                bold: fontBold ?? false
            };
            firstCell.alignment = { horizontal: 'center', vertical: 'middle' };
            if (range === 'D3:V4') {
                firstCell.value = 'SmallAir Shipping Rate List';
            }
        });

        sheetOne.getRow(6).eachCell({ includeEmpty: true }, (cell, colNumber) => {
            if (colNumber !== 1) {
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'ebf8fc' }
                };
                cell.border = {
                    top: { style: 'thin', color: { argb: '000000' } },
                    left: { style: 'thin', color: { argb: '000000' } },
                    bottom: { style: 'thin', color: { argb: '000000' } },
                    right: { style: 'thin', color: { argb: '000000' } }
                };
            }
        });

        const addBorders = (range) => {
            const [startCell, endCell] = range.split(':');
            const [startCol, startRow] = startCell.match(/[A-Z]+|[0-9]+/g);
            const [endCol, endRow] = endCell.match(/[A-Z]+|[0-9]+/g);

            for (let row = parseInt(startRow); row <= parseInt(endRow); row++) {
                for (let col = startCol.charCodeAt(0); col <= endCol.charCodeAt(0); col++) {
                    const cell = sheetOne.getCell(String.fromCharCode(col) + row);
                    cell.border = {
                        top: { style: 'thin', color: { argb: '000000' } },
                        left: { style: 'thin', color: { argb: '000000' } },
                        bottom: { style: 'thin', color: { argb: '000000' } },
                        right: { style: 'thin', color: { argb: '000000' } }
                    };
                }
            }
        };
        addBorders('B3:C4');
        addBorders('D3:V4');

        const weightKeys = [
            'w100', 'w200', 'w300', 'w400', 'w500', 'w600', 'w700', 'w800', 'w900', 'w1000',
            'w1100', 'w1200', 'w1300', 'w1400', 'w1500', 'w1600', 'w1700', 'w1800', 'w1900', 'w2000'
        ];

        const zoneRowMap = {
            'Z1': 7,
            'Z2': 8,
            'Z3': 9,
            'Z4': 10,
            'Z5': 11
        };

        const columnStart = 'C'.charCodeAt(0);

        airSData.forEach((data) => {
            const row = zoneRowMap[data.appAsCode];
            if (!row) {
                console.warn(`존재하지 않는 zone code: ${data.appAsCode}`);
                return;
            }

            weightKeys.forEach((key, idx) => {
                const col = String.fromCharCode(columnStart + idx);
                sheetOne.getCell(`${col}${row}`).value = data[key] ?? '';
                sheetOne.getCell(`${col}${row}`).alignment = { horizontal: 'center' };
            });
        });

        const memoSheet = workbook.addWorksheet('Zone Reference');

        const headers = ['Zone 1', 'Zone 2', 'Zone 3', 'Zone 4', 'Zone 5'];
        headers.forEach((header, index) => {
            const columnIndex = index + 1;
            memoSheet.getCell(1, columnIndex).value = header;
            memoSheet.getCell(1, columnIndex).alignment = { horizontal: 'center', vertical: 'middle' };
            memoSheet.getCell(1, columnIndex).font = { name: '맑은 고딕', size: 11, bold: true };
        });

        const rowData = [
            /* Zone 1 */
            ['China[CN]', 'Hong Kong[HK]', 'Japan[JP]', 'Macau[MO]', 'Taiwan[TW]'],

            /* Zone 2 */
            ['Bangladesh[BD]', 'Brunei[BN]', 'Cambodia[KH]', 'East Timor[TL]', 'Indonesia[ID]', 'Laos[LA]', 'Malaysia[MY]', 'Mongolia[MN]', 'Myanmar[MM]', 'Philippines[PH]', 'Singapore[SG]', 'Thailand[TH]', 'Vietnam[VN]'],

            /* Zone 3 */
            ['Afghanistan[AF]', 'Albania[AL]', 'Andorra[AD]', 'Armenia[AM]', 'Australia[AU]', 'Austria[AT]', 'Azerbaijan[AZ]', 'Bahrain[BH]', 'Belarus[BY]', 'Belgium[BE]', 'Bhutan[BT]', 'Bulgaria[BG]', 'Bosnia and Herzegovina[BA]', 'Canada[CA]', 'Christmas Island[CX]', 'Cocos (Keeling) Islands[CC]', 'Croatia[HR]', 'Cyprus[CY]',
                'Czech Republic[CZ]', 'Denmark[DK]', 'Estonia[EE]', 'Finland[FI]', 'France[FR]', 'Georgia[GE]', 'Germany[DE]', 'Gibraltar[GI]', 'Greece[GR]', 'Greenland[GL]', 'Guam[GU]', 'Hungary[HU]', 'Iceland[IS]', 'Israel[IL]', 'Italy[IT]', 'Jordan[JO]', 'Kazakhstan[KZ]', 'Kuwait[KW]', 'Kyrgyzstan[KG]',
                'Latvia[LV]', 'Lebanon[LB]', 'Liechtenstein[LI]', 'Lithuania[LT]', 'Luxembourg[LU]', 'Maldives[MV]', 'Malta[MT]', 'Northern Mariana Islands[MP]', 'Moldova[MD]', 'Monaco[MC]', 'Nepal[NP]', 'Netherlands[NL]', 'New Zealand[NZ]', 'Niue[NU]', 'Norfolk Island[NF]', 'North Macedonia[MK]', 'Norway[NO]', 'Oman[OM]', 'Pakistan[PK]',
                'Papua New Guinea[PG]', 'Poland[PL]', 'Portugal[PT]', 'Qatar[QA]', 'Romania[RO]', 'Russia[RU]', 'Montenegro[ME]', 'San Marino[SM]', 'Saudi Arabia[SA]', 'Slovakia[SK]', 'Slovenia[SI]', 'Spain[ES]', 'Sri Lanka[LK]', 'Sweden[SE]', 'Switzerland[CH]', 'Serbia[RS]', 'Turkey[TR]', 'Ukraine[UA]', 'United Arab Emirates[AE]', 'United Kingdom[GB]', 'Uzbekistan[UZ]', 'Vatican City[VA]'],

            /* Zone 4 */
            ['Algeria[DZ]', 'Angola[AO]', 'Antigua and Barbuda[AG]', 'Argentina[AR]', 'Aruba[AW]', 'Bahamas[BS]', 'Barbados[BB]', 'Belize[BZ]', 'Benin[BJ]', 'Bermuda[BM]', 'Botswana[BW]', 'Brazil[BR]', 'Burkina Faso[BF]', 'Burundi[BI]', 'Cameroon[CM]', 'Cape Verde[CV]', 'Central African Republic[CF]', 'Chad[TD]', 'Chile[CL]', 'Colombia[CO]',
                'Congo (Brazzaville)[CG]', 'Costa Rica[CR]', 'Ivory Coast[CI]', 'Cuba[CU]', 'Djibouti[DJ]', 'Dominica[DM]', 'Dominican Republic[DO]', 'Congo (Kinshasa)[CD]', 'Egypt[EG]', 'Equatorial Guinea[GQ]', 'Eritrea[ER]', 'Ethiopia[ET]', 'Fiji[FJ]', 'France (Overseas)[FR-OM]', 'Gabon[GA]', 'Gambia[GM]', 'Ghana[GH]', 'Grenada[GD]', 'Guadeloupe[GP]',
                'Guatemala[GT]', 'French Guiana[GF]', 'Guinea[GN]', 'Guinea-Bissau[GW]', 'Guyana[GY]', 'Honduras[HN]', 'Jamaica[JM]', 'Kenya[KE]', 'Eswatini[SZ]', 'Lesotho[LS]', 'Liberia[LR]', 'Madagascar[MG]', 'Malawi[MW]', 'Mali[ML]', 'Martinique[MQ]', 'Mauritania[MR]', 'Mauritius[MU]', 'Mayotte[YT]', 'Mexico[MX]',
                'Micronesia[FM]', 'Montserrat[MS]', 'Morocco[MA]', 'Mozambique[MZ]', 'Namibia[NA]', 'Nauru[NR]', 'New Caledonia[NC]', 'Nicaragua[NI]', 'Niger[NE]', 'Nigeria[NG]', 'Palau[PW]', 'Peru[PE]', 'South Africa[ZA]', 'Réunion[RE]', 'Rwanda[RW]', 'Saint Kitts and Nevis[KN]', 'American Samoa[AS]', 'Sao Tome and Principe[ST]', 'Senegal[SN]',
                'Seychelles[SC]', 'Solomon Islands[SB]', 'Somalia[SO]', 'Sudan[SD]', 'Suriname[SR]', 'Tanzania[TZ]', 'Togo[TG]', 'Tonga[TO]', 'Tunisia[TN]', 'Uganda[UG]', 'Uruguay[UY]', 'Vanuatu[VU]', 'Venezuela[VE]', 'United States Virgin Islands[VI]', 'British Virgin Islands[VG]', 'Wallis and Futuna[WF]', 'Samoa[WS]', 'Zambia[ZM]', 'Zimbabwe[ZW]'],

            /* Zone 5 */
            ['United States[US]']
        ];

        rowData.forEach((columnData, columnIndex) => {
            columnData.forEach((value, rowIndex) => {
                memoSheet.getCell(rowIndex + 2, columnIndex + 1).value = value;  // 데이터 입력
                memoSheet.getCell(rowIndex + 2, columnIndex + 1).alignment = { horizontal: 'center', vertical: 'middle' };
                memoSheet.getCell(rowIndex + 2, columnIndex + 1).font = { name: '맑은 고딕', size: 11 };
            });
        });

        const equalColumnWidth = 28;
        for (let i = 1; i <= headers.length; i++) {
            memoSheet.getColumn(i).width = equalColumnWidth;
        }

        workbook.xlsx.writeBuffer().then((data) => {
            const blob = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
            const url = window.URL.createObjectURL(blob);
            const anchor = document.createElement('a');
            anchor.href = url;
            anchor.download = `Btorage 요금표[Small-Packet].xlsx`;
            anchor.click();
            window.URL.revokeObjectURL(url);
        });
    };

    //endregion

    const handleSaveClick = (seqNum) => {
        const weightData = domeData.find(item => item.seqNum === seqNum);

        const weightToSubmit = {
            seqNum,
            w3000: editedWeights.w3000 || 0,
            w5000: editedWeights.w5000 || 0,
            w10000: editedWeights.w10000 || 0,
            w20000: editedWeights.w20000 || 0,
            w25000: editedWeights.w25000 || 0
        };

        axios.post('/shipinfo/updateDomePrice', weightToSubmit, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': LCAT,
            }
        })
            .then(() => {
                setDomeData(prevData => prevData.map(item =>
                    item.seqNum === seqNum ? { ...item, ...editedWeights } : item
                ));
                setEditMode(null);
            })
            .catch(error => {
                console.error("err", error);
            });
    };

    /** endregion */

    return (
        <div className="AdminCurrencyRatePg">
            <div className="admin-work-title">
                <img className="wd-35 ht-35" alt="" src={maCateImg}/>
                <p className="p-t-6">배송비용관리</p>
            </div>
            <div className="admin-wrap font-t-cont">
                <div className="admin-wrap-card">
                    {/*<div className="display-flex flex-column wd-100pc p-b-10 m-b-20">*/}
                    {/*    <a href="https://ems.epost.go.kr/front.EmsDeliveryDelivery02.postal" target="_blank" className="text-underline wd-200" style={{color: "#3177bb"}}>우체국 요금표 바로가기 ◁◁</a>*/}
                    {/*    <p>EXCEL[양식] 버튼 클릭 후 업로드 엑셀양식을 다운 받은 후 각 배송사별 요금정보를 '값으로만'★복붙하여 업로드 및 저장</p>*/}
                    {/*    <p style={{color: "#ff3535"}}>※ 주의 ※ 저장 즉시 배송비가 업데이트됩니다. 반드시 내용을 확인해주세요.</p>*/}
                    {/*</div>*/}
                    <Tabs className="mandm-tab m-b-20 font-s-15" defaultActiveKey="mam-tab-main" style={{marginBottom: "20px", fontSize: "15px"}}>
                        <Tab eventKey="mam-tab-main" title="&nbsp;&nbsp;&nbsp;FedEx&nbsp;&nbsp;&nbsp;">
                            <div className="admin-event-wrap">
                                <div className="admin-event-wrap-btn">
                                    {/* flex 컨테이너에 alignItems: 'center'를 추가하여 수직 정렬을 맞춥니다. */}
                                    <div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>

                                        <input
                                            type="file"
                                            onChange={excelUploadFEDEX}
                                            ref={fileSelectf}
                                            style={{display: "none"}}/>
                                        <button
                                            id="ex-btn"
                                            className="admin-btn-A wd-100 ht-30 font-s-13 btn-click-event m-r-10"
                                            onClick={() => fileSelectf.current.click()}>
                                            파일선택
                                        </button>

                                        {selectedSheetf && (
                                            <select
                                                className="admin-combo font-s-13"
                                                id="sheet-select"
                                                value={selectedSheetf.value}
                                                onChange={sheetSelectFEDEX}
                                                style={{width: "120px", height: "30px"}}
                                            >
                                                {excelDataf.SheetNames.map((sheetName) => (
                                                    <option key={sheetName} value={sheetName}>
                                                        {sheetName}
                                                    </option>
                                                ))}
                                            </select>
                                        )}
                                    </div>
                                </div>
                                <div className="admin-event-wrap-btn gap10">
                                    <button className="admin-btn-A wd-100 ht-30 font-s-13 btn-click-event"
                                            onClick={excelDownFEDEX}>EXCEL[양식]
                                    </button>
                                    {/*<button className="admin-btn-A wd-100 ht-30 font-s-13 btn-click-event" onClick={generateFedExExcel}>EXCEL[비용]</button>*/}
                                    <button className="admin-btn-A wd-100 ht-30 font-s-13 btn-click-event"
                                            onClick={alert}>저장
                                    </button>
                                </div>
                            </div>
                            <div className="gbn-border-b" style={{width: "100%", marginBottom: "15px"}}></div>
                            <div style={{display: "flex", flexDirection: "column"}}>
                                <div className="admin-event-wrap">
                                    <div className="admin-btn-wrap-l">
                                        <BsSquareFill className="admin-tb-header-notice"/>
                                        <a>새로 적용할 요금표[EXCEL]</a>
                                    </div>
                                </div>
                                <div style={{width: "100%", maxWidth: "100%", overflowX: "auto"}}>
                                    {selectedSheetf && (
                                        <Table className="admin-tb" striped bordered hover>
                                            <thead className="admin-tb-head">
                                            <tr className="admin-tb-head-line">
                                                {sheetDataf[0] && sheetDataf[0].map((header) =>
                                                    <th key={header} style={{width: "80px"}}>
                                                        <b>{header}</b>
                                                    </th>)
                                                }
                                            </tr>
                                                </thead>
                                                <tbody className="admin-tb-body">
                                                {sheetDataf.slice(1).map((row, i) => (
                                                    <tr className="admin-tb-body-line" key={i}>
                                                        {row.map((cell, j) => (
                                                            <td key={`${i}-${j}`}><a>{cell.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                        ))}
                                                    </tr>
                                                ))}
                                                </tbody>
                                            </Table>
                                        )}
                                    </div>
                                </div>
                                <div style={{display: "flex", flexDirection: "column"}}>
                                    <div className="admin-event-wrap" style={{marginTop: "70px", marginBottom: "-1px"}}>
                                        <div className="admin-btn-wrap-l">
                                            <BsSquareFill className="admin-tb-header-notice"/>
                                            <a>현재 적용된 요금표(단위:kg/&#8361;)</a>
                                        </div>
                                    </div>
                                    <div style={{width: "100%", maxWidth: "100%",overflowX: "auto"}}>
                                        <Table striped bordered hover className="admin-tb">
                                            <thead className="admin-tb-head">
                                                <tr className="admin-tb-head-line">
                                                <th style={{width: "75px"}}><b>그룹코드</b></th>
                                                <th style={{width: "75px"}}><b>0.5kg</b></th>
                                                <th style={{width: "75px"}}><b>1kg</b></th>
                                                <th style={{width: "75px"}}><b>1.5kg</b></th>
                                                <th style={{width: "75px"}}><b>2kg</b></th>
                                                <th style={{width: "75px"}}><b>2.5kg</b></th>
                                                <th style={{width: "75px"}}><b>3.0kg</b></th>
                                                <th style={{width: "75px"}}><b>3.5kg</b></th>
                                                <th style={{width: "75px"}}><b>4.0kg</b></th>
                                                <th style={{width: "75px"}}><b>4.5kg</b></th>
                                                <th style={{width: "75px"}}><b>5.0kg</b></th>
                                                <th style={{width: "75px"}}><b>5.5kg</b></th>
                                                <th style={{width: "75px"}}><b>6.0kg</b></th>
                                                <th style={{width: "75px"}}><b>6.5kg</b></th>
                                                <th style={{width: "75px"}}><b>7.0kg</b></th>
                                                <th style={{width: "75px"}}><b>7.5kg</b></th>
                                                <th style={{width: "75px"}}><b>8.0kg</b></th>
                                                <th style={{width: "75px"}}><b>8.5kg</b></th>
                                                <th style={{width: "75px"}}><b>9.0kg</b></th>
                                                <th style={{width: "75px"}}><b>9.5kg</b></th>
                                                <th style={{width: "75px"}}><b>10kg</b></th>
                                                <th style={{width: "75px"}}><b>10.5kg</b></th>
                                                <th style={{width: "75px"}}><b>11kg</b></th>
                                                <th style={{width: "75px"}}><b>11.5kg</b></th>
                                                <th style={{width: "75px"}}><b>12kg</b></th>
                                                <th style={{width: "75px"}}><b>12.5kg</b></th>
                                                <th style={{width: "75px"}}><b>13kg</b></th>
                                                <th style={{width: "75px"}}><b>13.5kg</b></th>
                                                <th style={{width: "75px"}}><b>14kg</b></th>
                                                <th style={{width: "75px"}}><b>14.5kg</b></th>
                                                <th style={{width: "75px"}}><b>15kg</b></th>
                                                <th style={{width: "75px"}}><b>15.5kg</b></th>
                                                <th style={{width: "75px"}}><b>16kg</b></th>
                                                <th style={{width: "75px"}}><b>16.5kg</b></th>
                                                <th style={{width: "75px"}}><b>17kg</b></th>
                                                <th style={{width: "75px"}}><b>17.5kg</b></th>
                                                <th style={{width: "75px"}}><b>18kg</b></th>
                                                <th style={{width: "75px"}}><b>18.5kg</b></th>
                                                <th style={{width: "75px"}}><b>19kg</b></th>
                                                <th style={{width: "75px"}}><b>19.5kg</b></th>
                                                <th style={{width: "75px"}}><b>20kg</b></th>
                                                <th style={{width: "75px"}}><b>20.5kg</b></th>
                                                <th style={{width: "75px"}}><b>21kg</b></th>
                                                <th style={{width: "75px"}}><b>22kg</b></th>
                                                <th style={{width: "75px"}}><b>23kg</b></th>
                                                <th style={{width: "75px"}}><b>24kg</b></th>
                                                <th style={{width: "75px"}}><b>25kg</b></th>
                                                <th style={{width: "75px"}}><b>26kg</b></th>
                                                <th style={{width: "75px"}}><b>27kg</b></th>
                                                <th style={{width: "75px"}}><b>28kg</b></th>
                                                <th style={{width: "75px"}}><b>29kg</b></th>
                                                <th style={{width: "75px"}}><b>30kg</b></th>
                                            </tr>
                                            </thead>
                                            <tbody className="admin-tb-body">
                                            {fedexData.map((cData, i) => (
                                                <tr className="admin-tb-body-line" key={cData.seqNum}>
                                                    <td><a>{fedexData[i].appGroup}</a></td>
                                                    <td><a>{fedexData[i].w500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                    <td><a>{fedexData[i].w1000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                    <td><a>{fedexData[i].w1500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                    <td><a>{fedexData[i].w2000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                    <td><a>{fedexData[i].w2500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                    <td><a>{fedexData[i].w3000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                    <td><a>{fedexData[i].w3500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                    <td><a>{fedexData[i].w4000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                    <td><a>{fedexData[i].w4500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                    <td><a>{fedexData[i].w5000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                    <td><a>{fedexData[i].w5500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                    <td><a>{fedexData[i].w6000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                    <td><a>{fedexData[i].w6500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                    <td><a>{fedexData[i].w7000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                    <td><a>{fedexData[i].w7500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                    <td><a>{fedexData[i].w8000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                    <td><a>{fedexData[i].w8500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                    <td><a>{fedexData[i].w9000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                    <td><a>{fedexData[i].w9500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                    <td><a>{fedexData[i].w10000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                    <td><a>{fedexData[i].w10500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                    <td><a>{fedexData[i].w11000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                    <td><a>{fedexData[i].w11500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                    <td><a>{fedexData[i].w12000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                    <td><a>{fedexData[i].w12500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                    <td><a>{fedexData[i].w13000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                    <td><a>{fedexData[i].w13500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                    <td><a>{fedexData[i].w14000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                    <td><a>{fedexData[i].w14500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                    <td><a>{fedexData[i].w15000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                    <td><a>{fedexData[i].w15500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                    <td><a>{fedexData[i].w16000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                    <td><a>{fedexData[i].w16500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                    <td><a>{fedexData[i].w17000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                    <td><a>{fedexData[i].w17500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                    <td><a>{fedexData[i].w18000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                    <td><a>{fedexData[i].w18500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                    <td><a>{fedexData[i].w19000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                    <td><a>{fedexData[i].w19500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                    <td><a>{fedexData[i].w20000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                    <td><a>{fedexData[i].w20500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                    <td><a>{fedexData[i].w21000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                    <td><a>{fedexData[i].w22000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                    <td><a>{fedexData[i].w23000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                    <td><a>{fedexData[i].w24000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                    <td><a>{fedexData[i].w25000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                    <td><a>{fedexData[i].w26000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                    <td><a>{fedexData[i].w27000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                    <td><a>{fedexData[i].w28000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                    <td><a>{fedexData[i].w29000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                    <td><a>{fedexData[i].w30000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                </tr>
                                            ))}
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            <div className="font-t-cont font-s-14">
                                {/*<p className="font-b">A - 마카오</p>*/}
                                {/*<p className="font-b">D - 캄보디아, 라오스 몽골</p>*/}
                                {/*<p className="font-b">F - 캐나다, 미국, 멕시코</p>*/}
                                {/*<p className="font-b">G - 오스트리아, 체코, 덴마크, 핀란드, 그리스, 헝가리, 아일랜드, 노르웨이, 폴란드, 포르투갈, 스웨덴, 스위스</p>*/}
                                {/*<p className="font-b">H - 이스라엘, 튀르키예, 러시아, 우크라이나, 우즈베키스탄</p>*/}
                                {/*<p className="font-b">I - 아르헨티아, 브라질, 칠레, 페루</p>*/}
                                {/*<p className="font-b">J - 방글라데시, 모로코, 카타르, 아랍에미리트, 요르단 ,사우디아라비아</p>*/}
                                {/*<p className="font-b">M - 벨기에, 독일, 이탈리아, 네덜란드, 스페인, 영국, 프랑스</p>*/}
                                {/*<p className="font-b">N - 베트남</p>*/}
                                {/*<p className="font-b">O - 인도</p>*/}
                                {/*<p className="font-b">P - 일본</p>*/}
                                {/*<p className="font-b">Q - 말레이시아</p>*/}
                                {/*<p className="font-b">R - 태국</p>*/}
                                {/*<p className="font-b">S - 필리핀</p>*/}
                                {/*<p className="font-b">T - 인도네시아</p>*/}
                                {/*<p className="font-b">U - 호주, 뉴질랜드</p>*/}
                                {/*<p className="font-b">V - 홍콩</p>*/}
                                {/*<p className="font-b">W - 중국</p>*/}
                                {/*<p className="font-b">X - 대만</p>*/}
                                {/*<p className="font-b">Y - 싱가포르</p>*/}
                            </div>
                        </Tab>
                        <Tab eventKey="mam-tab-main-eco" title="&nbsp;&nbsp;&nbsp;FedEx-E&nbsp;&nbsp;&nbsp;">
                            <div className="admin-event-wrap">
                                <div className="admin-event-wrap-btn">
                                    <div style={{display: "flex", flexDirection: "row"}}>
                                        <div className="m-r-10" style={{position: "relative"}}>
                                            <input
                                                type="file"
                                                onChange={excelUploadFEDEXE}
                                                ref={fileSelectfe}
                                                style={{display: "none"}}/>
                                            <button
                                                id="ex-btn"
                                                className="admin-btn-A wd-100 ht-30 font-s-13 btn-click-event m-r-10"
                                                onClick={() => fileSelectfe.current.click()}>
                                                파일선택
                                            </button>
                                        </div>

                                        {selectedSheetfe && (
                                            <select className="admin-combo font-s-13" id="sheet-select"
                                                    value={selectedSheetfe.value} onChange={sheetSelectFEDEXE}
                                                    style={{width: "120px", height: "25px", marginTop: "2px"}}>
                                                {excelDatafe.SheetNames.map((sheetName) => (
                                                    <option key={sheetName} value={sheetName}>
                                                    {sheetName}
                                                    </option>
                                                ))}
                                            </select>
                                        )}
                                    </div>
                                </div>
                                <div className="admin-event-wrap-btn gap10">
                                    <button className="admin-btn-A wd-100 ht-30 font-s-13 btn-click-event" onClick={excelDownFEDEXE}>EXCEL[양식]</button>
                                    <button className="admin-btn-A wd-100 ht-30 font-s-13 btn-click-event" onClick={alert2}>저장</button>
                                </div>
                            </div>
                            <div className="gbn-border-b" style={{width: "100%", marginBottom: "15px"}}></div>
                            <div style={{display: "flex", flexDirection: "column"}}>
                                <div className="admin-event-wrap">
                                    <div className="admin-btn-wrap-l">
                                        <BsSquareFill className="admin-tb-header-notice"/>
                                        <a>새로 적용할 요금표[EXCEL]</a>
                                    </div>
                                </div>
                                <div style={{width: "100%", maxWidth: "100%",overflowX: "auto"}}>
                                    {selectedSheetfe && (
                                        <Table className="admin-tb" striped bordered hover>
                                            <thead className="admin-tb-head">
                                            <tr className="admin-tb-head-line">
                                                {sheetDatafe[0] && sheetDatafe[0].map((header) =>
                                                    <th key={header} style={{width: "80px"}}>
                                                        <b>{header}</b>
                                                    </th>)
                                                }
                                            </tr>
                                            </thead>
                                            <tbody className="admin-tb-body">
                                            {sheetDatafe.slice(1).map((row, i) => (
                                                <tr className="admin-tb-body-line" key={i}>
                                                    {row.map((cell, j) => (
                                                        <td key={`${i}-${j}`}><a>{cell.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                    ))}
                                                </tr>
                                            ))}
                                            </tbody>
                                        </Table>
                                    )}
                                </div>
                            </div>
                            <div style={{display: "flex", flexDirection: "column"}}>
                                <div className="admin-event-wrap" style={{marginTop: "70px", marginBottom: "-1px"}}>
                                    <div className="admin-btn-wrap-l">
                                        <BsSquareFill className="admin-tb-header-notice"/>
                                        <a>현재 적용된 요금표(단위:kg/&#8361;)</a>
                                    </div>
                                </div>
                                <div style={{width: "100%", maxWidth: "100%",overflowX: "auto"}}>
                                    <Table striped bordered hover className="admin-tb">
                                        <thead className="admin-tb-head">
                                        <tr className="admin-tb-head-line">
                                            <th style={{width: "75px"}}><b>그룹코드</b></th>
                                            <th style={{width: "75px"}}><b>0.5kg</b></th>
                                            <th style={{width: "75px"}}><b>1kg</b></th>
                                            <th style={{width: "75px"}}><b>1.5kg</b></th>
                                            <th style={{width: "75px"}}><b>2kg</b></th>
                                            <th style={{width: "75px"}}><b>2.5kg</b></th>
                                            <th style={{width: "75px"}}><b>3.0kg</b></th>
                                            <th style={{width: "75px"}}><b>3.5kg</b></th>
                                            <th style={{width: "75px"}}><b>4.0kg</b></th>
                                            <th style={{width: "75px"}}><b>4.5kg</b></th>
                                            <th style={{width: "75px"}}><b>5.0kg</b></th>
                                            <th style={{width: "75px"}}><b>5.5kg</b></th>
                                            <th style={{width: "75px"}}><b>6.0kg</b></th>
                                            <th style={{width: "75px"}}><b>6.5kg</b></th>
                                            <th style={{width: "75px"}}><b>7.0kg</b></th>
                                            <th style={{width: "75px"}}><b>7.5kg</b></th>
                                            <th style={{width: "75px"}}><b>8.0kg</b></th>
                                            <th style={{width: "75px"}}><b>8.5kg</b></th>
                                            <th style={{width: "75px"}}><b>9.0kg</b></th>
                                            <th style={{width: "75px"}}><b>9.5kg</b></th>
                                            <th style={{width: "75px"}}><b>10kg</b></th>
                                            <th style={{width: "75px"}}><b>10.5kg</b></th>
                                            <th style={{width: "75px"}}><b>11kg</b></th>
                                            <th style={{width: "75px"}}><b>11.5kg</b></th>
                                            <th style={{width: "75px"}}><b>12kg</b></th>
                                            <th style={{width: "75px"}}><b>12.5kg</b></th>
                                            <th style={{width: "75px"}}><b>13kg</b></th>
                                            <th style={{width: "75px"}}><b>13.5kg</b></th>
                                            <th style={{width: "75px"}}><b>14kg</b></th>
                                            <th style={{width: "75px"}}><b>14.5kg</b></th>
                                            <th style={{width: "75px"}}><b>15kg</b></th>
                                            <th style={{width: "75px"}}><b>15.5kg</b></th>
                                            <th style={{width: "75px"}}><b>16kg</b></th>
                                            <th style={{width: "75px"}}><b>16.5kg</b></th>
                                            <th style={{width: "75px"}}><b>17kg</b></th>
                                            <th style={{width: "75px"}}><b>17.5kg</b></th>
                                            <th style={{width: "75px"}}><b>18kg</b></th>
                                            <th style={{width: "75px"}}><b>18.5kg</b></th>
                                            <th style={{width: "75px"}}><b>19kg</b></th>
                                            <th style={{width: "75px"}}><b>19.5kg</b></th>
                                            <th style={{width: "75px"}}><b>20kg</b></th>
                                            <th style={{width: "75px"}}><b>20.5kg</b></th>
                                            <th style={{width: "75px"}}><b>21kg</b></th>
                                            <th style={{width: "75px"}}><b>22kg</b></th>
                                            <th style={{width: "75px"}}><b>23kg</b></th>
                                            <th style={{width: "75px"}}><b>24kg</b></th>
                                            <th style={{width: "75px"}}><b>25kg</b></th>
                                            <th style={{width: "75px"}}><b>26kg</b></th>
                                            <th style={{width: "75px"}}><b>27kg</b></th>
                                            <th style={{width: "75px"}}><b>28kg</b></th>
                                            <th style={{width: "75px"}}><b>29kg</b></th>
                                            <th style={{width: "75px"}}><b>30kg</b></th>
                                        </tr>
                                        </thead>
                                        <tbody className="admin-tb-body">
                                        {fedexEcoData.map((cData, i) => (
                                            <tr className="admin-tb-body-line" key={cData.seqNum}>
                                                <td><a>{fedexEcoData[i].appGroup}</a></td>
                                                <td><a>{fedexEcoData[i].w500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{fedexEcoData[i].w1000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{fedexEcoData[i].w1500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{fedexEcoData[i].w2000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{fedexEcoData[i].w2500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{fedexEcoData[i].w3000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{fedexEcoData[i].w3500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{fedexEcoData[i].w4000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{fedexEcoData[i].w4500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{fedexEcoData[i].w5000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{fedexEcoData[i].w5500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{fedexEcoData[i].w6000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{fedexEcoData[i].w6500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{fedexEcoData[i].w7000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{fedexEcoData[i].w7500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{fedexEcoData[i].w8000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{fedexEcoData[i].w8500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{fedexEcoData[i].w9000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{fedexEcoData[i].w9500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{fedexEcoData[i].w10000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{fedexEcoData[i].w10500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{fedexEcoData[i].w11000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{fedexEcoData[i].w11500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{fedexEcoData[i].w12000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{fedexEcoData[i].w12500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{fedexEcoData[i].w13000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{fedexEcoData[i].w13500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{fedexEcoData[i].w14000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{fedexEcoData[i].w14500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{fedexEcoData[i].w15000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{fedexEcoData[i].w15500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{fedexEcoData[i].w16000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{fedexEcoData[i].w16500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{fedexEcoData[i].w17000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{fedexEcoData[i].w17500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{fedexEcoData[i].w18000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{fedexEcoData[i].w18500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{fedexEcoData[i].w19000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{fedexEcoData[i].w19500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{fedexEcoData[i].w20000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{fedexEcoData[i].w20500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{fedexEcoData[i].w21000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{fedexEcoData[i].w22000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{fedexEcoData[i].w23000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{fedexEcoData[i].w24000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{fedexEcoData[i].w25000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{fedexEcoData[i].w26000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{fedexEcoData[i].w27000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{fedexEcoData[i].w28000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{fedexEcoData[i].w29000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{fedexEcoData[i].w30000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </Table>
                                </div>
                            </div>
                            <div className="font-t-cont font-s-14">
                                {/*<p className="font-b">A - 마카오</p>*/}
                                {/*<p className="font-b">D - 캄보디아, 라오스 몽골</p>*/}
                                {/*<p className="font-b">F - 캐나다, 미국, 멕시코</p>*/}
                                {/*<p className="font-b">G - 오스트리아, 체코, 덴마크, 핀란드, 그리스, 헝가리, 아일랜드, 노르웨이, 폴란드, 포르투갈, 스웨덴, 스위스</p>*/}
                                {/*<p className="font-b">H - 이스라엘, 튀르키예, 러시아, 우크라이나, 우즈베키스탄</p>*/}
                                {/*<p className="font-b">I - 아르헨티아, 브라질, 칠레, 페루</p>*/}
                                {/*<p className="font-b">J - 방글라데시, 모로코, 카타르, 아랍에미리트, 요르단 ,사우디아라비아</p>*/}
                                {/*<p className="font-b">M - 벨기에, 독일, 이탈리아, 네덜란드, 스페인, 영국, 프랑스</p>*/}
                                {/*<p className="font-b">N - 베트남</p>*/}
                                {/*<p className="font-b">O - 인도</p>*/}
                                {/*<p className="font-b">P - 일본</p>*/}
                                {/*<p className="font-b">Q - 말레이시아</p>*/}
                                {/*<p className="font-b">R - 태국</p>*/}
                                {/*<p className="font-b">S - 필리핀</p>*/}
                                {/*<p className="font-b">T - 인도네시아</p>*/}
                                {/*<p className="font-b">U - 호주, 뉴질랜드</p>*/}
                                {/*<p className="font-b">V - 홍콩</p>*/}
                                {/*<p className="font-b">W - 중국</p>*/}
                                {/*<p className="font-b">X - 대만</p>*/}
                                {/*<p className="font-b">Y - 싱가포르</p>*/}
                            </div>
                        </Tab>
                        <Tab eventKey="mam-tab-sub-ups" title="&nbsp;&nbsp;UPS&nbsp;&nbsp;">
                            <div className="admin-event-wrap">
                                <div className="admin-event-wrap-btn">
                                    <div style={{display: "flex", flexDirection: "row"}}>
                                        <div className="m-r-10" style={{position: "relative"}}>
                                            <input
                                                type="file"
                                                onChange={excelUploadUPS}
                                                ref={fileSelectUps}
                                                style={{display: "none"}}/>
                                            <button
                                                id="ex-btn"
                                                className="admin-btn-A wd-100 ht-30 font-s-13 btn-click-event m-r-10"
                                                onClick={() => fileSelectUps.current.click()}>
                                                파일선택
                                            </button>
                                        </div>

                                        {selectedSheetUps && (
                                            <select className="admin-combo font-s-13" id="sheet-select"
                                                    value={selectedSheetUps.value} onChange={sheetSelectUPS}
                                                    style={{width: "120px", height: "25px", marginTop: "2px"}}>
                                                {excelDataUps.SheetNames.map((sheetName) => (
                                                    <option key={sheetName} value={sheetName}>
                                                    {sheetName}
                                                    </option>
                                                ))}
                                            </select>
                                        )}
                                    </div>
                                </div>
                                <div className="admin-event-wrap-btn gap10">
                                    <button className="admin-btn-A wd-100 ht-30 font-s-13 btn-click-event" onClick={excelDownUPS}>EXCEL[양식]</button>
                                    <button className="admin-btn-A wd-100 ht-30 font-s-13 btn-click-event" onClick={alert5}>저장</button>
                                </div>
                            </div>
                            <div className="gbn-border-b" style={{width: "100%", marginTop: "18px", marginBottom: "15px"}}></div>
                            <div className="admin-event-wrap" style={{marginTop: "10px", marginBottom: "-1px"}}>
                                <div className="admin-btn-wrap-l">
                                    <BsSquareFill className="admin-tb-header-notice"/>
                                    <a>새로 적용할 요금표[EXCEL]</a>
                                </div>
                            </div>
                            <div style={{width: "100%", maxWidth: "100%",overflowX: "auto", display: "flex", flexDirection: "row"}}>
                                {selectedSheetUps && (
                                    <Table className="admin-tb" striped bordered hover>
                                        <thead className="admin-tb-head">
                                        <tr className="admin-tb-head-line">
                                            {sheetDataUps[0] && sheetDataUps[0].map((header) =>
                                                <th key={header} style={{width: "80px"}}>
                                                    <b>{header}</b>
                                                </th>)
                                            }
                                        </tr>
                                        </thead>
                                        <tbody className="admin-tb-body">
                                        {sheetDataUps.slice(1).map((row, i) => (
                                            <tr className="admin-tb-body-line" key={i}>
                                                {row.map((cell, j) => (
                                                    <td key={`${i}-${j}`}><a>{cell.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                ))}
                                            </tr>
                                        ))}
                                        </tbody>
                                    </Table>
                                )}
                            </div>
                            <div className="admin-event-wrap" style={{marginTop: "70px", marginBottom: "-1px"}}>
                                <div className="admin-btn-wrap-l">
                                    <BsSquareFill className="admin-tb-header-notice"/>
                                    <a>현재 적용된 요금표(단위:kg/&#8361;)</a>
                                </div>
                            </div>
                            <div style={{width: "100%", maxWidth: "100%",overflowX: "auto", display: "flex", flexDirection: "row"}}>
                                <Table striped bordered hover className="admin-tb">
                                    <thead className="admin-tb-head">
                                    <tr className="admin-tb-head-line">
                                        <th style={{width: "75px"}}><b>지역코드</b></th>
                                        <th style={{width: "75px"}}><b>0.5kg</b></th>
                                        <th style={{width: "75px"}}><b>1kg</b></th>
                                        <th style={{width: "75px"}}><b>1.5kg</b></th>
                                        <th style={{width: "75px"}}><b>2kg</b></th>
                                        <th style={{width: "75px"}}><b>2.5kg</b></th>
                                        <th style={{width: "75px"}}><b>3.0kg</b></th>
                                        <th style={{width: "75px"}}><b>3.5kg</b></th>
                                        <th style={{width: "75px"}}><b>4.0kg</b></th>
                                        <th style={{width: "75px"}}><b>4.5kg</b></th>
                                        <th style={{width: "75px"}}><b>5.0kg</b></th>
                                        <th style={{width: "75px"}}><b>5.5kg</b></th>
                                        <th style={{width: "75px"}}><b>6.0kg</b></th>
                                        <th style={{width: "75px"}}><b>6.5kg</b></th>
                                        <th style={{width: "75px"}}><b>7.0kg</b></th>
                                        <th style={{width: "75px"}}><b>7.5kg</b></th>
                                        <th style={{width: "75px"}}><b>8.0kg</b></th>
                                        <th style={{width: "75px"}}><b>8.5kg</b></th>
                                        <th style={{width: "75px"}}><b>9.0kg</b></th>
                                        <th style={{width: "75px"}}><b>9.5kg</b></th>
                                        <th style={{width: "75px"}}><b>10.0kg</b></th>
                                        <th style={{width: "75px"}}><b>10.5kg</b></th>
                                        <th style={{width: "75px"}}><b>11kg</b></th>
                                        <th style={{width: "75px"}}><b>11.5kg</b></th>
                                        <th style={{width: "75px"}}><b>12kg</b></th>
                                        <th style={{width: "75px"}}><b>12.5kg</b></th>
                                        <th style={{width: "75px"}}><b>13kg</b></th>
                                        <th style={{width: "75px"}}><b>13.5kg</b></th>
                                        <th style={{width: "75px"}}><b>14kg</b></th>
                                        <th style={{width: "75px"}}><b>14.5kg</b></th>
                                        <th style={{width: "75px"}}><b>15kg</b></th>
                                        <th style={{width: "75px"}}><b>15.5kg</b></th>
                                        <th style={{width: "75px"}}><b>16kg</b></th>
                                        <th style={{width: "75px"}}><b>16.5kg</b></th>
                                        <th style={{width: "75px"}}><b>17kg</b></th>
                                        <th style={{width: "75px"}}><b>17.5kg</b></th>
                                        <th style={{width: "75px"}}><b>18kg</b></th>
                                        <th style={{width: "75px"}}><b>18.5kg</b></th>
                                        <th style={{width: "75px"}}><b>19kg</b></th>
                                        <th style={{width: "75px"}}><b>19.5kg</b></th>
                                        <th style={{width: "75px"}}><b>20kg</b></th>
                                        <th style={{width: "75px"}}><b>20.5kg</b></th>
                                        <th style={{width: "75px"}}><b>21kg</b></th>
                                        <th style={{width: "75px"}}><b>22kg</b></th>
                                        <th style={{width: "75px"}}><b>23kg</b></th>
                                        <th style={{width: "75px"}}><b>24kg</b></th>
                                        <th style={{width: "75px"}}><b>25kg</b></th>
                                        <th style={{width: "75px"}}><b>26kg</b></th>
                                        <th style={{width: "75px"}}><b>27kg</b></th>
                                        <th style={{width: "75px"}}><b>28kg</b></th>
                                        <th style={{width: "75px"}}><b>29kg</b></th>
                                        <th style={{width: "75px"}}><b>30kg</b></th>
                                        {/*<th style={{width: "75px"}}><b>31kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>32kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>33kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>34kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>35kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>36kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>37kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>38kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>39kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>40kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>41kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>42kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>43kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>44kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>45kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>46kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>47kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>48kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>49kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>50kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>51kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>52kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>53kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>54kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>55kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>56kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>57kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>58kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>59kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>60kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>61kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>62kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>63kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>64kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>65kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>66kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>67kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>68kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>69kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>70kg</b></th>*/}
                                    </tr>
                                    </thead>
                                    <tbody className="admin-tb-body">
                                    {upsData.map((cData, i) => (
                                        <tr className="admin-tb-body-line" key={cData.seqNum}>
                                            <td><a>{upsData[i].appUpsCode}</a></td>
                                            <td><a>{upsData[i].w500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsData[i].w1000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsData[i].w1500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsData[i].w2000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsData[i].w2500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsData[i].w3000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsData[i].w3500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsData[i].w4000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsData[i].w4500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsData[i].w5000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsData[i].w5500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsData[i].w6000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsData[i].w6500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsData[i].w7000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsData[i].w7500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsData[i].w8000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsData[i].w8500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsData[i].w9000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsData[i].w9500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsData[i].w10000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsData[i].w10500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsData[i].w11000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsData[i].w11500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsData[i].w12000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsData[i].w12500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsData[i].w13000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsData[i].w13500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsData[i].w14000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsData[i].w14500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsData[i].w15000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsData[i].w15500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsData[i].w16000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsData[i].w16500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsData[i].w17000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsData[i].w17500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsData[i].w18000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsData[i].w18500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsData[i].w19000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsData[i].w19500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsData[i].w20000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsData[i].w20500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsData[i].w21000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsData[i].w22000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsData[i].w23000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsData[i].w24000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsData[i].w25000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsData[i].w26000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsData[i].w27000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsData[i].w28000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsData[i].w29000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsData[i].w30000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            {/*<td><a>{upsData[i].w31000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w32000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w33000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w34000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w35000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w36000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w37000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w38000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w39000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w40000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w41000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w42000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w43000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w44000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w45000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w46000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w47000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w48000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w49000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w50000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w51000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w52000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w53000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w54000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w55000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w56000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w57000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w58000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w59000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w60000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w61000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w62000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w63000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w64000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w65000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w66000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w67000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w68000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w69000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w70000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                        </tr>
                                    ))}
                                    </tbody>
                                </Table>
                            </div>
                            <div className="font-t-cont font-s-14">
                                {/*<p className="font-b">Z1[1지역] - CN:중국, HK:홍콩, MO:마카오, TW:타이완</p>*/}
                                {/*<p className="font-b">Z2[2지역] - BN:브루나이, KH:캄보디아, JP:일본, LA:라오스, MY:말레이시아, SG:싱가포르, TH:태국, VN:베트남</p>*/}
                                {/*<p className="font-b">Z3[3지역] - </p>*/}
                                {/*<p className="font-b">Z4[4지역] - </p>*/}
                                {/*<p className="font-b">ZA[4-1지역] - RU:러시아</p>*/}
                                {/*<p className="font-b">Z5[5지역] - </p>*/}
                            </div>
                        </Tab>
                        <Tab eventKey="mam-tab-sub-ups-eco" title="&nbsp;&nbsp;UPS-E&nbsp;&nbsp;">
                            <div className="admin-event-wrap">
                                <div className="admin-event-wrap-btn">
                                    <div style={{display: "flex", flexDirection: "row"}}>
                                        <div className="m-r-10" style={{position: "relative"}}>
                                            <input
                                                type="file"
                                                onChange={excelUploadUPSE}
                                                ref={fileSelectUpse}
                                                style={{display: "none"}}/>
                                            <button
                                                id="ex-btn"
                                                className="admin-btn-A wd-100 ht-30 font-s-13 btn-click-event m-r-10"
                                                onClick={() => fileSelectUpse.current.click()}>
                                                파일선택
                                            </button>
                                        </div>

                                        {selectedSheetUpse && (
                                            <select className="admin-combo font-s-13" id="sheet-select"
                                                    value={selectedSheetUpse.value} onChange={sheetSelectUPSE}
                                                    style={{width: "120px", height: "25px", marginTop: "2px"}}>
                                                {excelDataUpse.SheetNames.map((sheetName) => (
                                                    <option key={sheetName} value={sheetName}>
                                                    {sheetName}
                                                    </option>
                                                ))}
                                            </select>
                                        )}
                                    </div>
                                </div>
                                <div className="admin-event-wrap-btn gap10">
                                    <button className="admin-btn-A wd-100 ht-30 font-s-13 btn-click-event" onClick={excelDownUPSE}>EXCEL[양식]</button>
                                    <button className="admin-btn-A wd-100 ht-30 font-s-13 btn-click-event" onClick={alert6}>저장</button>
                                </div>
                            </div>
                            <div className="gbn-border-b" style={{width: "100%", marginTop: "18px", marginBottom: "15px"}}></div>
                            <div className="admin-event-wrap" style={{marginTop: "10px", marginBottom: "-1px"}}>
                                <div className="admin-btn-wrap-l">
                                    <BsSquareFill className="admin-tb-header-notice"/>
                                    <a>새로 적용할 요금표[EXCEL]</a>
                                </div>
                            </div>
                            <div style={{width: "100%", maxWidth: "100%",overflowX: "auto", display: "flex", flexDirection: "row"}}>
                                {selectedSheetUpse && (
                                    <Table className="admin-tb" striped bordered hover>
                                        <thead className="admin-tb-head">
                                        <tr className="admin-tb-head-line">
                                            {sheetDataUpse[0] && sheetDataUpse[0].map((header) =>
                                                <th key={header} style={{width: "80px"}}>
                                                    <b>{header}</b>
                                                </th>)
                                            }
                                        </tr>
                                        </thead>
                                        <tbody className="admin-tb-body">
                                        {sheetDataUpse.slice(1).map((row, i) => (
                                            <tr className="admin-tb-body-line" key={i}>
                                                {row.map((cell, j) => (
                                                    <td key={`${i}-${j}`}><a>{cell.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                ))}
                                            </tr>
                                        ))}
                                        </tbody>
                                    </Table>
                                )}
                            </div>
                            <div className="admin-event-wrap" style={{marginTop: "70px", marginBottom: "-1px"}}>
                                <div className="admin-btn-wrap-l">
                                    <BsSquareFill className="admin-tb-header-notice"/>
                                    <a>현재 적용된 요금표(단위:kg/&#8361;)</a>
                                </div>
                            </div>
                            <div style={{width: "100%", maxWidth: "100%",overflowX: "auto", display: "flex", flexDirection: "row"}}>
                                <Table striped bordered hover className="admin-tb">
                                    <thead className="admin-tb-head">
                                    <tr className="admin-tb-head-line">
                                        <th style={{width: "75px"}}><b>지역코드</b></th>
                                        <th style={{width: "75px"}}><b>0.5kg</b></th>
                                        <th style={{width: "75px"}}><b>1kg</b></th>
                                        <th style={{width: "75px"}}><b>1.5kg</b></th>
                                        <th style={{width: "75px"}}><b>2kg</b></th>
                                        <th style={{width: "75px"}}><b>2.5kg</b></th>
                                        <th style={{width: "75px"}}><b>3.0kg</b></th>
                                        <th style={{width: "75px"}}><b>3.5kg</b></th>
                                        <th style={{width: "75px"}}><b>4.0kg</b></th>
                                        <th style={{width: "75px"}}><b>4.5kg</b></th>
                                        <th style={{width: "75px"}}><b>5.0kg</b></th>
                                        <th style={{width: "75px"}}><b>5.5kg</b></th>
                                        <th style={{width: "75px"}}><b>6.0kg</b></th>
                                        <th style={{width: "75px"}}><b>6.5kg</b></th>
                                        <th style={{width: "75px"}}><b>7.0kg</b></th>
                                        <th style={{width: "75px"}}><b>7.5kg</b></th>
                                        <th style={{width: "75px"}}><b>8.0kg</b></th>
                                        <th style={{width: "75px"}}><b>8.5kg</b></th>
                                        <th style={{width: "75px"}}><b>9.0kg</b></th>
                                        <th style={{width: "75px"}}><b>9.5kg</b></th>
                                        <th style={{width: "75px"}}><b>10.0kg</b></th>
                                        <th style={{width: "75px"}}><b>10.5kg</b></th>
                                        <th style={{width: "75px"}}><b>11kg</b></th>
                                        <th style={{width: "75px"}}><b>11.5kg</b></th>
                                        <th style={{width: "75px"}}><b>12kg</b></th>
                                        <th style={{width: "75px"}}><b>12.5kg</b></th>
                                        <th style={{width: "75px"}}><b>13kg</b></th>
                                        <th style={{width: "75px"}}><b>13.5kg</b></th>
                                        <th style={{width: "75px"}}><b>14kg</b></th>
                                        <th style={{width: "75px"}}><b>14.5kg</b></th>
                                        <th style={{width: "75px"}}><b>15kg</b></th>
                                        <th style={{width: "75px"}}><b>15.5kg</b></th>
                                        <th style={{width: "75px"}}><b>16kg</b></th>
                                        <th style={{width: "75px"}}><b>16.5kg</b></th>
                                        <th style={{width: "75px"}}><b>17kg</b></th>
                                        <th style={{width: "75px"}}><b>17.5kg</b></th>
                                        <th style={{width: "75px"}}><b>18kg</b></th>
                                        <th style={{width: "75px"}}><b>18.5kg</b></th>
                                        <th style={{width: "75px"}}><b>19kg</b></th>
                                        <th style={{width: "75px"}}><b>19.5kg</b></th>
                                        <th style={{width: "75px"}}><b>20kg</b></th>
                                        <th style={{width: "75px"}}><b>20.5kg</b></th>
                                        <th style={{width: "75px"}}><b>21kg</b></th>
                                        <th style={{width: "75px"}}><b>22kg</b></th>
                                        <th style={{width: "75px"}}><b>23kg</b></th>
                                        <th style={{width: "75px"}}><b>24kg</b></th>
                                        <th style={{width: "75px"}}><b>25kg</b></th>
                                        <th style={{width: "75px"}}><b>26kg</b></th>
                                        <th style={{width: "75px"}}><b>27kg</b></th>
                                        <th style={{width: "75px"}}><b>28kg</b></th>
                                        <th style={{width: "75px"}}><b>29kg</b></th>
                                        <th style={{width: "75px"}}><b>30kg</b></th>
                                        {/*<th style={{width: "75px"}}><b>31kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>32kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>33kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>34kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>35kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>36kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>37kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>38kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>39kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>40kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>41kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>42kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>43kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>44kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>45kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>46kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>47kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>48kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>49kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>50kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>51kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>52kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>53kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>54kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>55kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>56kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>57kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>58kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>59kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>60kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>61kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>62kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>63kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>64kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>65kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>66kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>67kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>68kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>69kg</b></th>*/}
                                        {/*<th style={{width: "75px"}}><b>70kg</b></th>*/}
                                    </tr>
                                    </thead>
                                    <tbody className="admin-tb-body">
                                    {upsEcoData.map((cData, i) => (
                                        <tr className="admin-tb-body-line" key={cData.seqNum}>
                                            <td><a>{upsEcoData[i].appUpsEcoCode}</a></td>
                                            <td><a>{upsEcoData[i].w500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsEcoData[i].w1000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsEcoData[i].w1500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsEcoData[i].w2000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsEcoData[i].w2500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsEcoData[i].w3000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsEcoData[i].w3500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsEcoData[i].w4000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsEcoData[i].w4500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsEcoData[i].w5000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsEcoData[i].w5500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsEcoData[i].w6000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsEcoData[i].w6500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsEcoData[i].w7000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsEcoData[i].w7500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsEcoData[i].w8000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsEcoData[i].w8500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsEcoData[i].w9000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsEcoData[i].w9500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsEcoData[i].w10000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsEcoData[i].w10500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsEcoData[i].w11000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsEcoData[i].w11500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsEcoData[i].w12000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsEcoData[i].w12500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsEcoData[i].w13000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsEcoData[i].w13500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsEcoData[i].w14000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsEcoData[i].w14500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsEcoData[i].w15000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsEcoData[i].w15500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsEcoData[i].w16000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsEcoData[i].w16500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsEcoData[i].w17000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsEcoData[i].w17500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsEcoData[i].w18000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsEcoData[i].w18500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsEcoData[i].w19000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsEcoData[i].w19500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsEcoData[i].w20000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsEcoData[i].w20500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsEcoData[i].w21000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsEcoData[i].w22000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsEcoData[i].w23000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsEcoData[i].w24000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsEcoData[i].w25000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsEcoData[i].w26000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsEcoData[i].w27000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsEcoData[i].w28000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsEcoData[i].w29000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{upsEcoData[i].w30000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            {/*<td><a>{upsData[i].w31000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w32000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w33000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w34000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w35000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w36000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w37000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w38000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w39000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w40000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w41000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w42000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w43000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w44000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w45000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w46000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w47000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w48000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w49000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w50000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w51000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w52000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w53000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w54000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w55000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w56000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w57000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w58000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w59000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w60000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w61000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w62000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w63000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w64000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w65000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w66000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w67000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w68000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w69000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                            {/*<td><a>{upsData[i].w70000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>*/}
                                        </tr>
                                    ))}
                                    </tbody>
                                </Table>
                            </div>
                            <div className="font-t-cont font-s-14">
                                {/*<p className="font-b">Z1[1지역] - CN:중국, HK:홍콩, MO:마카오, TW:타이완</p>*/}
                                {/*<p className="font-b">Z2[2지역] - BN:브루나이, KH:캄보디아, JP:일본, LA:라오스, MY:말레이시아, SG:싱가포르, TH:태국, VN:베트남</p>*/}
                                {/*<p className="font-b">Z3[3지역] - </p>*/}
                                {/*<p className="font-b">Z4[4지역] - </p>*/}
                                {/*<p className="font-b">ZA[4-1지역] - RU:러시아</p>*/}
                                {/*<p className="font-b">Z5[5지역] - </p>*/}
                            </div>
                        </Tab>
                        <Tab eventKey="mam-tab-sub" title="&nbsp;&nbsp;&nbsp;&nbsp;EMS&nbsp;&nbsp;&nbsp;&nbsp;">
                            <div>
                                <div className="admin-event-wrap">
                                    <div className="admin-event-wrap-btn">
                                        <div style={{display: "flex", flexDirection: "row"}}>
                                            <div className="m-r-10" style={{position: "relative"}}>
                                                <input
                                                    type="file"
                                                    onChange={excelUploadEMS}
                                                    ref={fileSelect}
                                                    style={{display: "none"}}/>
                                                <button
                                                    id="ex-btn"
                                                    className="admin-btn-A wd-100 ht-30 font-s-13 btn-click-event m-r-10"
                                                    onClick={() => fileSelect.current.click()}>
                                                    파일선택
                                                </button>
                                            </div>

                                            {selectedSheet && (
                                                <select className="admin-combo font-s-13" id="sheet-select"
                                                        value={selectedSheet.value} onChange={sheetSelectEMS}
                                                        style={{width: "120px", height: "25px", marginTop: "2px"}}>
                                                    {excelData.SheetNames.map((sheetName) => (
                                                        <option key={sheetName} value={sheetName}>
                                                        {sheetName}
                                                        </option>
                                                    ))}
                                                </select>
                                            )}
                                        </div>
                                    </div>
                                    <div className="admin-event-wrap-btn gap10">
                                        <button className="admin-btn-A wd-100 ht-30 font-s-13 btn-click-event" onClick={excelDownEMS}>EXCEL[양식]</button>
                                        <button className="admin-btn-A wd-100 ht-30 font-s-13 btn-click-event" onClick={alert3}>저장</button>
                                    </div>
                                </div>
                            </div>
                            <div className="gbn-border-b" style={{width: "100%", marginBottom: "15px"}}></div>
                            <div className="admin-event-wrap" style={{marginTop: "10px", marginBottom: "-1px"}}>
                                <div className="admin-btn-wrap-l">
                                    <BsSquareFill className="admin-tb-header-notice"/>
                                    <a>새로 적용할 요금표[EXCEL]</a>
                                </div>
                            </div>
                            <div style={{width: "100%", maxWidth: "100%",overflowX: "auto", display: "flex", flexDirection: "row"}}>
                                {selectedSheet && (
                                    <Table className="admin-tb" striped bordered hover>
                                        <thead className="admin-tb-head">
                                        <tr className="admin-tb-head-line">
                                            {sheetData[0] && sheetData[0].map((header) =>
                                                <th key={header} style={{width: "80px"}}>
                                                    <b>{header}</b>
                                                </th>)
                                            }
                                        </tr>
                                        </thead>
                                        <tbody className="admin-tb-body">
                                        {sheetData.slice(1).map((row, i) => (
                                            <tr className="admin-tb-body-line" key={i}>
                                                {row.map((cell, j) => (
                                                    <td key={`${i}-${j}`}><a>{cell.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                ))}
                                            </tr>
                                        ))}
                                        </tbody>
                                    </Table>
                                )}
                            </div>
                            <div className="admin-event-wrap" style={{marginTop: "70px", marginBottom: "-1px"}}>
                                <div className="admin-btn-wrap-l">
                                    <BsSquareFill className="admin-tb-header-notice"/>
                                    <a>현재 적용된 요금표(단위:g/&#8361;)</a>
                                </div>
                            </div>
                            <div style={{width: "100%", maxWidth: "100%",overflowX: "auto", display: "flex", flexDirection: "row"}}>
                                <Table striped bordered hover className="admin-tb">
                                    <thead className="admin-tb-head">
                                    <tr className="admin-tb-head-line">
                                        <th style={{width: "70px"}}><b>식별번호</b></th>
                                        <th style={{width: "120px"}}><b>국가</b></th>
                                        <th style={{width: "75px"}}><b>500g</b></th>
                                        <th style={{width: "75px"}}><b>750g</b></th>
                                        <th style={{width: "75px"}}><b>1000g</b></th>
                                        <th style={{width: "75px"}}><b>1250g</b></th>
                                        <th style={{width: "75px"}}><b>1500g</b></th>
                                        <th style={{width: "75px"}}><b>1750g</b></th>
                                        <th style={{width: "75px"}}><b>2000g</b></th>
                                        <th style={{width: "75px"}}><b>2500g</b></th>
                                        <th style={{width: "75px"}}><b>3000g</b></th>
                                        <th style={{width: "75px"}}><b>3500g</b></th>
                                        <th style={{width: "75px"}}><b>4000g</b></th>
                                        <th style={{width: "75px"}}><b>4500g</b></th>
                                        <th style={{width: "75px"}}><b>5000g</b></th>
                                        <th style={{width: "75px"}}><b>5500g</b></th>
                                        <th style={{width: "75px"}}><b>6000g</b></th>
                                        <th style={{width: "75px"}}><b>6500g</b></th>
                                        <th style={{width: "75px"}}><b>7000g</b></th>
                                        <th style={{width: "75px"}}><b>7500g</b></th>
                                        <th style={{width: "75px"}}><b>8000g</b></th>
                                        <th style={{width: "75px"}}><b>8500g</b></th>
                                        <th style={{width: "75px"}}><b>9000g</b></th>
                                        <th style={{width: "75px"}}><b>9500g</b></th>
                                        <th style={{width: "75px"}}><b>10000g</b></th>
                                        <th style={{width: "75px"}}><b>10500g</b></th>
                                        <th style={{width: "75px"}}><b>11000g</b></th>
                                        <th style={{width: "75px"}}><b>11500g</b></th>
                                        <th style={{width: "75px"}}><b>12000g</b></th>
                                        <th style={{width: "75px"}}><b>12500g</b></th>
                                        <th style={{width: "75px"}}><b>13000g</b></th>
                                        <th style={{width: "75px"}}><b>13500g</b></th>
                                        <th style={{width: "75px"}}><b>14000g</b></th>
                                        <th style={{width: "75px"}}><b>14500g</b></th>
                                        <th style={{width: "75px"}}><b>15000g</b></th>
                                        <th style={{width: "75px"}}><b>15500g</b></th>
                                        <th style={{width: "75px"}}><b>16000g</b></th>
                                        <th style={{width: "75px"}}><b>16500g</b></th>
                                        <th style={{width: "75px"}}><b>17000g</b></th>
                                        <th style={{width: "75px"}}><b>17500g</b></th>
                                        <th style={{width: "75px"}}><b>18000g</b></th>
                                        <th style={{width: "75px"}}><b>18500g</b></th>
                                        <th style={{width: "75px"}}><b>19000g</b></th>
                                        <th style={{width: "75px"}}><b>19500g</b></th>
                                        <th style={{width: "75px"}}><b>20000g</b></th>
                                        <th style={{width: "75px"}}><b>20500g</b></th>
                                        <th style={{width: "75px"}}><b>21000g</b></th>
                                        <th style={{width: "75px"}}><b>21500g</b></th>
                                        <th style={{width: "75px"}}><b>22000g</b></th>
                                        <th style={{width: "75px"}}><b>22500g</b></th>
                                        <th style={{width: "75px"}}><b>23000g</b></th>
                                        <th style={{width: "75px"}}><b>23500g</b></th>
                                        <th style={{width: "75px"}}><b>24000g</b></th>
                                        <th style={{width: "75px"}}><b>24500g</b></th>
                                        <th style={{width: "75px"}}><b>25000g</b></th>
                                        <th style={{width: "75px"}}><b>25500g</b></th>
                                        <th style={{width: "75px"}}><b>26000g</b></th>
                                        <th style={{width: "75px"}}><b>26500g</b></th>
                                        <th style={{width: "75px"}}><b>27000g</b></th>
                                        <th style={{width: "75px"}}><b>27500g</b></th>
                                        <th style={{width: "75px"}}><b>28000g</b></th>
                                        <th style={{width: "75px"}}><b>28500g</b></th>
                                        <th style={{width: "75px"}}><b>29000g</b></th>
                                        <th style={{width: "75px"}}><b>29500g</b></th>
                                        <th style={{width: "75px"}}><b>30000g</b></th>
                                    </tr>
                                    </thead>
                                    <tbody className="admin-tb-body">
                                        {emsData.map((cData, i) => (
                                            <tr className="admin-tb-body-line" key={cData.seqNum}>
                                                <td><a>{emsData[i].seqNum}</a></td>
                                                <td>
                                                    <a>
                                                        {["LA", "BD", "IL", "MX"].includes(emsData[i].countryDTO.countryCode) ? "" : emsData[i].countryDTO.countryNm}
                                                        {
                                                            emsData[i].countryDTO.countryCode === "LA" ? "1지역" :
                                                                emsData[i].countryDTO.countryCode === "BD" ? "2지역" :
                                                                    emsData[i].countryDTO.countryCode === "IL" ? "3지역" :
                                                                        emsData[i].countryDTO.countryCode === "MX" ? "4지역" : ""
                                                        }
                                                    </a>
                                                </td>
                                                <td><a>{emsData[i].w500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w750.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w1000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w1250.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w1500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w1750.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w2000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w2500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w3000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w3500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w4000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w4500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w5000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w5500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w6000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w6500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w7000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w7500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w8000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w8500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w9000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w9500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w10000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w10500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w11000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w11500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w12000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w12500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w13000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w13500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w14000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w14500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w15000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w15500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w16000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w16500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w17000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w17500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w18000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w18500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w19000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w19500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w20000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w20500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w21000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w21500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w22000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w22500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w23000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w23500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w24000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w24500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w25000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w25500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w26000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w26500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w27000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w27500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w28000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w28500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w29000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w29500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                <td><a>{emsData[i].w30000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>
                            <div className="font-s-14 font-t-cont">
                                <p className="font-b">[1지역] - LA:라오스, MO:마카오, KH:캄보디아, MM:미얀마, MN:몽골</p>
                                <p className="font-b">[2지역] - BD:방글라데시, BN:브루나이, IN:인도, NP:네팔, LK:스리랑카, MV:몰디브, BT:부탄</p>
                                <p className="font-b">[3지역] - BE:벨기에, DK:덴마크, FL:핀란드, NO:노르웨이, PT:포르투갈, CH:스위스, SE:스웨덴, AT:오스트리아, RO:루마니아, PL:폴란드, HU:헝가리,
                                    CZ:체코, BH:바레인, IR:이란, IQ:이라크, IL:이스라엘, JO:요르단, TR:튀르키예, KW:쿠웨이트, SA:사우디아라비아, QA:카타르, SY:시리아, PG:파푸아뉴기니, GU:괌, AF:아프가니스탄, AE:아랍에미리트</p>
                                <p className="font-b">[4지역] - EG:이집트, KE:케냐, LY:리비아, MX:멕시코, PA:파나마, AR:아르헨티나, UY:우루과이, PE:페루, CU:쿠바, HT:아이티, DO:도미니카공화국</p>
                            </div>
                        </Tab>
                        <Tab eventKey="mam-tab-sub-pre" title="&nbsp;&nbsp;&nbsp;&nbsp;EMSP&nbsp;&nbsp;&nbsp;&nbsp;">
                            <div>
                                <div className="admin-event-wrap">
                                    <div className="admin-event-wrap-btn">
                                        <div style={{display: "flex", flexDirection: "row"}}>
                                            <div className="m-r-10" style={{position: "relative"}}>
                                                <input
                                                    type="file"
                                                    onChange={excelUploadEMSP}
                                                    ref={fileSelectep}
                                                    style={{display: "none"}}/>
                                                <button
                                                    id="ex-btn"
                                                    className="admin-btn-A wd-100 ht-30 font-s-13 btn-click-event m-r-10"
                                                    onClick={() => fileSelectep.current.click()}>
                                                    파일선택
                                                </button>
                                            </div>

                                            {selectedSheetp && (
                                                <select className="admin-combo font-s-13" id="sheet-select"
                                                        value={selectedSheetp.value} onChange={sheetSelectEMSP}
                                                        style={{width: "120px", height: "25px", marginTop: "2px"}}>
                                                    {excelDataep.SheetNames.map((sheetName) => (
                                                        <option key={sheetName} value={sheetName}>
                                                        {sheetName}
                                                        </option>
                                                    ))}
                                                </select>
                                            )}
                                        </div>
                                    </div>
                                    <div className="admin-event-wrap-btn gap10">
                                        <button className="admin-btn-A wd-100 ht-30 font-s-13 btn-click-event" onClick={excelDownEMSP}>EXCEL[양식]</button>
                                        <button className="admin-btn-A wd-100 ht-30 font-s-13 btn-click-event" onClick={alert4}>저장</button>
                                    </div>
                                </div>
                            </div>
                            <div className="gbn-border-b" style={{width: "100%", marginBottom: "15px"}}></div>
                            <div className="admin-event-wrap" style={{marginTop: "10px", marginBottom: "-1px"}}>
                                <div className="admin-btn-wrap-l">
                                    <BsSquareFill className="admin-tb-header-notice"/>
                                    <a>새로 적용할 요금표[EXCEL]</a>
                                </div>
                            </div>
                            <div style={{width: "100%", maxWidth: "100%",overflowX: "auto", display: "flex", flexDirection: "row"}}>
                                {selectedSheetp && (
                                    <Table className="admin-tb" striped bordered hover>
                                        <thead className="admin-tb-head">
                                        <tr className="admin-tb-head-line">
                                            {sheetDatap[0] && sheetDatap[0].map((header) =>
                                                <th key={header} style={{width: "80px"}}>
                                                    <b>{header}</b>
                                                </th>)
                                            }
                                        </tr>
                                        </thead>
                                        <tbody className="admin-tb-body">
                                        {sheetDatap.slice(1).map((row, i) => (
                                            <tr className="admin-tb-body-line" key={i}>
                                                {row.map((cell, j) => (
                                                    <td key={`${i}-${j}`}><a>{cell.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                ))}
                                            </tr>
                                        ))}
                                        </tbody>
                                    </Table>
                                )}
                            </div>
                            <div className="admin-event-wrap" style={{marginTop: "70px", marginBottom: "-1px"}}>
                                <div className="admin-btn-wrap-l">
                                    <BsSquareFill className="admin-tb-header-notice"/>
                                    <a>현재 적용된 요금표(단위:kg/&#8361;)</a>
                                </div>
                            </div>
                            <div style={{width: "100%", maxWidth: "100%",overflowX: "auto", display: "flex", flexDirection: "row"}}>
                                <Table striped bordered hover className="admin-tb">
                                    <thead className="admin-tb-head">
                                    <tr className="admin-tb-head-line">
                                        <th style={{width: "70px"}}><b>식별번호</b></th>
                                        <th style={{width: "120px"}}><b>국가</b></th>
                                        <th style={{width: "75px"}}><b>0.5kg</b></th>
                                        <th style={{width: "75px"}}><b>1kg</b></th>
                                        <th style={{width: "75px"}}><b>1.5kg</b></th>
                                        <th style={{width: "75px"}}><b>2kg</b></th>
                                        <th style={{width: "75px"}}><b>2.5kg</b></th>
                                        <th style={{width: "75px"}}><b>3.0kg</b></th>
                                        <th style={{width: "75px"}}><b>3.5kg</b></th>
                                        <th style={{width: "75px"}}><b>4.0kg</b></th>
                                        <th style={{width: "75px"}}><b>4.5kg</b></th>
                                        <th style={{width: "75px"}}><b>5.0kg</b></th>
                                        <th style={{width: "75px"}}><b>5.5kg</b></th>
                                        <th style={{width: "75px"}}><b>6.0kg</b></th>
                                        <th style={{width: "75px"}}><b>6.5kg</b></th>
                                        <th style={{width: "75px"}}><b>7.0kg</b></th>
                                        <th style={{width: "75px"}}><b>7.5kg</b></th>
                                        <th style={{width: "75px"}}><b>8.0kg</b></th>
                                        <th style={{width: "75px"}}><b>8.5kg</b></th>
                                        <th style={{width: "75px"}}><b>9.0kg</b></th>
                                        <th style={{width: "75px"}}><b>9.5kg</b></th>
                                        <th style={{width: "75px"}}><b>10kg</b></th>
                                        <th style={{width: "75px"}}><b>10.5kg</b></th>
                                        <th style={{width: "75px"}}><b>11kg</b></th>
                                        <th style={{width: "75px"}}><b>11.5kg</b></th>
                                        <th style={{width: "75px"}}><b>12kg</b></th>
                                        <th style={{width: "75px"}}><b>12.5kg</b></th>
                                        <th style={{width: "75px"}}><b>13kg</b></th>
                                        <th style={{width: "75px"}}><b>13.5kg</b></th>
                                        <th style={{width: "75px"}}><b>14kg</b></th>
                                        <th style={{width: "75px"}}><b>14.5kg</b></th>
                                        <th style={{width: "75px"}}><b>15kg</b></th>
                                        <th style={{width: "75px"}}><b>15.5kg</b></th>
                                        <th style={{width: "75px"}}><b>16kg</b></th>
                                        <th style={{width: "75px"}}><b>16.5kg</b></th>
                                        <th style={{width: "75px"}}><b>17kg</b></th>
                                        <th style={{width: "75px"}}><b>17.5kg</b></th>
                                        <th style={{width: "75px"}}><b>18kg</b></th>
                                        <th style={{width: "75px"}}><b>18.5kg</b></th>
                                        <th style={{width: "75px"}}><b>19kg</b></th>
                                        <th style={{width: "75px"}}><b>19.5kg</b></th>
                                        <th style={{width: "75px"}}><b>20kg</b></th>
                                        <th style={{width: "75px"}}><b>21kg</b></th>
                                        <th style={{width: "75px"}}><b>22kg</b></th>
                                        <th style={{width: "75px"}}><b>23kg</b></th>
                                        <th style={{width: "75px"}}><b>24kg</b></th>
                                        <th style={{width: "75px"}}><b>25kg</b></th>
                                        <th style={{width: "75px"}}><b>26kg</b></th>
                                        <th style={{width: "75px"}}><b>27kg</b></th>
                                        <th style={{width: "75px"}}><b>28kg</b></th>
                                        <th style={{width: "75px"}}><b>29kg</b></th>
                                        <th style={{width: "75px"}}><b>30kg</b></th>
                                        <th style={{width: "75px"}}><b>31kg</b></th>
                                        <th style={{width: "75px"}}><b>32kg</b></th>
                                        <th style={{width: "75px"}}><b>33kg</b></th>
                                        <th style={{width: "75px"}}><b>34kg</b></th>
                                        <th style={{width: "75px"}}><b>35kg</b></th>
                                        <th style={{width: "75px"}}><b>36kg</b></th>
                                        <th style={{width: "75px"}}><b>37kg</b></th>
                                        <th style={{width: "75px"}}><b>38kg</b></th>
                                        <th style={{width: "75px"}}><b>39kg</b></th>
                                        <th style={{width: "75px"}}><b>40kg</b></th>
                                        <th style={{width: "75px"}}><b>41kg</b></th>
                                        <th style={{width: "75px"}}><b>42kg</b></th>
                                        <th style={{width: "75px"}}><b>43kg</b></th>
                                        <th style={{width: "75px"}}><b>44kg</b></th>
                                        <th style={{width: "75px"}}><b>45kg</b></th>
                                        <th style={{width: "75px"}}><b>46kg</b></th>
                                        <th style={{width: "75px"}}><b>47kg</b></th>
                                        <th style={{width: "75px"}}><b>48kg</b></th>
                                        <th style={{width: "75px"}}><b>49kg</b></th>
                                        <th style={{width: "75px"}}><b>50kg</b></th>
                                        <th style={{width: "75px"}}><b>51kg</b></th>
                                        <th style={{width: "75px"}}><b>52kg</b></th>
                                        <th style={{width: "75px"}}><b>53kg</b></th>
                                        <th style={{width: "75px"}}><b>54kg</b></th>
                                        <th style={{width: "75px"}}><b>55kg</b></th>
                                        <th style={{width: "75px"}}><b>56kg</b></th>
                                        <th style={{width: "75px"}}><b>57kg</b></th>
                                        <th style={{width: "75px"}}><b>58kg</b></th>
                                        <th style={{width: "75px"}}><b>59kg</b></th>
                                        <th style={{width: "75px"}}><b>60kg</b></th>
                                        <th style={{width: "75px"}}><b>61kg</b></th>
                                        <th style={{width: "75px"}}><b>62kg</b></th>
                                        <th style={{width: "75px"}}><b>63kg</b></th>
                                        <th style={{width: "75px"}}><b>64kg</b></th>
                                        <th style={{width: "75px"}}><b>65kg</b></th>
                                        <th style={{width: "75px"}}><b>66kg</b></th>
                                        <th style={{width: "75px"}}><b>67kg</b></th>
                                        <th style={{width: "75px"}}><b>68kg</b></th>
                                        <th style={{width: "75px"}}><b>69kg</b></th>
                                        <th style={{width: "75px"}}><b>70kg</b></th>
                                    </tr>
                                    </thead>
                                    <tbody className="admin-tb-body">
                                    {emsPreData.map((cData, i) => (
                                        <tr className="admin-tb-body-line" key={cData.seqNum}>
                                            <td><a>{emsPreData[i].seqNum}</a></td>
                                            <td><a>{emsPreData[i].appEmsPreCode}</a></td>
                                            <td><a>{emsPreData[i].w500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w1000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w1500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w2000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w2500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w3000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w3500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w4000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w4500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w5000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w5500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w6000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w6500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w7000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w7500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w8000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w8500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w9000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w9500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w10000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w10500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w11000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w11500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w12000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w12500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w13000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w13500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w14000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w14500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w15000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w15500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w16000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w16500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w17000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w17500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w18000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w18500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w19000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w19500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w20000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w21000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w22000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w23000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w24000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w25000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w26000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w27000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w28000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w29000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w30000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w31000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w32000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w33000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w34000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w35000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w36000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w37000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w38000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w39000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w40000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w41000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w42000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w43000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w44000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w45000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w46000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w47000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w48000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w49000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w50000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w51000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w52000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w53000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w54000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w55000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w56000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w57000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w58000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w59000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w60000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w61000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w62000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w63000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w64000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w65000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w66000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w67000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w68000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w69000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td><a>{emsPreData[i].w70000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </Table>
                            </div>
                            <div className="font-s-14 font-t-cont">
                                {/*<p className="font-b">[1지역] - LA:라오스, MO:마카오, KH:캄보디아, MM:미얀마, MN:몽골</p>*/}
                                {/*<p className="font-b">[2지역] - BD:방글라데시, BN:브루나이, IN:인도, NP:네팔, LK:스리랑카, MV:몰디브, BT:부탄</p>*/}
                                {/*<p className="font-b">[3지역] - BE:벨기에, DK:덴마크, FL:핀란드, NO:노르웨이, PT:포르투갈, CH:스위스, SE:스웨덴, AT:오스트리아, RO:루마니아, PL:폴란드, HU:헝가리,*/}
                                {/*    CZ:체코, BH:바레인, IR:이란, IQ:이라크, IL:이스라엘, JO:요르단, TR:튀르키예, KW:쿠웨이트, SA:사우디아라비아, QA:카타르, SY:시리아, PG:파푸아뉴기니, GU:괌, AF:아프가니스탄, AE:아랍에미리트</p>*/}
                                {/*<p className="font-b">[4지역] - EG:이집트, KE:케냐, LY:리비아, MX:멕시코, PA:파나마, AR:아르헨티나, UY:우루과이, PE:페루, CU:쿠바, HT:아이티, DO:도미니카공화국</p>*/}
                            </div>
                        </Tab>
                        <Tab eventKey="mam-tab-sub-ship" title="&nbsp;&nbsp;&nbsp;&nbsp;SHIP&nbsp;&nbsp;&nbsp;&nbsp;">
                            <div>
                                <div className="admin-event-wrap">
                                    <div className="admin-event-wrap-btn">
                                        <div style={{display: "flex", flexDirection: "row"}}>
                                            <div className="m-l-10" style={{position: "relative"}}>
                                                <input
                                                    type="file"
                                                    onChange={excelUploadSHIP}
                                                    ref={fileSelects}
                                                    style={{display: "none"}}/>
                                                <button
                                                    id="ex-btn"
                                                    className="admin-btn-A wd-100 ht-30 font-s-13 btn-click-event m-r-10"
                                                    onClick={() => fileSelects.current.click()}>
                                                    파일선택
                                                </button>
                                            </div>

                                            {selectedSheets && (
                                                <select className="admin-combo font-s-13" id="sheet-select"
                                                        value={selectedSheets.value} onChange={sheetSelectSHIP}
                                                        style={{width: "120px", height: "25px", marginTop: "2px"}}>
                                                    {excelDatas.SheetNames.map((sheetName) => (
                                                        <option key={sheetName} value={sheetName}>
                                                        {sheetName}
                                                        </option>
                                                    ))}
                                                </select>
                                            )}
                                        </div>
                                    </div>
                                    <div className="admin-event-wrap-btn gap10">
                                        <button className="admin-btn-A wd-100 ht-30 font-s-13 btn-click-event" onClick={excelDownSHIP}>EXCEL[양식]</button>
                                        <button className="admin-btn-A wd-100 ht-30 font-s-13 btn-click-event" onClick={alert9}>저장</button>
                                    </div>
                                </div>
                            </div>
                            <div className="gbn-border-b" style={{width: "100%", marginTop: "18px", marginBottom: "15px"}}></div>
                            <div className="admin-event-wrap" style={{marginTop: "10px", marginBottom: "-1px"}}>
                                <div className="admin-btn-wrap-l">
                                    <BsSquareFill className="admin-tb-header-notice"/>
                                    <a>새로 적용할 요금표[EXCEL]</a>
                                </div>
                            </div>
                            <div style={{width: "100%", maxWidth: "100%",overflowX: "auto", display: "flex", flexDirection: "row"}}>
                                {selectedSheets && (
                                    <div className="div-tb m-b-10">
                                        <div className="div-tb-head ht-60">
                                            {sheetDatas[0] && sheetDatas[0].map((header) =>
                                                <div key={header} className="wd-80">
                                                    <p>{header}</p>
                                                </div>)
                                            }
                                        </div>
                                        {sheetDatas.slice(1).map((row, i) => (
                                            <div className="div-tb-body ht-70" key={i}>
                                                {row.map((cell, j) => (
                                                    <div key={`${i}-${j}`} className="wd-80">
                                                        <a>{cell.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a>
                                                    </div>
                                                ))}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                            <div className="admin-event-wrap" style={{marginTop: "70px", marginBottom: "-1px"}}>
                                <div className="admin-btn-wrap-l">
                                    <BsSquareFill className="admin-tb-header-notice"/>
                                    <a>현재 적용된 요금표(단위:g/&#8361;)</a>
                                </div>
                            </div>
                            <div style={{width: "100%", maxWidth: "100%",overflowX: "auto", display: "flex", flexDirection: "row"}}>
                                <div className="div-tb m-b-10">
                                    <div className="div-tb-head ht-60">
                                        <div className="wd-80"><p>지역코드</p></div>
                                        <div className="wd-80"><p>1000g</p></div>
                                        <div className="wd-80"><p>2000g</p></div>
                                        <div className="wd-80"><p>4000g</p></div>
                                        <div className="wd-80"><p>6000g</p></div>
                                        <div className="wd-80"><p>8000g</p></div>
                                        <div className="wd-80"><p>10000g</p></div>
                                        <div className="wd-80"><p>12000g</p></div>
                                        <div className="wd-80"><p>14000g</p></div>
                                        <div className="wd-80"><p>16000g</p></div>
                                        <div className="wd-80"><p>18000g</p></div>
                                        <div className="wd-80"><p>20000g</p></div>
                                    </div>
                                    {shipData.map((cData, i) => (
                                        <div key={cData.seqNum} className="div-tb-body ht-70">
                                            <div className="wd-80"><p>{shipData[i].appShipCode}</p></div>
                                            <div className="wd-80"><p>{shipData[i].w1000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</p></div>
                                            <div className="wd-80"><p>{shipData[i].w2000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</p></div>
                                            <div className="wd-80"><p>{shipData[i].w4000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</p></div>
                                            <div className="wd-80"><p>{shipData[i].w6000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</p></div>
                                            <div className="wd-80"><p>{shipData[i].w8000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</p></div>
                                            <div className="wd-80"><p>{shipData[i].w10000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</p></div>
                                            <div className="wd-80"><p>{shipData[i].w12000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</p></div>
                                            <div className="wd-80"><p>{shipData[i].w14000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</p></div>
                                            <div className="wd-80"><p>{shipData[i].w16000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</p></div>
                                            <div className="wd-80"><p>{shipData[i].w18000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</p></div>
                                            <div className="wd-80"><p>{shipData[i].w20000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</p></div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="font-t-cont font-s-14">
                                <p className="font-b">Z1[1지역] - CN:중국, HK:홍콩, JP:일본, TW:타이완</p>
                                <p className="font-b">Z2[2지역] - BD:방글라데시, ID:인도네시아, MY:말레이시아, PH:필리핀, SG:싱가포르, VN:베트남</p>
                                <p className="font-b">Z3[3지역] - AU:호주, CA:캐나다, DE:독일, ES:스페인, FR:프랑스, GB:영국, IE:아일랜드, NL:네덜란드, NZ:뉴질랜드, PL:폴란드, US:미국</p>
                                <p className="font-b">Z4[4지역] - PE:페루</p>
                            </div>
                        </Tab>
                        <Tab eventKey="mam-tab-sub-kPack" title="&nbsp;&nbsp;&nbsp;K-Packet&nbsp;&nbsp;&nbsp;">
                            <div>
                                <div className="admin-event-wrap">
                                    <div className="admin-event-wrap-btn">
                                        <div style={{display: "flex", flexDirection: "row"}}>
                                            <div className="m-l-10" style={{position: "relative"}}>
                                                <input
                                                    type="file"
                                                    onChange={excelUploadKP}
                                                    ref={fileSelectKp}
                                                    style={{display: "none"}}/>
                                                <button
                                                    id="ex-btn"
                                                    className="admin-btn-A wd-100 ht-30 font-s-13 btn-click-event m-r-10"
                                                    onClick={() => fileSelectKp.current.click()}>
                                                    파일선택
                                                </button>
                                            </div>

                                            {selectedSheetKp && (
                                                <select className="admin-combo font-s-13" id="sheet-select"
                                                        value={selectedSheetKp.value} onChange={sheetSelectKP}
                                                        style={{width: "120px", height: "25px", marginTop: "2px"}}>
                                                    {excelDataKp.SheetNames.map((sheetName) => (
                                                        <option key={sheetName} value={sheetName}>
                                                        {sheetName}
                                                        </option>
                                                    ))}
                                                </select>
                                            )}
                                        </div>
                                    </div>
                                    <div className="admin-event-wrap-btn gap10">
                                        <button className="admin-btn-A wd-100 ht-30 font-s-13 btn-click-event" onClick={excelDownKP}>EXCEL[양식]</button>
                                        <button className="admin-btn-A wd-100 ht-30 font-s-13 btn-click-event" onClick={alert7}>저장</button>
                                    </div>
                                </div>
                            </div>
                            <div className="gbn-border-b" style={{width: "100%", marginTop: "18px", marginBottom: "15px"}}></div>
                            <div className="admin-event-wrap" style={{marginTop: "10px", marginBottom: "-1px"}}>
                                <div className="admin-btn-wrap-l">
                                    <BsSquareFill className="admin-tb-header-notice"/>
                                    <a>새로 적용할 요금표[EXCEL]</a>
                                </div>
                            </div>
                            <div style={{width: "100%", maxWidth: "100%",overflowX: "auto", display: "flex", flexDirection: "row"}}>
                                {selectedSheetKp && (
                                    <Table className="admin-tb" striped bordered hover>
                                        <thead className="admin-tb-head">
                                        <tr className="admin-tb-head-line">
                                            {sheetDataKp[0] && sheetDataKp[0].map((header) =>
                                                <th key={header} style={{width: "80px"}}>
                                                    <b>{header}</b>
                                                </th>)
                                            }
                                        </tr>
                                        </thead>
                                        <tbody className="admin-tb-body">
                                        {sheetDataKp.slice(1).map((row, i) => (
                                            <tr className="admin-tb-body-line" key={i}>
                                                {row.map((cell, j) => (
                                                    <td key={`${i}-${j}`}><a>{cell.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                                ))}
                                            </tr>
                                        ))}
                                        </tbody>
                                    </Table>
                                )}
                            </div>
                            <div className="admin-event-wrap" style={{marginTop: "70px", marginBottom: "-1px"}}>
                                <div className="admin-btn-wrap-l">
                                    <BsSquareFill className="admin-tb-header-notice"/>
                                    <a>현재 적용된 요금표(단위:g/&#8361;)</a>
                                </div>
                            </div>
                            <div style={{width: "100%", maxWidth: "100%",overflowX: "auto", display: "flex", flexDirection: "row"}}>
                                <Table striped bordered hover className="admin-tb">
                                    <thead className="admin-tb-head">
                                    <tr className="admin-tb-head-line">
                                        <th style={{width: "100px"}}><b>국가</b></th>
                                        <th style={{width: "50px"}}><b>100g</b></th>
                                        <th style={{width: "50px"}}><b>200g</b></th>
                                        <th style={{width: "50px"}}><b>300g</b></th>
                                        <th style={{width: "50px"}}><b>400g</b></th>
                                        <th style={{width: "50px"}}><b>500g</b></th>
                                        <th style={{width: "50px"}}><b>600g</b></th>
                                        <th style={{width: "50px"}}><b>700g</b></th>
                                        <th style={{width: "50px"}}><b>800g</b></th>
                                        <th style={{width: "50px"}}><b>900g</b></th>
                                        <th style={{width: "50px"}}><b>1000g</b></th>
                                        <th style={{width: "50px"}}><b>1100g</b></th>
                                        <th style={{width: "50px"}}><b>1200g</b></th>
                                        <th style={{width: "50px"}}><b>1200g</b></th>
                                        <th style={{width: "50px"}}><b>1400g</b></th>
                                        <th style={{width: "50px"}}><b>1500g</b></th>
                                        <th style={{width: "50px"}}><b>1600g</b></th>
                                        <th style={{width: "50px"}}><b>1700g</b></th>
                                        <th style={{width: "50px"}}><b>1800g</b></th>
                                        <th style={{width: "50px"}}><b>1900g</b></th>
                                        <th style={{width: "50px"}}><b>2000g</b></th>
                                    </tr>
                                    </thead>
                                    <tbody className="admin-tb-body">
                                    {kpackData.map((cData, i) => (
                                        <tr className="admin-tb-body-line" key={cData.seqNum}>
                                            <td style={{width: "100px"}}><a>{kpackData[i].countryDTO.countryNm}</a></td>
                                            <td style={{width: "50px"}}><a>{kpackData[i].w100.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td style={{width: "50px"}}><a>{kpackData[i].w200.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td style={{width: "50px"}}><a>{kpackData[i].w300.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td style={{width: "50px"}}><a>{kpackData[i].w400.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td style={{width: "50px"}}><a>{kpackData[i].w500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td style={{width: "50px"}}><a>{kpackData[i].w600.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td style={{width: "50px"}}><a>{kpackData[i].w700.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td style={{width: "50px"}}><a>{kpackData[i].w800.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td style={{width: "50px"}}><a>{kpackData[i].w900.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td style={{width: "50px"}}><a>{kpackData[i].w1000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td style={{width: "50px"}}><a>{kpackData[i].w1100.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td style={{width: "50px"}}><a>{kpackData[i].w1200.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td style={{width: "50px"}}><a>{kpackData[i].w1300.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td style={{width: "50px"}}><a>{kpackData[i].w1400.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td style={{width: "50px"}}><a>{kpackData[i].w1500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td style={{width: "50px"}}><a>{kpackData[i].w1600.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td style={{width: "50px"}}><a>{kpackData[i].w1700.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td style={{width: "50px"}}><a>{kpackData[i].w1800.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td style={{width: "50px"}}><a>{kpackData[i].w1900.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                            <td style={{width: "50px"}}><a>{kpackData[i].w2000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </Table>
                            </div>
                            <div className="font-s-14 font-t-cont">

                            </div>
                        </Tab>
                        <Tab eventKey="mam-tab-sub-air-s" title="&nbsp;&nbsp;Small-Packet&nbsp;&nbsp;">
                            <div>
                                <div className="admin-event-wrap">
                                    <div className="admin-event-wrap-btn">
                                        <div style={{display: "flex", flexDirection: "row"}}>
                                            <div className="m-l-10" style={{position: "relative"}}>
                                                <input
                                                    type="file"
                                                    onChange={excelUploadAS}
                                                    ref={fileSelectAs}
                                                    style={{display: "none"}}/>
                                                <button
                                                    id="ex-btn"
                                                    className="admin-btn-A wd-100 ht-30 font-s-13 btn-click-event m-r-10"
                                                    onClick={() => fileSelectAs.current.click()}>
                                                    파일선택
                                                </button>
                                            </div>

                                            {selectedSheetAs && (
                                                <select className="admin-combo font-s-13" id="sheet-select"
                                                        value={selectedSheetAs.value} onChange={sheetSelectAS}
                                                        style={{width: "120px", height: "25px", marginTop: "2px"}}>
                                                    {excelDataAs.SheetNames.map((sheetName) => (
                                                        <option key={sheetName} value={sheetName}>
                                                        {sheetName}
                                                        </option>
                                                    ))}
                                                </select>
                                            )}
                                        </div>
                                    </div>
                                    <div className="admin-event-wrap-btn gap10">
                                        <button className="admin-btn-A wd-100 ht-30 font-s-13 btn-click-event" onClick={excelDownAS}>EXCEL[양식]</button>
                                        <button className="admin-btn-A wd-100 ht-30 font-s-13 btn-click-event" onClick={alert8}>저장</button>
                                    </div>
                                </div>
                            </div>
                            <div className="gbn-border-b" style={{width: "100%", marginTop: "18px", marginBottom: "15px"}}></div>
                            <div className="admin-event-wrap" style={{marginTop: "10px", marginBottom: "-1px"}}>
                                <div className="admin-btn-wrap-l">
                                    <BsSquareFill className="admin-tb-header-notice"/>
                                    <a>새로 적용할 요금표[EXCEL]</a>
                                </div>
                            </div>
                            <div style={{width: "100%", maxWidth: "100%",overflowX: "auto", display: "flex", flexDirection: "row"}}>
                                {selectedSheetAs && (
                                    <div className="div-tb m-b-10">
                                        <div className="div-tb-head ht-60">
                                            {sheetDataAs[0] && sheetDataAs[0].map((header) =>
                                                <div key={header} style={{width: "80px"}}>
                                                    <p>{header}</p>
                                                </div>)
                                            }
                                        </div>
                                        {sheetDataAs.slice(1).map((row, i) => (
                                            <div className="div-tb-body ht-70" key={i}>
                                                {row.map((cell, j) => (
                                                    <p key={`${i}-${j}`}><a>{cell.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</a></p>
                                                ))}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                            <div className="admin-event-wrap" style={{marginTop: "70px", marginBottom: "-1px"}}>
                                <div className="admin-btn-wrap-l">
                                    <BsSquareFill className="admin-tb-header-notice"/>
                                    <a>현재 적용된 요금표(단위:g/&#8361;)</a>
                                </div>
                            </div>
                            <div style={{width: "100%", maxWidth: "100%",overflowX: "auto", display: "flex", flexDirection: "row"}}>
                                <div className="div-tb m-b-10">
                                    <div className="div-tb-head ht-60">
                                        <div style={{width: "60px"}}><p>지역코드</p></div>
                                        <div style={{width: "50px"}}><p>100g</p></div>
                                        <div style={{width: "50px"}}><p>200g</p></div>
                                        <div style={{width: "50px"}}><p>300g</p></div>
                                        <div style={{width: "50px"}}><p>400g</p></div>
                                        <div style={{width: "50px"}}><p>500g</p></div>
                                        <div style={{width: "50px"}}><p>600g</p></div>
                                        <div style={{width: "50px"}}><p>700g</p></div>
                                        <div style={{width: "50px"}}><p>800g</p></div>
                                        <div style={{width: "50px"}}><p>900g</p></div>
                                        <div style={{width: "50px"}}><p>1000g</p></div>
                                        <div style={{width: "50px"}}><p>1100g</p></div>
                                        <div style={{width: "50px"}}><p>1200g</p></div>
                                        <div style={{width: "50px"}}><p>1200g</p></div>
                                        <div style={{width: "50px"}}><p>1400g</p></div>
                                        <div style={{width: "50px"}}><p>1500g</p></div>
                                        <div style={{width: "50px"}}><p>1600g</p></div>
                                        <div style={{width: "50px"}}><p>1700g</p></div>
                                        <div style={{width: "50px"}}><p>1800g</p></div>
                                        <div style={{width: "50px"}}><p>1900g</p></div>
                                        <div style={{width: "50px"}}><p>2000g</p></div>
                                    </div>
                                    {airSData.map((cData, i) => (
                                        <div key={cData.seqNum} className="div-tb-body ht-70">
                                            <div style={{width: "60px"}}><p>{airSData[i].appAsCode}</p></div>
                                            <div style={{width: "50px"}}><p>{airSData[i].w100.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</p></div>
                                            <div style={{width: "50px"}}><p>{airSData[i].w200.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</p></div>
                                            <div style={{width: "50px"}}><p>{airSData[i].w300.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</p></div>
                                            <div style={{width: "50px"}}><p>{airSData[i].w400.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</p></div>
                                            <div style={{width: "50px"}}><p>{airSData[i].w500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</p></div>
                                            <div style={{width: "50px"}}><p>{airSData[i].w600.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</p></div>
                                            <div style={{width: "50px"}}><p>{airSData[i].w700.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</p></div>
                                            <div style={{width: "50px"}}><p>{airSData[i].w800.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</p></div>
                                            <div style={{width: "50px"}}><p>{airSData[i].w900.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</p></div>
                                            <div style={{width: "50px"}}><p>{airSData[i].w1000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</p></div>
                                            <div style={{width: "50px"}}><p>{airSData[i].w1100.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</p></div>
                                            <div style={{width: "50px"}}><p>{airSData[i].w1200.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</p></div>
                                            <div style={{width: "50px"}}><p>{airSData[i].w1300.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</p></div>
                                            <div style={{width: "50px"}}><p>{airSData[i].w1400.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</p></div>
                                            <div style={{width: "50px"}}><p>{airSData[i].w1500.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</p></div>
                                            <div style={{width: "50px"}}><p>{airSData[i].w1600.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</p></div>
                                            <div style={{width: "50px"}}><p>{airSData[i].w1700.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</p></div>
                                            <div style={{width: "50px"}}><p>{airSData[i].w1800.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</p></div>
                                            <div style={{width: "50px"}}><p>{airSData[i].w1900.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</p></div>
                                            <div style={{width: "50px"}}><p>{airSData[i].w2000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</p></div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="font-t-cont font-s-14">
                                {/*<p className="font-b">Z1[1지역] - CN:중국, HK:홍콩, JP:일본, TW:타이완</p>*/}
                                {/*<p className="font-b">Z2[2지역] - BD:방글라데시, ID:인도네시아, MY:말레이시아, PH:필리핀, SG:싱가포르, VN:베트남</p>*/}
                                {/*<p className="font-b">Z3[3지역] - AU:호주, CA:캐나다, DE:독일, ES:스페인, FR:프랑스, GB:영국, IE:아일랜드, NL:네덜란드, NZ:뉴질랜드, PL:폴란드, US:미국</p>*/}
                                {/*<p className="font-b">Z4[4지역] - PE:페루</p>*/}
                            </div>
                        </Tab>
                        <Tab eventKey="mam-tab-sub-dome" title="&nbsp;&nbsp;&nbsp;&nbsp;국내배송&nbsp;&nbsp;&nbsp;&nbsp;">
                            <div className="admin-event-wrap" style={{marginBottom: "-1px"}}>
                                <div className="admin-btn-wrap-l">
                                    <BsSquareFill className="admin-tb-header-notice"/>
                                    <a>(단위:kg/&#8361;)</a>
                                </div>
                            </div>
                            <div style={{width: "100%", maxWidth: "100%",overflowX: "auto", display: "flex", flexDirection: "row"}}>
                                <div className="div-tb m-b-10">
                                    <div className="div-tb-head ht-60">
                                        <div className="wd-40"><p>번호</p></div>
                                        <div className="wd-80"><p>부피</p></div>
                                        <div className="wd-80"><p>~3kg</p></div>
                                        <div className="wd-80"><p>~5kg</p></div>
                                        <div className="wd-80"><p>~10kg</p></div>
                                        <div className="wd-80"><p>~20kg</p></div>
                                        <div className="wd-80"><p>25kg~</p></div>
                                        <div className="wd-80"><p></p></div>
                                    </div>
                                    {domeData.map((cData, i) => (
                                        <div key={cData.seqNum} className="div-tb-body ht-70">
                                            <div className="wd-40"><p>{domeData[i].seqNum}</p></div>
                                            <div className="wd-80">
                                                <p className="font-b">{domeData[i].volumes === "V08" ? "~80cm"
                                                    : domeData[i].volumes === "V10" ? "~100cm"
                                                        : domeData[i].volumes === "V12" ? "~120cm"
                                                            : domeData[i].volumes === "V14" ? "~140cm"
                                                                : domeData[i].volumes === "V16" ? "~160cm"
                                                                    : domeData[i].volumes === "V20" ? "~200cm": null}</p>
                                            </div>
                                            <div className="wd-80">
                                                {editMode === cData.seqNum ? (
                                                    <input className="admin-input-line m-0-a font-b font-c-cancel wd-100pc ht-30 text-center font-s-13 com-input"
                                                           maxLength="5" type="text" value={editedWeights.w3000} onChange={(e) => handleFeeChange(e, 'w3000')}/>
                                                ) : (
                                                    <p>{cData.w3000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</p>
                                                )}
                                            </div>
                                            <div className="wd-80">
                                                {editMode === cData.seqNum ? (
                                                    <input className="admin-input-line m-0-a font-b font-c-cancel wd-100pc ht-30 text-center font-s-13 com-input"
                                                           maxLength="5" type="text" value={editedWeights.w5000} onChange={(e) => handleFeeChange(e, 'w5000')}/>
                                                ) : (
                                                    <p>{cData.w5000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</p>
                                                )}
                                            </div>
                                            <div className="wd-80">
                                                {editMode === cData.seqNum ? (
                                                    <input className="admin-input-line m-0-a font-b font-c-cancel wd-100pc ht-30 text-center font-s-13 com-input"
                                                           maxLength="5" type="text" value={editedWeights.w10000} onChange={(e) => handleFeeChange(e, 'w10000')}/>
                                                ) : (
                                                    <p>{cData.w10000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</p>
                                                )}
                                            </div>
                                            <div className="wd-80">
                                                {editMode === cData.seqNum ? (
                                                    <input className="admin-input-line m-0-a font-b font-c-cancel wd-100pc ht-30 text-center font-s-13 com-input"
                                                           maxLength="7" type="text" value={editedWeights.w20000} onChange={(e) => handleFeeChange(e, 'w20000')}/>
                                                ) : (
                                                    <p>{cData.w20000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</p>
                                                )}
                                            </div>
                                            <div className="wd-80">
                                                {editMode === cData.seqNum ? (
                                                    <input className="admin-input-line m-0-a font-b font-c-cancel wd-100pc ht-30 text-center font-s-13 com-input"
                                                           maxLength="7" type="text" value={editedWeights.w25000} onChange={(e) => handleFeeChange(e, 'w25000')}/>
                                                ) : (
                                                    <p>{cData.w25000.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")}</p>
                                                )}
                                            </div>
                                            <div className="wd-80">
                                                {editMode === cData.seqNum ? (
                                                    <button className="admin-btn-A ht-30 font-s-13 btn-click-event" onClick={() => handleSaveClick(cData.seqNum)}>저장</button>
                                                ) : (
                                                    <button className="admin-btn-B ht-30 font-s-13 btn-click-event" onClick={() => handleEditClick(cData)}>수정</button>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </Tab>
                    </Tabs>
                </div>
            </div>
            {alertShow === true ? <MsgSelectModal alertShow={alertShow} eventHandle1={modalCancel} eventHandle2={saveExcelFileFEDEX} msgData1={msgConfirmData1} msgData2={msgConfirmData2}/> : null}
            {alertShow2 === true ? <MsgSelectModal alertShow={alertShow2} eventHandle1={modalCancel2} eventHandle2={saveExcelFileFEDEXE} msgData1={msgConfirmData1} msgData2={msgConfirmData2}/> : null}
            {alertShow3 === true ? <MsgSelectModal alertShow={alertShow3} eventHandle1={modalCancel3} eventHandle2={saveExcelFileEMS} msgData1={msgConfirmData1} msgData2={msgConfirmData2}/> : null}
            {alertShow4 === true ? <MsgSelectModal alertShow={alertShow4} eventHandle1={modalCancel4} eventHandle2={saveExcelFileEMSP} msgData1={msgConfirmData1} msgData2={msgConfirmData2}/> : null}
            {alertShow5 === true ? <MsgSelectModal alertShow={alertShow5} eventHandle1={modalCancel5} eventHandle2={saveExcelFileUPS} msgData1={msgConfirmData1} msgData2={msgConfirmData2}/> : null}
            {alertShow6 === true ? <MsgSelectModal alertShow={alertShow6} eventHandle1={modalCancel6} eventHandle2={saveExcelFileUPSE} msgData1={msgConfirmData1} msgData2={msgConfirmData2}/> : null}
            {alertShow7 === true ? <MsgSelectModal alertShow={alertShow7} eventHandle1={modalCancel7} eventHandle2={saveExcelFileKP} msgData1={msgConfirmData1} msgData2={msgConfirmData2}/> : null}
            {alertShow8 === true ? <MsgSelectModal alertShow={alertShow8} eventHandle1={modalCancel8} eventHandle2={saveExcelFileAS} msgData1={msgConfirmData1} msgData2={msgConfirmData2}/> : null}
            {alertShow9 === true ? <MsgSelectModal alertShow={alertShow9} eventHandle1={modalCancel9} eventHandle2={saveExcelFileSHIP} msgData1={msgConfirmData1} msgData2={msgConfirmData2}/> : null}
            {/*{alertShow9 === true ? <MsgSelectModal alertShow={alertShow9} eventHandle1={modalCancel9} eventHandle2={saveExcelFileSHIP} msgData1={msgConfirmData1} msgData2={msgConfirmData2}/> : null}*/}
        </div>
    );
}

export default AdminCurrencyRatePg
